module.exports = {
    language: {
        name: 'English'
    },
    // 头部
    header: {
        menu: 'MENU',
        login: '登录',
        register: '注册',
        placeholder: '请输入内容',
        menuwe1: '我们是谁',
        menuwe2: '我们的优势',
        menuwe3: '我们的义务',
        mbleft1: '受监管的',
        mbleft2: '绿色数字资产交易所',
        leftMenus1: '受监管的',
        leftMenus2: '绿色数字资产交易所',
        leftMenus: '受监管的 绿色数字资产 交易所',
        leftMenu: [{
                name: '受监管的',
                id: 1
            },
            {
                name: '绿色数字资产',
                id: 2
            },
            {
                name: '交易所',
                id: 3
            },
        ],
        menu: [{
                name: '产品',
                menuBool: false,
                menuContant: [{
                        tatil: 'BTC/ETH',
                        cont: [{
                            name: '概览',
                            id: '1'
                        }, ]
                    },
                    {
                        tatil: '碳中和通证(CNT)',
                        cont: [{
                            name: '概览',
                            id: '9'
                        }, {
                            name: 'CNT 资产列表',
                            id: '8'
                        }, ]
                    },
                    {
                        tatil: '非同质化通证(NFT)',
                        cont: [{
                                name: '概览',
                                id: '7'
                            },


                        ]
                    },
                    {
                        tatil: '股票支持通证(EBT)',
                        cont: [{
                            name: '概览',
                            id: '6'
                        }]
                    },
                    {
                        tatil: '资产支持通证(ABT)',
                        cont: [{
                                name: '艺术品支持通证(ABT-A)',
                                id: '2'
                            },
                            {
                                name: '钻石支持通证(ABT-D)',
                                id: '3'
                            },
                            {
                                name: '基础设施支持通证(ABT-I)',
                                id: '4'
                            },
                            {
                                name: '房地产支持通证(ABT-R)',
                                id: '5'
                            },
                            // {
                            //     name: '股票支持通证(ABT-S)',
                            //     id: '6'
                            // },
                        ]
                    },


                ],
                id: 1
            },
            {
                name: '服务',
                menuBool: false,
                menuContant: [{
                        tatil: '服务',
                        cont: [{
                            name: '概览',
                            id: '1'
                        }, ]
                    },
                    {
                        tatil: '交易服务',
                        cont: [{
                                name: '技术架构',
                                id: '2'
                            },
                            {
                                name: 'BTC/ETH交易',
                                id: '3'
                            },
                            {
                                name: '资产支持的通证交易',
                                id: '4'
                            },
                        ]
                    },
                    {
                        tatil: '结算服务',
                        cont: [{
                                name: '技术架构',
                                id: '5'
                            },
                            {
                                name: '结算 —— BTC/ETH',
                                id: '6'
                            },
                            {
                                name: '结算——资产支持通证',
                                id: '7'
                            },
                            {
                                name: '结算 – CNT',
                                id: '10'
                            },
                        ]
                    },
                    {
                        tatil: '托管服务',
                        cont: [{
                                name: '托管服务 —— BTC/ETH',
                                id: '8'
                            },
                            {
                                name: '托管服务-资产支持通证',
                                id: '9'
                            },
                            {
                                name: '托管服务 – CNT',
                                id: '11'
                            }
                        ]
                    },

                ],
                id: 2
            },
            {
                name: '市场',
                menuBool: false,
                menuContant: [{
                        tatil: 'NFT - 市场',
                        cont: [{
                            name: 'NFT 市场',
                            id: '7'
                        }, ]
                    },
                    {
                        tatil: '发行人 - 在MVGX上市',
                        cont: [{
                                name: '在MVGX上市的好处',
                                id: '1'
                            },
                            {
                                name: 'MVGX上市程序',
                                id: '2'
                            },
                            {
                                name: 'MVGX上市要求',
                                id: '3'
                            },
                        ]

                    },
                    {
                        tatil: '投资者 - 在MVGX进行交易',
                        cont: [{
                                name: '投资者 - 如何在MVGX进行交易',
                                id: '4'
                            },
                            {
                                name: '在MVGX交易的好处',
                                id: '5'
                            },
                            {
                                name: 'KYC 和注册流程',
                                id: '6'
                            },
                        ]
                    },

                ],
                id: 3
            },
            {
                name: '监管与合规',
                menuBool: false,
                menuContant: [{
                        tatil: '我们如何监管',
                        cont: [{
                            name: '概览',
                            id: '1'
                        }, ]
                    },

                ],
                id: 4
            },
            {
                name: '数据报告',
                menuBool: false,
                menuContant: [{
                        tatil: '报告',
                        cont: [
                            // {
                            //     tatil: '',
                            //     name: '碳中和和绿色影响报告 2020',
                            //     id: '1'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '比特币碳足迹追踪计算方法',
                            //     id: '2'
                            // },
                            // {
                            //     name: '比特币碳足迹计算器',
                            //     id: '3'
                            // },
                            // {
                            //     name: '中国碳市场周报 2021年8月16日',
                            //     id: '5'
                            // },
                            // {
                            //     name: '中国碳市场周报',
                            //     id: '5'
                            // },
                        ]
                    },
                    {
                        tatil: '中国碳市场周报',
                        cont: [
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月27日',
                            //     id: '11'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月20日',
                            //     id: '10'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月13日',
                            //     id: '9'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月06日',
                            //     id: '8'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月30日',
                            //     id: '7'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月23日',
                            //     id: '6'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月16日',
                            //     id: '5'
                            // },
                        ]
                    },
                    // {
                    //     tatil: '市场统计',
                    //     cont: []
                    // },

                ],
                menuContants: [{
                        tatil: '报告',
                        cont: [
                            // {
                            //     name: '碳中和和绿色影响报告 2020',
                            //     id: '1'
                            // },
                            // {
                            //     name: '比特币碳足迹追踪计算方法',
                            //     id: '2'
                            // },
                            // {
                            //     name: '比特币碳足迹计算器',
                            //     id: '3'
                            // },
                            // {
                            //     name: '中国碳市场周报 2021年8月16日',
                            //     id: '5'
                            // },
                            // {
                            //     name: '中国碳市场周报',
                            //     id: '5'
                            // },
                        ]
                    },
                    {
                        tatil: '中国碳市场周报',
                        cont: [
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月27日',
                            //     id: '11'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月20日',
                            //     id: '10'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月13日',
                            //     id: '9'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年9月06日',
                            //     id: '8'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月30日',
                            //     id: '7'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月23日',
                            //     id: '6'
                            // },
                            // {
                            //     tatil: '',
                            //     name: '中国碳市场周报 - 2021年8月16日',
                            //     id: '5'
                            // },
                        ]
                    },
                    // {
                    //     tatil: '市场统计',
                    //     cont: []
                    // },

                ],
                id: 5
            },
            {
                name: '关于MVGX',
                menuBool: false,
                menuContant: [{
                        tatil: '关于MVGX',
                        cont: [{
                                tatil: '',
                                name: '我们是谁',
                                id: '1'
                            },
                            {
                                tatil: '',
                                name: '愿景与使命',
                                id: '2'
                            },
                            {
                                tatil: '',
                                name: '我们的优势',
                                id: '3'
                            },
                            {
                                tatil: '',
                                name: '我们的团队',
                                id: '4'
                            },
                            {
                                tatil: '',
                                name: 'MVGX ESG 义务',
                                id: '5'
                            },
                            {
                                tatil: '',
                                name: '隐私和Cookie 政策',
                                id: '6'
                            },
                            {
                                tatil: '',
                                name: '法律免责声明',
                                id: '7'
                            },
                        ]
                    },
                    {
                        tatil: '加入我们',
                        cont: [
                            // {
                            //     tatil: '',
                            //     name: 'Assistant Director, Infrastructure Services (Cloud Engineer)',
                            //     id: '9'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Assistant Director, IT Security',
                            //     id: '11'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Vice President, Institutional Sales',
                            //     id: '15'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Institutional Sales Associate',
                            //     id: '16'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Customer Service Specialist',
                            //     id: '19'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Customer Service Manager',
                            //     id: '20'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Deputy Director / Director, IT Security',
                            //     id: '21'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Executive Assistant',
                            //     id: '23'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Senior HR Executive / HR Executive',
                            //     id: '24'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Talent Acquisition Executive',
                            //     id: '25'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Finance Executive',
                            //     id: '26'
                            // },
                            // {
                            //     tatil: '',
                            //     name: 'Finance Manager',
                            //     id: '27'
                            // },
                        ]
                    },
                ],
                menuContants: [{
                        tatil: '',
                        cont: [{
                                name: '我们是谁',
                                id: '1'
                            },
                            {
                                name: '愿景与使命',
                                id: '2'
                            },
                        ]
                    },
                    {
                        tatil: '',
                        cont: [{
                                name: '我们的优势',
                                id: '3'
                            },
                            {
                                name: '我们的团队',
                                id: '4'
                            },
                            {
                                name: '加入我们',
                                id: '9'
                            },
                        ]
                    },
                    {
                        tatil: '',
                        cont: [{
                                name: 'MVGX ESG 义务',
                                id: '5'
                            },
                            {
                                name: '隐私和Cookie 政策',
                                id: '6'
                            },
                            {
                                name: '法律免责声明',
                                id: '7'
                            },
                        ]
                    },

                ],
                id: 6
            },
        ],
    },

    home: {
        imglist: [{
                img: require('@/assets/img/banner1.png'),
                title: '受监管的数字资产交易所',
                cont: '由全球领先金融中心——新加坡金融管理局发牌和监管的数字资产交易所，持有CMS资本市场服务牌照（托管服务和资本市场产品一级交易服务）、RMO市场运营商牌照以及PSA支付服务牌照（豁免期）。',
            },
            {
                img: require('@/assets/img/banner2.png'),
                title: '基于纳斯达克引擎的交易平台',
                cont: "MVGX采用纳斯达克的交易引擎、全球监控引擎及风控引擎，结合MVGX自主研发的专用数字资产评估和管理平台，共同打造高效透明的数字资产市场。",
            },
            {
                img: require('@/assets/img/banner3.png'),
                title: '打造通证经济基础设施',
                cont: 'MVGX为通证经济提供一条龙基础服务，包括通证发行、交易、结算和托管，为传统金融机构的业务增值，并为实体经济提供创新融资渠道。',
            },
            {
                img: require('@/assets/img/banner4.png'),
                title: '助力全球碳中和',
                cont: 'MVGX 是全球首个实现对发行人和交易者资产都进行碳披露的交易所，建立了首个交易所碳中和区块链，奖励与MVGX 产品相关的所有为可持续发展所做出的贡献。',
            },
            {
                img: require('@/assets/img/banners5.jpg'),
                title: 'BTC/ETH-法定货币直接交易',
                cont: 'MVGX提供以美元、欧元和新加坡元计价的法定货币与BTC和ETH直接交易，无需通过stablecoins进行转换，从而将投资者的市场和信用风险降至最低。',
            },
        ],
        imglist1: [{
                img: require('@/assets/img/banner1.png'),
                title: '受监管的数字资产交易所',
                cont: '由全球领先金融中心——新加坡金融管理局发牌和监管的数字资产交易所，持有CMS资本市场服务牌照（托管服务和资本市场产品一级交易服务）、RMO市场运营商牌照（原则性批复）以及PSA支付服务牌照（豁免期）。',
            },
            {
                img: require('@/assets/img/banner2.png'),
                title: '基于纳斯达克引擎的交易平台',
                cont: "MVGX采用纳斯达克的交易引擎、全球监控引擎及风控引擎，结合MVGX自主研发的专用数字资产评估和管理平台，共同打造高效透明的数字资产市场。",
            },
            {
                img: require('@/assets/img/banner3.png'),
                title: '打造通证经济基础设施',
                cont: 'MVGX为通证经济提供一条龙基础服务，包括通证发行、交易、结算和托管，为传统金融机构的业务增值，并为实体经济提供创新融资渠道。',
            },
            {
                img: require('@/assets/img/banner4.png'),
                title: '助力全球碳中和',
                cont: 'MVGX 是全球首个实现对发行人和交易者资产都进行碳披露的交易所，建立了首个交易所碳中和区块链，奖励与MVGX 产品相关的所有为可持续发展所做出的贡献。',
            },
            {
                img: require('@/assets/img/banner1_5.jpg'),
                title: 'BTC/ETH-法定货币直接交易能力',
                cont: 'MVGX提供以美元、欧元和新加坡元计价的法定货币进行的直接BTC和ETH交易，无需通过stablecoins进行交易，从而将投资者的市场和信用风险降至最低。',
            },
        ],
        newsimg: require('@/assets/img/pic.png'),
        news: '新闻',
        cpnews: '公司新闻',
        more: '更多 >',
        consociation: '合作伙伴',
        home: '首页',
        newlist: [
            // {
            //     title: 'Poloniex同意支付1000万美元与美国证券交易委员会和解，用于运营未注册的交易所',
            //     date: '2021-08-09',
            //     id: '20'
            // },
            {
                title: '英国银行业巨头NatWest禁止向币安付款',
                date: '2021-07-22',
                id: '19'
            },
            {
                title: '阿拉巴马州向BlockFi发出禁止销售加密货币禁令',
                date: '2021-07-22',
                id: '18'
            },
            {
                title: '近半数高盛的家族办公室客户有意持仓纳入数字货币',
                date: '2021-07-22',
                id: '17'
            },
            {
                title: '美国新泽西州总检察长计划向BlockFi发出停止令',
                date: '2021-07-20',
                id: '16'
            },
            {
                title: '欧盟将设立新机构以打击加密货币洗钱活动',
                date: '2021-07-10',
                id: '15'
            },
            {
                title: 'Bitcoin.org遭到大规模DDoS攻击，攻击者索要比特币赎金',
                date: '2021-07-06',
                id: '14'
            },
            // {
            //     title: '英国巴克莱银行禁止其用户向币安进行单边付款',
            //     date: '2021-07-05',
            //     id: '13'
            // },
            // {
            //     title: '加密货币交易所币安在泰国和开曼群岛面临更加严格的监管审查',
            //     date: '2021-07-02',
            //     id: '12'
            // },
            // {
            //     title: '新加坡金融管理局：已意识到需对币安采取行动，将酌情跟进其它国家监管机构的行动',
            //     date: '2021-07-01',
            //     id: '11'
            // },
            // {
            //     title: '美国对加密货币交易所的投诉攀升，其中针对 Coinbase投诉最多',
            //     date: '2021-06-30',
            //     id: '10'
            // },
            // {
            //     title: '越来越多加密公司正在放弃在英国金融管理局注册申请',
            //     date: '2021-06-29',
            //     id: '9'
            // },
            // {
            //     title: '英国金融行为监管局禁止币安在该国的受监管活动',
            //     date: '2021-06-27',
            //     id: '8'
            // },
            // {
            //     title: '出于对币安和 Kraken钱包安全的顾虑，TSB将禁止购买加密货币',
            //     date: '2021-06-20',
            //     id: '7'
            // },
            // {
            //     title: 'CFTC：DeFi 衍生品可能被定为为违法',
            //     date: '2021-06-09',
            //     id: '1'
            // },
            // {
            //     title: '英国的反洗钱规则可能会迫使多达 50 家加密公司停止交易',
            //     date: '2021-06-04',
            //     id: '2'
            // },
            // {
            //     title: '韩国计划从 2022 年开始对海外加密资产征税',
            //     date: '2021-06-04',
            //     id: '3'
            // },
            // {
            //     title: 'Gensler 称 DeFi 为投资者和监管机构“增强了挑战”',
            //     date: '2021-05-21',
            //     id: '4'
            // },
            // {
            //     title: 'Gensler 表示 SEC 应该“准备好处理涉及加密的案件”',
            //     date: '2021-05-21',
            //     id: '5'
            // },
            // {
            //     title: '美国财政部：价值 10,000 美元或以上的转账需向 IRS 报告',
            //     date: '2021-05-20',
            //     id: '6'
            // },
        ],
        cpnewlist: [
            // {
            //     img: require('@/assets/img/cpnews38.jpg'),
            //     title: 'CTX to Debut Chinese Carbon Credit Backed Digital Tokens',
            //     date: '2021-07-26',
            //     nyuan: '报道自: ',
            //     yuan: 'cryptoknowmics',
            //     url: 'https://www.cryptoknowmics.com/news/ctx-to-debut-chinese-carbon-credit-backed-digital-tokens/ ',
            //     id: '12'
            // },
            // {
            //     img: require('@/assets/img/cpnews36.png'),
            //     title: 'China’s Carbon Credit-Backed Digital Tokens to Launch August',
            //     date: '2021-07-25',
            //     nyuan: '报道自: ',
            //     yuan: '8 BTC',
            //     url: 'https://news.8btc.com/chinas-carbon-credit-backed-digital-tokens-to-launch-august',
            //     id: '11'
            // },
            // {
            //     img: require('@/assets/img/cpnews37.png'),
            //     title: 'Singapore-Based Cyberdyne Exchange to Debut China Carbon Credit-Backed Tokens',
            //     date: '2021-07-23',
            //     nyuan: '报道自: ',
            //     yuan: 'Caixin Global',
            //     url: 'https://www.caixinglobal.com/2021-07-23/singapore-based-cyberdyne-exchange-to-debut-china-carbon-credit-backed-tokens-101744675.html',
            //     id: '10'
            // },
            // {
            //     img: require('@/assets/img/cpnewss36.png'),
            //     title: 'CTX to Debut Cross-Border Trading of Tokens Backed by China’s Carbon Credits',
            //     date: '2021-07-23',
            //     nyuan: '报道自: ',
            //     yuan: 'AsiaBizToday',
            //     url: 'https://www.asiabiztoday.com/2021/07/23/ctx-debut-cross-border-trading-of-tokens-china-carbon-credits/',
            //     id: '9'
            // },
            {
                img: require('@/assets/img/cpnewss35.png'),
                title: '中国太平与MVGX签署战略合作协议，共同致力发展绿色资产',
                date: '2021-07-06',
                nyuan: '报道自: ',
                yuan: 'MVGX',
                url: '',
                id: '8'
            },
            {
                img: require('@/assets/img/new34.png'),
                title: 'MVGX Chairman 白波：如何应对日趋激烈的碳交易市场竞争',
                date: '2021-06-21',
                nyuan: '报道自: ',
                yuan: 'The Edge Singapore',
                url: 'https://www.pressreader.com/singapore/the-edge-singapore/20210621/281526524015445',
                id: '1'
            },
            {
                img: require('@/assets/img/new33.png'),
                title: '全球碳交易市场竞争日渐加剧',
                date: '2021-06-18',
                nyuan: '报道自: ',
                yuan: 'The Edge Singapore',
                url: 'https://www.theedgesingapore.com/issues/capital-markets/competition-carbon-exchanges-heats',
                id: '2'
            },
            {
                img: require('@/assets/img/news5.png'),
                title: 'MVGX 宣布劳埃德银行（新加坡）前风控合规副行长黄国强（Kelvin Wong） 加入MVGX担任首席合规官',
                date: '2021-06-15',
                nyuan: '报道自: ',
                yuan: 'MVGX',
                url: '',
                id: '4'
            },
            {
                img: require('@/assets/img/news1.png'),
                title: '新加坡金融管理局批复新的绿色资产交易的数字资产交易所',
                date: '2021-05-19',
                nyuan: '报道自: ',
                yuan: 'THE BUSINESS TIMES',
                url: 'https://www.businesstimes.com.sg/banking-finance',
                id: '5'
            },
            // {
            //     img: require('@/assets/img/cpnews-logo.png'),
            //     title: '洪英莉女士作为北亚区唯一代表  荣获2019纳斯达克全球科技女性大奖',
            //     date: '2019-05-20',
            //     nyuan: '报道自: ',
            //     yuan: 'CTX',
            //     url: '',
            //     id: '3'
            // },
            // {
            //     img: require('@/assets/img/news2.png'),
            //     title: 'CTX将推出首个由纳斯达克技术支持的、受监管的资产支持代币交易所，专注于绿色金融',
            //     date: '2021-05-19',
            //     nyuan: '报道自:',
            //     yuan: 'Yahoo/Finance',
            //     url: 'https://finance.yahoo.com/news/ctx-launch-first-regulated-exchange-000000199.html?guccounter=1',
            //     id: '4'
            // },
            // {
            //     img: require('@/assets/img/news3.png'),
            //     title: '新加坡将建立全球首家受监管的资产支持代币数字交易所',
            //     date: '2021-05-19',
            //     nyuan: '报道自:',
            //     yuan: 'The Wall Street Journal',
            //     url: 'https://cn.wsj.com/articles/%E6%96%B0%E5%8A%A0%E5%9D%A1ctx%E7%AD%B9%E5%A4%87%E6%8E%A8%E5%87%BA%E8%B5%84%E4%BA%A7%E6%94%AF%E6%8C%81%E4%BB%A3%E5%B8%81%E4%BA%A4%E6%98%93%E6%89%80-11621413314',
            //     id: '5'
            // },
        ],
        cpnewlists: [
            // {
            //     img: require('@/assets/img/cpnews38.jpg'),
            //     title: 'CTX to Debut Chinese Carbon Credit Backed Digital Tokens',
            //     date: '2021-07-26',
            //     nyuan: '报道自: ',
            //     yuan: 'cryptoknowmics',
            //     url: 'https://www.cryptoknowmics.com/news/ctx-to-debut-chinese-carbon-credit-backed-digital-tokens/ ',
            //     id: '12'
            // },
            // {
            //     img: require('@/assets/img/cpnews36.png'),
            //     title: 'China’s Carbon Credit-Backed Digital Tokens to Launch August',
            //     date: '2021-07-25',
            //     nyuan: '报道自: ',
            //     yuan: '8 BTC',
            //     url: 'https://news.8btc.com/chinas-carbon-credit-backed-digital-tokens-to-launch-august',
            //     id: '11'
            // },
            // {
            //     img: require('@/assets/img/cpnews37.png'),
            //     title: 'Singapore-Based Cyberdyne Exchange to Debut China Carbon Credit-Backed Tokens',
            //     date: '2021-07-23',
            //     nyuan: '报道自: ',
            //     yuan: 'Caixin Global',
            //     url: 'https://www.caixinglobal.com/2021-07-23/singapore-based-cyberdyne-exchange-to-debut-china-carbon-credit-backed-tokens-101744675.html',
            //     id: '10'
            // },
            // {
            //     img: require('@/assets/img/cpnewss36.png'),
            //     title: 'CTX to Debut Cross-Border Trading of Tokens Backed by China’s Carbon Credits',
            //     date: '2021-07-23',
            //     nyuan: '报道自: ',
            //     yuan: 'AsiaBizToday',
            //     url: 'https://www.asiabiztoday.com/2021/07/23/ctx-debut-cross-border-trading-of-tokens-china-carbon-credits/',
            //     id: '9'
            // },
            {
                img: require('@/assets/img/cpnewss35.png'),
                title: '中国太平与MVGXMVGX签署战略合作协议，共同致力发展绿色资产',
                date: '2021-07-06',
                nyuan: '报道自: ',
                yuan: 'MVGX',
                url: '',
                id: '8'
            },
            {
                img: require('@/assets/img/new34.png'),
                title: 'MVGX Chairman 白波：如何应对日趋激烈的碳交易市场竞争',
                date: '2021-06-21',
                nyuan: '报道自: ',
                yuan: 'The Edge Singapore',
                url: 'https://www.pressreader.com/singapore/the-edge-singapore/20210621/281526524015445',
                id: '1'
            },
            {
                img: require('@/assets/img/new33.png'),
                title: '全球碳交易市场竞争日渐加剧',
                date: '2021-06-18',
                nyuan: '报道自: ',
                yuan: 'The Edge Singapore',
                url: 'https://www.theedgesingapore.com/issues/capital-markets/competition-carbon-exchanges-heats',
                id: '2'
            },
            {
                img: require('@/assets/img/news5.png'),
                title: 'MVGX 宣布劳埃德银行（新加坡）前风控合规副行长黄国强（Kelvin Wong） 加入MVGX担任首席合规官',
                date: '2021-06-15',
                nyuan: '报道自: ',
                yuan: 'MVGX',
                url: '',
                id: '4'
            },
            {
                img: require('@/assets/img/news1.png'),
                title: '新加坡金融管理局批复新的绿色资产交易的数字资产交易所',
                date: '2021-05-19',
                nyuan: '报道自: ',
                yuan: 'THE BUSINESS TIMES',
                url: 'https://www.businesstimes.com.sg/banking-finance',
                id: '5'
            },
            {
                img: require('@/assets/img/news2.png'),
                title: 'MVGX将推出首个由纳斯达克技术支持的、受监管的资产支持代币交易所，专注于绿色金融',
                date: '2021-05-19',
                nyuan: '报道自: ',
                yuan: 'Yahoo/Finance',
                url: 'https://finance.yahoo.com/news/ctx-launch-first-regulated-exchange-000000199.html?guccounter=1',
                id: '6'
            },
            {
                img: require('@/assets/img/news3.png'),
                title: '新加坡将建立全球首家受监管的资产支持代币数字交易所',
                date: '2021-05-19',
                nyuan: '报道自: ',
                yuan: 'The Wall Street Journal',
                url: 'https://cn.wsj.com/articles/%E6%96%B0%E5%8A%A0%E5%9D%A1ctx%E7%AD%B9%E5%A4%87%E6%8E%A8%E5%87%BA%E8%B5%84%E4%BA%A7%E6%94%AF%E6%8C%81%E4%BB%A3%E5%B8%81%E4%BA%A4%E6%98%93%E6%89%80-11621413314',
                id: '7'
            },
            {
                img: require('@/assets/img/cpnews-logo.png'),
                title: '洪英莉女士作为北亚区唯一代表  荣获2019纳斯达克全球科技女性大奖',
                date: '2019-05-20',
                nyuan: '报道自: ',
                yuan: 'MVGX',
                url: '',
                id: '3'
            },
        ],
        footimg: [{
                img: require('@/assets/img/prt1.png')
            },
            // {
            //     img: require('@/assets/img/prt2.png')
            // },
            {
                img: require('@/assets/img/prt7.png')
            },
            {
                img: require('@/assets/img/prt9.png')
            },
            {
                img: require('@/assets/img/trend.png')
            },
            {
                img: require('@/assets/img/prt10.jpg')
            },
        ],
    },

    //新闻
    new: {
        title: '新闻中心',
        n1: {
            title: "CFTC：DeFi 衍生品可能被定为为违法",
            date: '9 June 2021',
            c1: 'Commodity Futures Trading Commission (CFTC) Commissioner Dan Berkovitz said in a speech to the Asset Management Derivatives Forum that DeFi derivatives may not be legal under the Commodity Exchange Act, a U.S. law that governs such products and requires them to trade only on regulated designated contract markets.',
            c2: '“DeFi markets, platforms, or websites are not registered as DCMs or SEFs [swap execution facilities]. The CEA does not contain any exception from registration for digital currencies, blockchains, or ‘smart contracts’”, he said.',
            c3: 'Berkovitz also expressed concerns that DeFi markets trading derivatives may not share the same protections that their centralized counterparts offer. ',
            c4: '“In a pure ‘peer-to-peer’ DeFi system, none of these benefits or protections exist. There is no intermediary to monitor markets for fraud and manipulation, prevent money laundering, safeguard deposited funds, ensure counterparty performance or make customers whole when processes fail.”',
        },
        n2: {
            title: "英国的反洗钱规则可能会迫使多达 50 家加密公司停止交易",
            date: '4 June 2021',
            c1: 'The U.K. financial watchdog said it is concerned that a "significantly high number" of crypto-asset businesses are not meeting its anti-money laundering standards.',
            c2: 'The Financial Conduct Authority had previously extended the deadline for crypto businesses to register under its Temporary Registrations Regime (TRR) from July 9 to March 31 of next year. The TRR was established in December 2020 to allow businesses that had registered with FCA to continue trading.',
        },
        n3: {
            title: '韩国计划从 2022 年开始对海外加密资产征税',
            date: '4 June 2021',
            c1: 'South Korea residents will be obliged to pay tax on crypto assets held in overseas exchanges starting next year. The new rule applies from Jan. 1, 2022, with tax reporting required from June 2023.',
            c2: "Tax will be required when total balances held with foreign virtual-asset businesses exceed 500 million won (US$450,000) at the end of each month, according to an announcement by the country's National Tax Service.",
            c3: '',
            c4: '',
            c5: '',
            c6: '',
        },
        n4: {
            title: 'Gensler 称 DeFi 为投资者和监管机构“增强了挑战”',
            date: '21 May 2021',
            c1: 'SEC chief Gary Gensler said Wednesday crypto lending platforms and so-called decentralized finance (‘DeFi’) platforms raise a number of challenges for investors and the SEC staff trying to protect them.',
            c2: "“Tokens currently on the market that are securities may be offered, sold, and traded in non-compliance with the federal securities laws. Furthermore, none of the exchanges trading crypto tokens has registered yet as an exchange with the SEC. Altogether, this has led to substantially less investor protection than in our traditional securities markets, and to correspondingly greater opportunities for fraud and manipulation,” he said.",
            c3: '',
            c4: '',
            c5: '',
            c6: '',
        },
        n5: {
            title: 'Gensler 表示 SEC 应该“准备好处理涉及加密的案件”',
            date: '21 May 2021',
            c1: 'SEC chief Gary Gensler said regulators should be ready to pursue deceptive private funds, accounting fraud, insider trading and a bevy of other potential regulatory pitfalls rippling throughout the capital markets.',
            c2: "“As we continue to stay abreast of those developments, the SEC and FINRA should be ready to bring cases involving issues such as crypto, cyber and fintech,” Gensler told FINRA conference attendees on Thursday. The SEC chair highlighted investor protection as he previewed SEC’s cryptocurrency enforcement efforts.",
            c3: '',
            c4: '',
            c5: '',
            c6: '',
        },
        n6: {
            title: '美国财政部：价值 10,000 美元或以上的转账需向 IRS 报告',
            date: '20 May 2021',
            c1: 'The Treasury Department on Thursday announced that it is taking steps to crack down on cryptocurrency markets and transactions, and said it will require any transfer worth $10,000 or more to be reported to the Internal Revenue Service.',
            c2: "Within the context of the new financial account reporting regime, cryptocurrencies and cryptoasset exchange accounts and payment service accounts that accept cryptocurrencies would be covered. Further, as with cash transactions, businesses that receive cryptoassets with a fair market value of more than $10,000 would also be reported on,” the Treasury Department said in a release.",
            c3: '',
            c4: '',
            c5: '',
            c6: '',
        },
        n7: {
            title: "出于对币安和 Kraken钱包安全的顾虑，TSB将禁止购买加密货币",
            date: '20 June 2021',
            c1: 'TSB plans to block its 5.4 million customers from sending money to trading platforms such as Binance and Kraken due to concerns scammers are being allowed to set up e-wallets on Binance and Kraken which steal people’s money because of inadequate security checks.',
            c2: 'The U.K. bank is particularly concerned about Binance as about two-thirds of all frauds involving crypto were tied to the Binance platform. In one 30-day period, 849 TSB savers reported losing funds from Binance accounts. According to the Times, TSB claims that Binance "hardly ever" responds to allegations of customer fraud, claims both Binance and Kraken denied.',
        },
        n8: {
            title: "英国金融行为监管局禁止币安在该国的受监管活动",
            date: '27 June 2021',
            c1: 'Binance Markets was banned by Britain’s financial watchdog from doing any regulated business in the country. The FCA edict specifies that the notice must be put on Binance.com and communication channels including the Binance mobile and desktop applications, as well as its website, social media channels and all other communications that it is no longer permitted to operate in the UK. Binance Markets won’t be able to resume UK operations without prior written consent.',
            c2: 'Binance is being probed by several agencies in the US, Bloomberg News reported in recent months. Japan’s Financial Services Agency issued a warning against Binance recently, saying it offered crypto services without registration.',
            c3: `The move extends a regulatory crackdown on the cryptocurrency sector amid concerns about its potential involvement in money laundering and fraud.`,
        },
        n9: {
            title: "越来越多加密公司正在放弃在英国金融管理局注册申请",
            date: '29 June 2021',
            c1: 'Crypto firms are dropping their bids for registration with the U.K’.s Financial Conduct Authority (FCA) amidst mounting regulatory scrutiny of the industry.',
            c2: 'Reuters reported on Monday, in less than a month, the number of companies abandoning their efforts to register with the financial watchdog has increased to 64 from 51.',
            c3: `The deadline is March 31, 2022 for Crypto firms to register with the FCA for the regulator to determine whether they are meeting anti-money laundering and counter-terrorist financing standards.`,
        },
        n10: {
            title: "美国对加密货币交易所的投诉攀升，其中针对 Coinbase投诉最多",
            date: '30 June 2021',
            c1: 'Coinbase has received the most complaints in the US for the year to date basic according to the Consumer Financial Protection Bureau. ',
            c2: 'The complaints revolving around domestic and international money transfers, digital wallets, and foreign currency exchange. ',
            c3: `8 states in US have registered complaints against Coinbase.`,
            c4: `Coinbase is not alone in complaints filed over cryptocurrency. Other platforms such as Kraken, Binance.US recorded complaints respectively.`,
        },
        n11: {
            title: "新加坡金融管理局：已意识到需对币安采取行动，将酌情跟进其它国家监管机构的行动",
            date: '1 July 2021',
            c1: `Singapore’s financial regulator said it would follow up as required with the local unit of Binance Holdings Ltd. after its parent company came under scrutiny from authorities around the world. “We are aware of the actions taken by other regulatory authorities against Binance and will follow up as appropriate,” the authority said. The parent company is being probed by several agencies in the U.S., Bloomberg News has reported, and Japan’s Financial Services Agency warned that it offered crypto services without registration. The MAS said it is applying “robust standards” in assessing applications, and considers a number of factors such as the applicant’s ability to implement strong measures against illicit flows, as well as fitness and propriety of shareholders and key appointment holders.`,
            c2: `Many applicants dropped out of the race as they were unable to meet the standards laid out under last year’s Payment Services Act, the MAS said.`,
            c3: `Applicants will be “subject to close scrutiny in the licensing process and ongoing supervision by MAS,” the regulator said.`,
        },
        n12: {
            title: "加密货币交易所币安在泰国和开曼群岛面临更加严格的监管审查",
            date: '2 July 2021',
            c1: `Binance Holdings Ltd. is facing increasing attention from regulators, with Thailand and the Cayman Islands becoming the latest nations to weigh in on the dealings of the largest cryptocurrency exchange.`,
            c2: `Thailand’s Securities and Exchange Commission filed a criminal complaint Friday against Binance for operating a digital-asset business in the country without a license. `,
            c3: `The regulator said it issued a warning letter on April 5 this year requiring Binance to submit a written response. It failed to do so within the specified time, the SEC said.`,
            c4: `While the Cayman Islands’ financial regulator said Binance wasn’t authorized to operate in the territory and are investigating the matter.`,
            c5: `It’s the latest in a string of developments from regulators against the crypto business following reports Singapore’s financial regulator would “follow up” on developments from other watchdogs including in the U.K. and Japan.`,
        },
        n13: {
            title: "英国巴克莱银行禁止其用户向币安进行单边付款",
            date: '5 July 2021',
            c1: `Barclays has suspended debit and credit card payments from UK customers to Binance, citing recent Financial Conduct Authority action against the crypto exchange.`,
            c2: `Barclays account holders who had previously sent money to the exchange received text messages informing them of the change Monday.`,
            c3: `Last month the FCA issued a consumer warning that "Binance Markets Limited is not permitted to undertake any regulated activity in the UK".`,
        },
        n14: {
            title: "Bitcoin.org遭到大规模DDoS攻击，攻击者索要比特币赎金",
            date: '6 July 2021',
            c1: `Bitcoin.org was hit with an “overwhelming and massive” distributed denial of service (DDoS) attack and a ransom demand today, according to the site’s pseudonymous operator, Cobra. Shortly after being entwined in a legal decision in the U.K., the Bitcoin.org website now faced the technical battle.`,
            c2: `A DDoS attack is a coordinated cyber-attack that targets to overload a site’s host or its infrastructure with request traffic and in turn bring it down. Such attacks are common in the crypto world.`,
            c3: `The attack is the latest development for the site, which is designed to educate and instruct others on how to buy and sell the crypto.`,
            c4: `Last week, the website lost a UK lawsuit after Cobra opted to preserve his pseudonymity rather than defend himself against charges of copyright infringement from Craig Wright, who claims to have invented Bitcoin. As a result of the default judgment, Bitcoin.org must remove the Bitcoin whitepaper from its website for UK visitors.`,
        },
        n15: {
            title: "欧盟将设立新机构以打击加密货币洗钱活动",
            date: '10 July 2021',
            c1: `The European Commission, the trading bloc's executive arm, is proposing an Anti-Money Laundering Authority (AMLA) as a new agency and new rules concerning crypto-asset transfers.`,
        },
        n16: {
            title: "美国新泽西州总检察长计划向BlockFi发出停止令",
            date: '20 July 2021',
            c1: `New Jersey’s acting attorney general (AG) ordered crypto lending platform BlockFi to halt its Interest Account operations in the state.`,
            c2: `This marks the latest troubles for the embattled lender who, in May, incorrectly deposited and then tried to reverse excessive amounts of bitcoin to users’ accounts. BlockFi was also hit by an attacker spamming its platform with fake sign-ups and abusive language in March.`,
        },
        n17: {
            title: "近半数高盛的家族办公室客户有意持仓纳入数字货币",
            date: '22 July 2021',
            c1: `A survey conducted by the investment bank of the more than 150 family offices found that 45% of them are interested in investing in cryptocurrencies, while a further 15% that responded already do so.`,
            c2: `They see the crypto industry as a hedge against “higher inflation, prolonged low rates and other macroeconomic developments following a year of unprecedented global monetary and fiscal stimulus,” Bloomberg reported Wednesday.`,
        },
        n18: {
            title: "阿拉巴马州向BlockFi发出禁止销售加密货币禁令",
            date: '22 July 2021',
            c1: `The Alabama Securities Commission asked crypto lender BlockFi to show why it should not be required to stop selling unregistered securities in the state. The Commission alleges that BlockFi has funded cryptocurrency lending in part through the sale of unregistered securities.`,
        },
        n19: {
            title: "英国银行业巨头NatWest禁止向币安付款",
            date: '22 July 2021',
            c1: `NatWest joins Santander and Barclays among major banks preventing U.K. customers from purchasing crypto on Binance, following the warning from the Financial Conduct Authority in June that the exchange was operating in the country without permission.`,
            c2: `According to CNBC, Anne Boden, CEO of digital banking heavyweight Starling Bank, described some exchanges as "quite dangerous" on a call with reporters.`,
        },
        // n20: {
        //     title: "Poloniex同意支付1000万美元与美国证券交易委员会和解，用于运营未注册的交易所",
        //     date: '9th August 2021',
        //     c1: `The Securities and Exchange Commission (SEC) has announced that Poloniex has agreed to pay the fine imposed on them for operating an unregistered online digital asset and providing a trading platform that facilities the buying and selling of digital assets.`,
        //     c2: `Although Poloniex qualified as an Exchange, but the latter violated Section 5 of the Exchange Act, failing to register as a national securities exchange.`,
        //     c3: `Furthermore, Poloniex was “aggressive” in their approach to increase their market shares by making new digital assets.`,
        // },
        cn1: {
            title: 'MVGX Chairman 白波：如何应对日趋激烈的碳交易市场竞争',
            date: 'Jun 18, 2021',
            nyuan: '新闻来源:',
            yuan: 'The Edge Singapore',
            url: 'https://www.pressreader.com/singapore/the-edge-singapore/20210621/281526524015445',
            img1: require('@/assets/img/new-20-logo.png'),
            c1: `Bai: We are convinced that the future of exchanges is digital and green, and we want MVGX to be the driving force for green financing`,
            c2: "What can three Singapore-based carbon or green exchanges add to the many already in existence? There are several carbon exchanges but only six exchanges trading under the United Nations Framework for Climate Change-related carbon credits with emission-related permits.",
            c3: 'These are CTRB European Energy Exchange (Europe), ICE Endex (Europe), ICE Futures Europe- Commodities ( Europe), ICE Futures US Energy Division (US), Nasdaq OMX Commodities (US) and NYMEX Exchange US.',
            c4: 'Without delving into the intricacies of carbon credits and carbon markets, DBS Group Holdings together with Standard Chartered Bank, Singapore Exchange (SGX) and Temasek Holdings have launched a carbon exchange,Climate Impact X (CIX), which will be a Singapore-based global exchange.',
            c5: 'According to the launch announcement, CIX offers distinct platforms and products that cater to the needs of different carbon credit buyers and sellers. The exchange will facilitate the sale of large-scale, high-quality carbon credits through standardised contracts that cater primarily to MNCs and institutional investors.',
            c6: 'CIX plans to build “an ecosystem of partners, leveraging satellite monitoring, machine learning and blockchain to enhance transparency, integrity and quality of carbon credits”. This will empower corporations to take effective action and complement carbon reduction efforts as part of a holistic climate mitigation strategy, it adds.',
            c7: 'A second exchange, Cyberdyne Tech Exchange (CTX) received an MAS Capital Market licence in May. Its co-founder and executive chairman Bai Bo says the exchange will focus on being “regulated, digital and green”.MVGX also claims to be the first exchange to require carbon emission disclosure for all assets for both issuers and investors.',
            c8: 'The third, AirCarbon Exchange (ACX), brings commodity exchange infrastructure to carbon markets. Like how commodity trades take place based on receipts representing commodities in warehouses, AirCarbon securitises carbon credits into tradable carbon asset classes based on the markets they serve. It is backed by Enterprise Singapore, Sustainable Energy Association of Singapore and the Digital Exchange Association.',
            c9: 'The CIX differentiator',
            c10: 'Each exchange has different focuses, most likely different customers and products, and, of course, different shareholders.',
            c11: '“The sponsors here make a difference because each of us has a unique strength in terms of customer outreach, technological solutions, the exchange process and ecosystem; and you need liquidity, the right kind of partners and sponsors such as getting global players to crowd in upfront,” explains Piyush Gupta, CEO of DBS, during the launch of CIX. “A lot of questions have been around integrity and we must have world-class people. Anchored in Singapore makes a difference, with its good financial and legal infrastructure. A couple of banks and tacit support of Singapore Inc will distinguish this exchange,” he adds.',
            c12: 'SGX CEO Loh Boon Chye agrees, adding that the local bourse operator brings to the table its unique understanding of market infrastructure. “We understand what it takes to create an ecosystem around trading, settlement,registry and post trade,” he tells The Edge Singapore in an interview.',
            c13: 'This is a tough act for MVGX to follow but Bai is unfazed. “We are convinced that the future of exchanges is digital and green, and we want MVGX to be the driving force for green financing,” he says. Bai is also chairman and CEO of the Asia Green Fund — a significant shareholder of MVGX. The fund is a green impact private equity firm focusing on Chinese industrials and business services as well as technology-enabled green impact with around RMB15 billion ($3.1 billion) worth of assets under management.',
            c14: '“Tokenising” green assets make sustainable investment more accessible to investors and allow issuers to raise funds more cheaply, quickly and simply than via IPO or bond offering. Meanwhile, advances in digital technology — particularly in the blockchain sphere — have also made investors more confident about putting their money into such assets.',
            c15: "Bai also notes that digital information associated with such assets can serve as a rich pool of data that can be analysed to help investors better make investment decisions within this space. A digital exchange,he says, helps capture and analyse data associated with participating assets for the benefit of investors.', require large amounts of energy to mine. The goal of MVGX is not to be a watchdog but rather an exchange of information to allow for transparency regarding prevailing ESG standards.",
            c16: '“We’re not trying to be a police ... because that’s really for the market to decide,” Bai tells The Edge Singapore. He notes from his decades of experience in the sustainable investment space that there is a growing interest in ESG from the markets. With investors increasingly realising that ESG investments tend to outperform nonESG investments, he is confident that given sufficient information, investors will favour assets that comply with ESG requirements and shun those that perform poorly on this front.',
            c17: 'ACX has engaged the British Standards',
            c18: 'Institution to perform token & carbon credit verification. It says that the process “provides confidence to clients that the reported information and associated characteristics of a carbon credit are a faithful,true and fair account of the carbon credits in question and that they conform to the token specifications from AirCarbon”.',
            c19: 'Every token is backed by a one tCO2e carbon credit that sits in the Exchange’s trust. For instance, the AirCarbon Corsia Eligible Token (CET) is backed by the International Civil Aviation Organization’s Carbon Offset & Reductions Scheme for International Aviation (Corsia). Its AirCarbon Global Nature Token and AirCarbon Renewable Energy Token are backed by Verified Carbon Standard (VCS) tokens.',
            c20: 'Resembling how commodities are held in escrow and traded using receipts, ACX claims to offer the lowest transaction cost on the market at 1% of the transaction notional. The industry standard pricing is typically between 10%–20% of the transaction notional. Users enjoy built-in diversification through a managed portfolio of carbon-mitigating projects, reducing concentration risks to clients.',
            c21: '“This allows investors to gain exposure to the underlying commodity without being pigeon-holed into specific carbon projects. By bringing this architecture to the carbon markets we eliminate opacity, increase accessibility and unleash previously alienated investment dollars,” says ACX co-founder Bill Pazos.',
            c22: 'Regulation versus laissez-faire',
            c23: 'A major differentiation with CIX and Bai’s MVGX — in addition to not being under pressure to yield a profit within a narrow time frame like MVGX — is that CIX will be the first carbon exchange anchored in the framework of the Task Force on Climate-related Financial Disclosures (TCFD). This framework was established by the G20’s Financial Stability Board to identify financing risk related to climate change.',
            c24: '“We aim to open doors for trading by endyear and there is a need for corporations to buy carbon credits. In terms of [numbers], there are the 1,800 companies who’ve committed [to climate change]. Among them, there are a couple of hundred buyers [of carbon credits]. They are not necessarily banks because the largest buyers of carbon credits are in hard-to-abate industries like steel and cement,” noted Mikkel Larsen, DBS’s chief sustainability office, during CIX’s launch in May.',
            c25: 'Bill Winters, chief executive of Standard Chartered, says there is a need to go beyond listed companies. “We have stakes in private companies and many are our clients,” says Winters, referring to companies that are ready to purchase carbon credits from CIX.',
            c26: '“SMEs are the ones which find it hardest to understand the complexities around carbon credits. We see increasing interest for corporates to provide neutral projects to customers,” Larsen adds.',
            c27: 'Bai highlights that his exchange is for now only open to institutional and accredited investors, ruling out retail investors in the foreseeable future. There is some evidence that the investing behaviour of institutional investors is more likely to be influenced by ESG concerns than “mom and pop” investors. Bai believes that there is a critical mass of participants from this demographic willing to vote with their feet for ESG.',
            c28: 'Assets traded on MVGX include not just cryptocurrencies but also non-fungible tokens (NFT) and asset-backed tokens. Investors can use asset-backed tokens to invest in alternative assets such as artwork and diamonds.Infrastructure, shares and real estate-backed tokens also provide an alternative to accredited investors seeking more esoteric investment options relative to more mainstream offerings like REITs or bonds.',
            c29: 'According to Bai, alternative assets present an attractive proposition for accredited investors as inflation jitters spread through the global economy. As people fear the devaluation of currencies, demand has risen for real assets as an inflation hedge. The existence of digital assets like NFTs has also increased opportunities for investors to buy fractionalised units of alternative assets, opening up a new opportunity for growth in a more accessible alternatives market.',
            c30: 'MVGX provides trading, settlement and custody services for both cryptocurrencies and asset-backed tokens. It also provides institutional bank-grade security for all levels of its trading platform such as robust penetration testing and managed defence and response to cyber threats. Part of the reason it cites for only taking accredited clients is to ensure rigorous “know your client” and anti-money laundering processes for all who use its services.',
            c31: 'ACX targets its services to financial, corporate and airline clients. It offers widgets and API tools to help corporate clients calculate the carbon they need to offset and is planning the creation of a Futures Carbon market this year. Airline clients also enjoy zero storage costs for their carbon credits, paying for them only on physical delivery.',
            c32: 'Carbon project developers also enjoy significant benefits when trading over AirCarbon. When tokens backed by their carbon credits are traded on the exchange, the project developer enjoys a cut of the ongoing trade fees through blockchain. The upcoming futures market will also provide more sophisticated methods for developers to raise capital on the exchange.',
            c33: 'A more established player, ACX has its own existing portfolio of clients. In April, it announced that it had helped Hong Kong-listed FinTech firm BC Technology Group offset carbon emissions from 2018–2020. Viridios Capital, meanwhile, securitised 500,000 tonnes of Corsia eligible carbon credits with ACX.',
            c34: '“We have great confidence in their cutting-edge blockchain technology. It’s also a competitive advantage that they’re located in Singapore, given the country’s leadership and drive toward becoming a carbon-trading hub in the world,” says Eddie Listorti, Viridios’ founding partner and CEO.',
            c35: 'While Bai’s MVGX is likely to be flexible and secure, CIX has the edge with its established shareholders, long client list from two of Asia’s leading banks, and the ability to recognise liquidity and regulation are among two of the many factors needed for a successful exchange. But ACX’s strong engagement with regulatory standards and carbon credit issuers, and the creation of well-backed in-house tokens present it a unique niche in the carbon exchange space.',
            c36: '',
        },
        cn2: {
            title: '全球碳交易市场竞争日渐加剧',
            date: 'Jun 18, 2021',
            nyuan: '新闻来源:',
            yuan: 'The Edge Singapore',
            url: 'https://www.theedgesingapore.com/issues/capital-markets/competition-carbon-exchanges-heats',
            img1: require('@/assets/img/new-20-logo.png'),
            c1: 'What can three Singapore-based carbon or green exchanges add to the many already in existence? There are several carbon exchanges but only six exchanges trading under the United Nations Framework for Climate Change-related carbon credits with emission-related permits.',
            c2: 'These are CTRB European Energy Exchange (Europe), ICE Endex (Europe), ICE Futures Europe-Commodities (Europe), ICE Futures US Energy Division (US), Nasdaq OMX Commodities (US) and NYMEX Exchange US.',
            c3: 'Without delving into the intricacies of carbon credits and carbon markets, DBS Group Holdings together with Standard Chartered Bank, Singapore Exchange (SGX) and Temasek Holdings have launched a carbon exchange, Climate Impact X (CIX), which will be a Singapore-based global exchange.',
            c4: 'According to the launch announcement, CIX offers distinct platforms and products that cater to the needs of different carbon credit buyers and sellers. The exchange will facilitate the sale of large-scale, high-quality carbon credits through standardised contracts that cater primarily to MNCs and institutional investors.',
            c5: 'CIX plans to build “an ecosystem of partners, leveraging satellite monitoring, machine learning and blockchain to enhance transparency, integrity and quality of carbon credits”. This will empower corporations to take effective action and complement carbon reduction efforts as part of a holistic climate mitigation strategy, it adds.',
            c6: 'A second exchange, Cyberdyne Tech Exchange (CTX) received an MAS Capital Market licence in May. Its co-founder and executive chairman Bai Bo says the exchange will focus on being “regulated, digital and green”. MVGX also claims to be the first exchange to require carbon emission disclosure for all assets for both issuers and investors.',
            c7: 'The third, AirCarbon Exchange (ACX), brings commodity exchange infrastructure to carbon markets. Like how commodity trades take place based on receipts representing commodities in warehouses, AirCarbon securitises carbon credits into tradable carbon asset classes based on the markets they serve. It is backed by Enterprise Singapore, Sustainable Energy Association of Singapore and the Digital Exchange Association.',
            c8: 'The CIX differentiator',
            c9: 'Each exchange has different focuses, most likely different customers and products, and, of course, different shareholders.',
            c10: '“The sponsors here make a difference because each of us has a unique strength in terms of customer outreach, technological solutions, the exchange process and ecosystem; and you need liquidity, the right kind of partners and sponsors such as getting global players to crowd in upfront,” explains Piyush Gupta, CEO of DBS, during the launch of CIX. “A lot of questions have been around integrity and we must have world-class people. Anchored in Singapore makes a difference, with its good financial and legal infrastructure. A couple of banks and tacit support of Singapore Inc will distinguish this exchange,” he adds.',
            c11: 'SGX CEO Loh Boon Chye agrees, adding that the local bourse operator brings to the table its unique understanding of market infrastructure. “We understand what it takes to create an ecosystem around trading, settlement, registry and post trade,” he tells The Edge Singapore in an interview.',
            c12: 'This is a tough act for MVGX to follow but Bai is unfazed. “We are convinced that the future of exchanges is digital and green, and we want MVGX to be the driving force for green financing,” he says. Bai is also chairman and CEO of the Asia Green Fund — a significant shareholder of MVGX. The fund is a green impact private equity firm focusing on Chinese industrials and business services as well as technology-enabled green impact with around RMB15 billion ($3.1 billion) worth of assets under management.',
            c13: '“Tokenising” green assets make sustainable investment more accessible to investors and allow issuers to raise funds more cheaply, quickly and simply than via IPO or bond offering. Meanwhile, advances in digital technology — particularly in the blockchain sphere — have also made investors more confident about putting their money into such assets.',
            c14: 'Bai also notes that digital information associated with such assets can serve as a rich pool of data that can be analysed to help investors better make investment decisions within this space. A digital exchange, he says, helps capture and analyse data associated with participating assets for the benefit of investors.',
            c15: 'Bai does not see MVGX intervening against firms that are found to be unsustainable in terms of carbon emissions. Besides trading in green assets, MVGX also trades less sustainable assets like cryptocurrencies, which require large amounts of energy to mine. The goal of MVGX is not to be a watchdog but rather an exchange of information to allow for transparency regarding prevailing ESG standards.',
            c16: '“We’re not trying to be a police ... because that’s really for the market to decide,” Bai tells The Edge Singapore. He notes from his decades of experience in the sustainable investment space that there is a growing interest in ESG from the markets. With investors increasingly realising that ESG investments tend to outperform non-ESG investments, he is confident that given sufficient information, investors will favour assets that comply with ESG requirements and shun those that perform poorly on this front.',
            c17: 'ACX has engaged the British Standards Institution to perform token & carbon credit verification. It says that the process “provides confidence to clients that the reported information and associated characteristics of a carbon credit are a faithful, true and fair account of the carbon credits in question and that they conform to the token specifications from AirCarbon”.',
            c18: 'Every token is backed by a one tCO2e carbon credit that sits in the Exchange’s trust. For instance, the AirCarbon Corsia Eligible Token (CET) is backed by the International Civil Aviation Organization’s Carbon Offset & Reductions Scheme for International Aviation (Corsia). Its AirCarbon Global Nature Token and AirCarbon Renewable Energy Token are backed by Verified Carbon Standard (VCS) tokens.',
            c19: 'Resembling how commodities are held in escrow and traded using receipts, ACX claims to offer the lowest transaction cost on the market at 1% of the transaction notional. The industry standard pricing is typically between 10%–20% of the transaction notional. Users enjoy built-in diversification through a managed portfolio of carbon-mitigating projects, reducing concentration risks to clients.',
            c20: '“This allows investors to gain exposure to the underlying commodity without being pigeon-holed into specific carbon projects. By bringing this architecture to the carbon markets we eliminate opacity, increase accessibility and unleash previously alienated investment dollars,” says ACX co-founder Bill Pazos.',
            c21: 'Regulation versus laissez-faire',
            c22: 'A major differentiation with CIX and Bai’s MVGX — in addition to not being under pressure to yield a profit within a narrow time frame like MVGX — is that CIX will be the first carbon exchange anchored in the framework of the Task Force on Climate-related Financial Disclosures (TCFD). This framework was established by the G20’s Financial Stability Board to identify financing risk related to climate change.',
            c23: '“We aim to open doors for trading by end-year and there is a need for corporations to buy carbon credits. In terms of [numbers], there are the 1,800 companies who’ve committed [to climate change]. Among them, there are a couple of hundred buyers [of carbon credits].',
            c24: 'They are not necessarily banks because the largest buyers of carbon credits are in hard-to-abate industries like steel and cement,” noted Mikkel Larsen, DBS’s chief sustainability office, during CIX’s launch in May.',
            c25: 'Bill Winters, chief executive of Standard Chartered, says there is a need to go beyond listed companies. “We have stakes in private companies and many are our clients,” says Winters, referring to companies that are ready to purchase carbon credits from CIX.',
            c26: '“SMEs are the ones which find it hardest to understand the complexities around carbon credits. We see increasing interest for corporates to provide neutral projects to customers,” Larsen adds.',
            c27: 'Bai highlights that his exchange is for now only open to institutional and accredited investors, ruling out retail investors in the foreseeable future. There is some evidence that the investing behaviour of institutional investors is more likely to be influenced by ESG concerns than “mom and pop” investors. Bai believes that there is a critical mass of participants from this demographic willing to vote with their feet for ESG.',
            c28: 'Assets traded on MVGX include not just cryptocurrencies but also non-fungible tokens (NFT) and asset-backed tokens. Investors can use asset-backed tokens to invest in alternative assets such as artwork and diamonds. Infrastructure, shares and real estate-backed tokens also provide an alternative to accredited investors seeking more esoteric investment options relative to more mainstream offerings like REITs or bonds.',
            c29: 'According to Bai, alternative assets present an attractive proposition for accredited investors as inflation jitters spread through the global economy. As people fear the devaluation of currencies, demand has risen for real assets as an inflation hedge. The existence of digital assets like NFTs has also increased opportunities for investors to buy fractionalised units of alternative assets, opening up a new opportunity for growth in a more accessible alternatives market.',
            c30: 'MVGX provides trading, settlement and custody services for both cryptocurrencies and asset-backed tokens. It also provides institutional bank-grade security for all levels of its trading platform such as robust penetration testing and managed defence and response to cyber threats. Part of the reason it cites for only taking accredited clients is to ensure rigorous “know your client” and anti-money laundering processes for all who use its services.',
            c31: 'ACX targets its services to financial, corporate and airline clients. It offers widgets and API tools to help corporate clients calculate the carbon they need to offset and is planning the creation of a Futures Carbon market this year. Airline clients also enjoy zero storage costs for their carbon credits, paying for them only on physical delivery. Carbon project developers also enjoy significant benefits when trading over AirCarbon. When tokens backed by their carbon credits are traded on the exchange, the project developer enjoys a cut of the ongoing trade fees through blockchain. The upcoming futures market will also provide more sophisticated methods for developers to raise capital on the exchange.',
            c32: 'A more established player, ACX has its own existing portfolio of clients. In April, it announced that it had helped Hong Kong-listed FinTech firm BC Technology Group offset carbon emissions from 2018–2020. Viridios Capital, meanwhile, securitised 500,000 tonnes of Corsia eligible carbon credits with ACX.',
            c33: '“We have great confidence in their cutting-edge blockchain technology. It’s also a competitive advantage that they’re located in Singapore, given the country’s leadership and drive toward becoming a carbon-trading hub in the world,” says Eddie Listorti, Viridios’ founding partner and CEO.',
            c34: 'While Bai’s MVGX is likely to be flexible and secure, CIX has the edge with its established shareholders, long client list from two of Asia’s leading banks, and the ability to recognise liquidity and regulation are among two of the many factors needed for a successful exchange. But ACX’s strong engagement with regulatory standards and carbon credit issuers, and the creation of well-backed in-house tokens present it a unique niche in the carbon exchange space.',
            c35: ` — Additional reporting by Jeffrey Tan`,
        },
        cn3: {
            title: '洪英莉女士作为北亚区唯一代表 荣获2019纳斯达克全球科技女性大奖',
            date: '20 May 2019',
            nyuan: '新闻来源:',
            yuan: 'MVGX',
            url: '',
            img1: require('@/assets/img/news_32_logo2.png'),
            c1: `据纳斯达克官方媒体报道，纽约时间5 月 20 日上午 9 点，洪英莉女士因其在金融科技领域的突出贡献，荣获2019纳斯达克全球科技女性大奖，并因此登上纽约时代广场纳斯达克大屏，是北亚地区唯一获此殊荣的技术女性。以下是纳斯达克对于洪英莉女士的采访全文，文中分享了她对科技的看法和初心、在技术领域里的职业经历以及对年轻技术女性的一些建议。洪英莉（Lily Hong）女士本科毕业于美国斯坦福大学，主修计算机科学。2002年回国创业，联合创立北京英孚特创新通讯技术有限公司，主营移动终端的研发、生产、销售，为当时移动终端市场销售前五位的公司。2006年联合创立北京艾尔网路科技有限公司，主营系统集成、数据库运营、网络安全。2008 年，洪英莉创立智普信科技，一家为 IoT 行业提供整体安全技术解决方案的科技企业，该公司在 Pre-A 轮即获腾讯投资，并成为其最大的企业股东。我们有幸与
            Lily 坐下来聊聊她的技术职业经历，以及给与希望进入金融、科技行业的年轻技术女性的一些建议。`,
            img2: require('@/assets/img/news_32_logo3.png'),
            c2: `您是怎么进入到科技领域的？`,
            c3: `我从小就对科技充满了好奇心，在绝大多数女孩子玩娃娃的时候，我已经是个自己做电风扇，给自行车装马达，把小电器拆成零件的怪孩子。青少年时代，取代时尚八卦和言情小说让我投入最大热情是对当时新的科学技术的学习和探索。斯坦福大学毕业后，我没有选择在大公司发展的机会，带着科技可以让生活变得美好的初心，毅然决然回到了中国创业。出于一直以来对技术和市场的敏感，我抓住了中国几次科技应用变革爆发的市场机会，先后参与创立了三个科技公司，从移动终端产品的研发和销售，到后来的数据运营、网络安全，再到现在的物联网开发及应用。
            经过数十年技术研发和商业拓展的积淀，让我清晰且欣喜地看到，随着移动物联网、大数据、人工智能等技术的发展，人类社会将全面数字化，数据的有序流动并构建成为可协同的数据资源将产生无限价值。自2013年区块链概念的兴起开始，我就在研究区块链技术在金融领域的探索和应用，包括传统资产的数字化改造、数字货币、数字令牌等。但我认为，区块链技术和数字化经济确实能够对于当前的金融行业和融资方式产生很大的影响，但监管和合规是前提，创新的技术必须与合法的金融行业参与者和监管机构合作，才能发挥其对行业的推动作用。
            我曾经是一名专业的赛车手。在赛场上，不管你的驾驶技术有多好，不管你在赛场上的行驶排位有多靠前，尊重赛场规则都是唯一前提，否则就可能威胁到别人甚至自己的生命，违反规则是以生命为代价的。`,
            c4: `而目前在传统和新型的金融体系各行其道的情况下，特别是加密货币的出现，使安全交易和金融监管的成本极大增加，我认为，我们需要为新兴的数字经济和相关的数字资产领域带来同样的意识。 如何构建合规的数字资产交易是当前金融科技的重要议题。
            我们跟纳斯达克合作，力求在合规的前提下，一起用技术解决传统金融资产数字化及数字化交易问题，使其可被追踪、最小化分割、全球流动，提升交易效率、降低交易成本，并保证数字资产的安全，用技术为传统和新型金融体系搭建一座桥梁。`,
            c5: `您为什么选择从事科技事业？`,
            c6: `我一直认为是科技行业选择了我，而不是我选择从事科技事业。我对科学和技术充满了深深的热爱和敬畏，坚信科技可以推动人类进步，因此我一直将科技让生活更美好作为我从业的初心。受到斯坦福大学精神的深刻影响，我非常尊敬那些真正做底层科学技术研究的人，尤其像居里夫人、屠呦呦等女性科学家，都是我的偶像，我也一直希望我自己的企业能够以我们的技术为行业创新和发展贡献力量和价值。`,
            c7: `您职业经历中最大的挑战是什么？`,
            c8: `时间对每一个人都是公平的，但作为科技领域的创业者，时间对于我而言尤为珍贵也更是极大的挑战。如果想在这个日新月异的科技领域站住脚，持续学习与时俱进是不可或缺的特质。我需要有很强的学习能力和多元化的知识结构。但作为科技公司的创始人，也同样是研发人员，我就必须平衡好作为管理者和研发人员之间的角色分配，既要积极投入各种社会活动，又要保持长期且高效的学习专注度，我对自己时间的管理精确到“分”，尽自己所能不浪费时间。`,
            img3: require('@/assets/img/news_32_logo4.png'),
            c9: `技术女性的身份是如何影响您的职业的？`,
            c10: `我觉得女性可以成为科技行业从业人员是很幸运的。技术，尤其是底层的技术逻辑思维，可以改变很多我们看待事情的方式。作为一名女性，我觉得技术思维的训练，让我能更清楚看到事情的本质，更快抓住问题关键，更追求细节，也更容易把握住自己的行动方向和节奏。我很少纠结，无论道路如何崎岖，都会坚定地走下去。如果不幸失败了，也不后悔，从头再来。我认为，这都是从事科技事业给我构建的良好思维方式。`,
            c11: `您有什么建议，可以分享给希望进入科技行业的年轻女性？`,
            c12: `首先，我认为科技行业女性从业人员，都要认清女性在科技领域特有的优势，要为自己感到骄傲，极力发挥自己的优势和长项，而不是改变自己的不足，要扬长避短。其次，建议多旅行，多了解艺术等美学知识。所谓不去看世界，哪儿来的世界观？看不到美，哪里知道什么是美，好的世界观和价值观可以支持你更好的理解科技以及科技的应用，帮助你在科技道路上更长久更快乐地走下去。`,
            c13: ``,
            c14: ``,
            c15: ``,
            c16: ``,
            c17: ``,
            c18: ``,
            c19: ``,
            c20: ``,
            c21: ``,
            c22: ``,
            c23: ``,
            c24: ``,
            c25: ``,
            c26: ``,
            c27: ``,
            c28: ``,
            c29: ``,
            c30: ``,

        },
        cn4: {
            title: 'MVGX 宣布劳埃德银行（新加坡）前风控合规副行长黄国强（Kelvin Wong） 加入MVGX担任首席合规官',
            date: 'June 15, 2021',
            nyuan: '新闻来源:',
            yuan: 'MVGX',
            url: '',
            img1: require('@/assets/img/news-25-logo.jpg'),
            c1: `Cyberdyne Tech Exchange (“CTX”), a regulated digital green exchange headquartered in Singapore, today announced that Kelvin Wong had joined the company as its Chief Compliance Officer.`,
            c2: `In his role, Mr. Wong will report to MVGX’s Executive Chairman Dr. Bai Bo and oversee MVGX’s compliance issues of its products and business activities, through developing, implementing and executing compliance and
            governance policies, procedures, manuals and training programs.`,
            c3: `Mr. Wong joined MVGX following after more than 17 years experiences in compliance, audit and risk management in the financial services industry. In his prior roles including member of Risk Management & Regulation
            at Singapore Exchange, Deputy Country Head/Risk Partner of Lloyds Bank (Singapore) and Head of Compliance at Tiger Brokers (Singapore), he has developed an extensive compliance experience of capital market products.`,
            c4: `Dr. Bai said, "We are excited to welcome Kelvin to MVGX. As a regulated exchange aiming to create seamless connection with mainstream financial institutions, institutional investors and accredited individuals, we
            appreciate Kelvin’s deep compliance experiences to safeguard our bank-grade KYC/AML standards and best-practices of compliance procedures."`,
            c5: `Mr. Wong said, “I am thrilled to join MVGX, and I look forward to working with the team to implement and execute a world-class compliance practices to bring MVGX to greater heights.”`,
            c6: `Mr. Wong has assumed his full-time responsibilities with MVGX on June 14, 2021.`,
            c7: `About MVGX`,
            c8: `Cyberdyne Tech Exchange (CTX) is a digital exchange licensed and regulated by the Monetary Authority of Singapore and leverages Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides
            qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to
            be a global hub for green financing and will be the first digital exchange to incorporate carbon disclosures for both issuers and investors. Visit www.mvgx.com or contact info@mvgx.com for more information on CTX.`,
            c9: ``,
            c10: ``,
            c11: ``,
            c12: ``,
            c13: ``,
            c14: ``,
            c15: ``,
            c16: ``,
            c17: ``,
            c18: ``,
            c19: ``,
            c20: ``,
            c21: ``,
            c22: ``,
            c23: ``,
            c24: ``,
            c25: ``,
            c26: ``,
            c27: ``,
            c28: ``,
            c29: ``,
            c30: ``,
        },
        cn5: {
            title: '新加坡金融管理局批复新的绿色资产交易的数字资产交易所',
            date: 'MAY 19, 2021',
            nyuan: '新聞來源:',
            yuan: 'THE BUSINESS TIMES',
            url: 'https://www.businesstimes.com.sg/banking-finance',
            img1: require('@/assets/img/new-20-logo.png'),
            c1: `A NEW kid on the block is riding on the growing popularity of digital exchanges for asset-backed tokens - but with a green finance twist.`,
            c2: `Singapore-based Cyberdyne Tech Exchange (CTX) will soon introduce a platform to enable trading of green assets, such as solar or wind farms and electric-vehicle infrastructure in tokenised form.`,
            c3: `On its platform, set to launch in July, issuers and investors will be required to disclose their carbon footprint. Prospective issuers on its exchange include a solar developer in China as well as an art dealer
            in Europe.`,
            c4: `The co-founder and executive chairman of the exchange, Bai Bo told The Business Times that CTX received its capital markets licence from the Monetary Authority of Singapore (MAS) "a few days ago".`,
            c5: `Last December, CTX was granted in-principle approval for a Recognised Market Operator licence and an exemption, for a specified period, from licensing under the Payment Services Act (PSA). Under the PSA, entities
            are given a grace period to submit licence applications. Notified entities will still eventually need a licence from MAS to operate.`,
            c6: `Dr Bai, formerly from private equity firm Warburg Pincus, told The Business Times in an interview: "Part of the fundamental rationale for CTX is that there's a lot of capital, internationally, waiting to be channelled
            towards achieving both financial returns and ESG (environmental, social and governance) impact."`,
            c7: `The Global Sustainable Investment Alliance estimated in 2019 that at least US$31 trillion in funds were then held in sustainable or green investments.`,
            c8: `Dr Bai added: "One way to do that is investing in a private equity fund that pursues such a strategy, but another way is to come to CTX and purchase tokens backed by green assets with a certified economic value
            and certified carbon footage."`,
            c9: `Tokenisation refers to the practice of slicing real assets - such as real estate, infrastructure, equity, and art - into fractions of ownership via a blockchain. This boosts trading liquidity and price discovery,
            while reducing barriers to investment, because a wider range of investors can now buy into the tokens with smaller-sized investment tickets.`,
            c10: `Other digital exchanges in Singapore that have pursued a similar approach include DBS' Digital Exchange and the Temasek-backed iSTOX.`,
            c11: `Like these two digital exchanges, CTX will be available only to accredited and institutional investors when launched, Dr Bai said.`,
            c12: `MAS defines accredited investors as individuals in Singapore who have an annual income in the preceding 12 months of not less than S$300,000.`,
            c13: `Individuals can also qualify as accredited investors in the city-state if their net financial assets exceed S$1 million, or if their net personal assets are more than S$2 million and the net equity of their primary
            residence is no more than S$1 million.`,
            c14: `CTX will tap the expertise of international testing, certification and inspection companies such as DNV and Bureau Veritas to add the green label to its assets. Investors' carbon footprints will also be tracked,
            Dr Bai said, adding that such disclosure is made more efficient via blockchain technology.`,
            c15: `"All we are doing in our ledger is ... to create a quantified and certified carbon footprint for each investor. This is the beauty of the digital assets exchange that we're trying to pursue, which will be harder
            to do on the traditional exchanges."`,
            c16: `Dr Bai added that it will be more challenging for traditional, established exchanges to pull this off also because they already have a huge volume of assets on their platform.`,
            c17: `"Think about it, if you are SGX (Singapore Exchange) or the Hong Kong Stock Exchange, if you want to do this today, what happens to the trillions of dollars that are being traded there? (By contrast) we are able
            to do this by starting from scratch and writing the rules (that) require the exposure and disclosure," he said.`,
            c18: `He also started Asia Green Fund, a green-impact private equity firm with offices in Beijing, Shanghai and Chicago.`,
            c19: `CTX's co-founders include Gabriel Wong, a Singaporean and former Citi investment banker, and Lily Hong, a Chinese national chief executive at a data security technology service provider.`,
            c20: ``,
        },
        cn6: {
            title: 'CTX将推出首个由纳斯达克技术支持的、受监管的资产支持代币交易所，专注于绿色金融',
            date: 'MAY 19, 2021',
            nyuan: 'News Source:',
            yuan: 'Yahoo/Finance',
            url: 'https://finance.yahoo.com/news/ctx-launch-first-regulated-exchange-000000199.html?guccounter=1',
            img1: require('@/assets/img/new-22-logo.jpg'),
            c1: `SINGAPORE, May 19, 2021 /PRNewswire/ -- Singapore-based Cyberdyne Tech Exchange (CTX) said today it will launch the world's first regulated digital exchange to be powered by Nasdaq technologies, for asset-backed
            tokens.`,
            c2: `The tokens will represent fractional value in real assets including green infrastructure, equity, real estate, art, bitcoin and Ethereum.`,
            c3: `CTX will allow qualified asset owners, accredited investors, institutions and corporations, to issue and trade in such digital assets by the second half of this year. It will also provide settlement and custody
            of the tokens.`,
            c4: `The move to launch the exchange comes after the company received Capital Market Services licenses from the Monetary Authority of Singapore this month, approval-in-principle for a Recognised Market Operator license
            in December 2020, as well an exempt Payment Service Act licence.`,
            c5: `Tokenising an asset using blockchain technology and smart contracts creates a security token that represents a share or ownership of a piece of the underlying asset, which is often of high value or is illiquid.
            The process makes the asset accessible to many more investors and allows issuers to raise funds in a cheaper, faster, and easier manner compared to a conventional IPO or bond offering.`,
            c6: `Founded in 2018, CTX said it sees exciting potential in the issuing and trading of tokens of green assets, be it solar or wind farms, smart and sustainable buildings, green industrial parks, sustainable agriculture
            and zero emission mobility.`,
            c7: `Dr Bai Bo, Executive Chairman and Co-Founder of CTX, said: "We believe security tokens will be the new equity and will drive the next wave of the digital economy. For investors, it paves the way for fractional ownership
            of hard-to-access investments and for businesses, it offers a new source of funding that is cost-efficient, trackable, and highly liquid.`,
            c8: `"CTX will seamlessly connect mainstream financial institutions and accredited investors to innovative green assets on a robust exchange that will operate within the rigorous and progressive regulatory framework
            that Singapore offers."`,
            c9: `Dr Bai, a Chinese American, is also Chairman of Asia Green Fund (AGF), one of Asia's first impact private equity funds with over US$2.0 billion assets under management.`,
            c10: `AGF was founded in 2016 with a focus on tech-enabled green impact investments.`,
            c11: `The OECD estimated that US$6.9 trillion per year in infrastructure investment would be required between 2017 and 2030, for the world to achieve the goals under the Paris Agreement of limiting the rise in global
            temperature to below two degrees Celsius.`,
            c12: `Dr Bai added: "We are convinced that the future of exchanges is regulated, digital and green, and we want CTX to be the driving force for green financing."`,
            c13: `AGF has vigorously ensured that the carbon footprint of its investments is quantified and certified with independent agencies such as Bureau Veritas. Dr Bai said CTX will apply that same approach and will be the
            first exchange to require carbon emission disclosures for all assets traded on its system, allowing both issuers and investors to track the carbon footprint of the assets in their possession.`,
            c14: `CTX's trading architecture will deploy Nasdaq's best-in-class matching and market surveillance engines, which are currently utilised by national exchanges, clearing houses, central securities depositories, and regulators
            in over 50 countries.`,
            c15: `Like Nasdaq, CTX requires all issuers to satisfy its listing standards that include both qualitative and quantitative criteria. All issued asset-backed tokens are priced via CTX's proprietary book building process
            to ensure transparency.`,
            c16: `AGF recently invested an additional US$15 million in CTX whose two other co-founders are Gabriel Wong, a Singaporean who was formerly an investment banker, and Lily Hong, Founder and CEO of a data security technology
            service provider for industrial IoT applications.`,
            c17: `About MVGX`,
            c18: `Cyberdyne Tech Exchange (CTX) is a digital exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq's advanced trading and surveillance technologies. Founded in 2018, it provides
            qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to
            be a global hub for green financing and will be the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c19: ``,
            c20: ``,
        },
        cn7: {
            title: '新加坡CTX籌備推出資產支持代幣交易所',
            date: 'MAY 19, 2021',
            nyuan: 'News Source:',
            yuan: 'The Wall Street Journal',
            url: 'https://cn.wsj.com/articles/%E6%96%B0%E5%8A%A0%E5%9D%A1ctx%E7%AD%B9%E5%A4%87%E6%8E%A8%E5%87%BA%E8%B5%84%E4%BA%A7%E6%94%AF%E6%8C%81%E4%BB%A3%E5%B8%81%E4%BA%A4%E6%98%93%E6%89%80-11621413314',
            img1: require('@/assets/img/new-22-logo.jpg'),
            c1: `總部位於新加坡的Cyberdyne Tech Exchange正籌備推出⼀個受監管的資產⽀持代幣數字交易所，並稱，隨著為緩解氣候變化⽽進⾏的投資激增，推出這樣⼀個交易所可以為更多綠⾊融資打開⼤⾨。`,
            c2: `圖片來源：ASSOCIATED PRESS`,
            c3: `Fabiana Negrin Ochoa 2021年5⽉19⽇16:35 `,
            c4: `總部位於新加坡的Cyberdyne Tech Exchange（簡稱CTX）正籌備推出一個受監管的資產支持代幣數字交易所，並稱，隨著為緩解氣候變化而進行的投資激增，推出這樣一個交易所可以為更多綠色融資打開大門。`,
            c5: `CTX周三表示，該交易所將採用納斯達克(Nasdaq Inc.)的技術，到今年下半年將允許符合資格的資產所有者、經認可的投資者、機構和企業發行和交易代幣。`,
            c6: `代幣本質上是太陽能發電廠或風力發電場等現實世界實物資產的一種數字代表。`,
            c7: `CTX聯合創始人Bo Bai告訴《華爾街日報》(The Wall Street Journal)，通過代幣化，將有更多投資者獲得投資這些資產的更多途徑，相比發債等傳統方式， 發行人籌集資金的難度也將下降。`,
            c8: `他在一份聲明中表示：「對於投資者來說，代幣化為他們投資通過其他途徑難以獲取的部分所有權鋪平了道路，對於企業來說，這提供了一種新的資金來 源，具有成本效益高、可追蹤和高流動性的特點。」`,
            c9: `他表示，在全球加緊實現減碳目標之際，促進資本流向環保項目正變得更加緊迫。`,
            c10: `Bai表示：「我們預計未來十年對綠色基礎設施的需求將達到數十兆美元。」 他是亞洲較早的一家私募股權影響基金的創始人，擁有綠色金融方面的從業經歷。`,
            c11: `CTX還打算要求發行人和投資者披露碳足跡，嘗試在透明度方面有所突破。在作出這種披露要求的地方，大多數規定都不是強制性的，缺乏標準化、統一的碳排放資訊是綠色金融面臨的一個問題。`,
            c12: `Bai說，就像他們必須提供由普華永道(PricewaterhouseCoopers)或安永(Ernst & Young)等機構認證的財務數據一樣，交易所參與者將需要提供必維集團(Bureau Veritas)等可持續發展審計公司的碳足跡認證。`,
            c13: `有了這些數據，交易所會員可以更好地平衡他們的投資組合，用諸如綠色工業園區這樣更環保的投資對象來抵消比特幣等碳排放密集型資產。 「所以作為一個投資者，我可以說：我打算在泰國投資一個太陽能項目，也許還會買一個Monet幣，把它們放在一起，我感覺很好，很有滿足感，」Bai 說。`,
            c14: `CTX表示，它是唯一已宣布提供即將上市資產碳足跡資訊計劃的數字貨幣交易所。CTX已獲得了新加坡金融管理局許可，可以交易資本市場產品並提供託管服務。`,
            c15: `（本文來自道瓊斯通訊社）`,
            c16: ``,
            c17: ``,
            c18: ``,
            c19: ``,
            c20: ``,
            c21: ``,
            c22: ``,
            c23: ``,
            c24: ``,
            c25: ``,
            c26: ``,
            c27: ``,
            c28: ``,
            c29: ``,
            c30: ``,
        },
        cn8: {
            title: '中国太平与CTX签署战略合作协议，共同致力发展绿色资产',
            date: 'Singapore, Jul. 6th, 2021 ',
            nyuan: 'News Source:',
            yuan: 'CTX',
            url: '',
            img1: require('@/assets/img/cpnews35.jpg'),
            c1: `China Taiping Insurance Singapore Pte. Ltd. (“CTPIS”) and Cyberdyne Tech Exchange Pte. Ltd. (“CTX”) have announced a new cooperation agreement to encourage the investment, trading and insurance of green assets. `,
            c2: `Photo: Yang Yamei (CTPIS), Lin Dapeng (CTPIS), Bo Bai (CTX), Kelvin Wong (CTX) `,
            c3: `The agreement, signed this week in the form of a Memorandum of Understanding, included CTX enlisting CTPIS as their preferred insurer. Asset issuers and investors (both accredited and institutional) will benefit from access to the expertise and customised insurance solutions of CTPIS when using CTX for primary issuance, secondary trading, settlement, clearing, and custody of asset-backed tokens. `,
            c4: `The two parties confirmed the scope of the agreement provides for continued strengthening of future cooperation in achieving common goals that will foster stability and liquidity of the increasingly in-demand asset class. `,
            c5: `Mr. Yang Yamei, General Manager at CTPIS, said:`,
            c6: `“ We are delighted to partner with Cyberdyne Tech Exchange who has deep knowledge in digital green asset. Together through resource sharing and collaborative innovation, we can unlock the potential of investment, trading and insurance of green assets. This strategic partnership will allow us to bring the best of both worlds together.”`,
            c7: `Bo Bai, Executive Chairman and co-founder of CTX, said: `,
            c8: `“CTX is very happy to cooperate with CTPIS on promoting green assets. As a licensed digital exchange, CTX offers best-in-class capital market services. China Taiping Insurance is regularly acknowledged as a leader in their field with unique market capabilities. This agreement will help us accomplish our goals of establishing Singapore as a green finance hub.”`,
            c9: `About China Taiping Insurance (Singapore) Pte. Ltd. `,
            c10: `China Taiping Insurance (Singapore) Pte. Ltd. (“CTPIS”) is a leading insurer for both life and general insurance businesses. Established in Singapore since 1938, CTPIS has a financial strength rating of A- by S&P and A by A.M Best. We have been assuring our customers in Singapore with financial peace of mind for over 80 years.`,
            c11: `CTPIS is wholly owned by China Taiping Insurance Holdings Company Limited, which has been listed on the Hong Kong Stock Exchange since 2000, making it the first Chinese-funded insurer listed overseas. China Taiping Insurance Group Limited is a large transnational financial and insurance group with business network in Mainland China, Hong Kong, Macau, North America, Europe, Oceania, East and Southeast Asia. The brand has gained international recognition over the years and successfully made the rankings in the “Global Fortune 500 Companies” since 2018.`,
            c12: `About Cyberdyne Tech Exchange Pte. Ltd`,
            c13: `CTX is a green digital exchange licensed and regulated by the Monetary Authority of Singapore. Empowered by Nasdaq’s best-in-class trading and market surveillance engines, CTX offers a comprehensive suite of capital market services for global issuers, institutional investors and accredited investors. CTX services include the primary issuance, secondary trading, settlement and clearing, as well as the custody of, asset-backed tokens. Headquartered in Singapore, CTX aims to become an international hub for green financing and the first regulated exchange that enables carbon disclosures for both the issuers and investors.`,
            c14: `Media enquiries: `,
            c15: `pr@mvgx.com `,
            c16: `Tel: +65 6993 0182`,
        },
        cn10: {
            title: 'Singapore to get world’s first regulated digital exchange for asset-backed tokens',
            date: 'MAY 24, 2021',
            nyuan: 'News Source:',
            yuan: 'IPT.net',
            url: 'https://www.itp.net/emergent-tech/97869-singapore-to-get-worlds-first-regulated-digital-exchange-for-asset-backed-tokens',
            img1: require('@/assets/img/new-24-logo.jpg'),
            c1: `Singapore-based Cyberdyne Tech Exchange (CTX) will launch the world’s first regulated digital exchange for asset-backed tokens.`,
            c2: `Powered by Nasdaq Technologies, the tokens will represent fractional value in real assets including green infrastructure, equity, real estate, art, Bitcoin and Ethereum.`,
            c3: `CTX will allow qualified asset owners, accredited investors, institutions and corporations, to issue and trade in such digital assets by the second half of this year. It will also provide settlement and custody
            of the tokens.`,
            c4: `The move to launch the exchange comes after the company received Capital Market Services licenses from the Monetary Authority of Singapore this month, approval-in-principle for a Recognised Market Operator license
            in December 2020, as well an exempt Payment Service Act licence.`,
            c5: `Tokenising an asset using blockchain technology and smart contracts creates a security token that represents a share or ownership of a piece of the underlying asset, often of high value or is illiquid. The process
            makes the asset accessible to many more investors and allows issuers to raise funds in a cheaper, faster, and easier manner compared to a conventional IPO or bond offering.`,
            c6: `Founded in 2018, CTX said it sees exciting potential in the issuing and trading of tokens of green assets, be it solar or wind farms, smart and sustainable buildings, green industrial parks, sustainable agriculture
            and zero emission mobility.`,
            c7: `Dr Bai Bo, Executive Chairman and Co-Founder of CTX, said: “We believe security tokens will be the new equity and will drive the next wave of the digital economy. For investors, it paves the way for fractional ownership
            of hard-to-access investments. For businesses, it offers a new source of funding that is cost-efficient, trackable, and highly liquid.`,
            c8: `“CTX will seamlessly connect mainstream financial institutions and accredited investors to innovative green assets on a robust exchange that will operate within the rigorous and progressive regulatory framework
            that Singapore offers.”`,
            c9: `Dr Bai is also Chairman of Asia Green Fund (AGF), one of Asia's first impact private equity funds with over USD 2 billion assets under management. Founded in 2016, AGF focuses on tech-enabled green impact investments.`,
            c10: `The OECD estimated that USD6.9 trillion infrastructure investment per year would be required until 2030 for the world to achieve the goals under the Paris Agreement of limiting the rise in global temperature to
            below two degrees Celsius.`,
            c11: `Dr Bai added: “We are convinced that the future of exchanges is regulated, digital and green, and we want CTX to be the driving force for green financing.”`,
            c12: `CTX’s trading architecture will deploy Nasdaq’s best-in-class matching and market surveillance engines, which are currently utilised by national exchanges, clearing houses, central securities depositories, and regulators
            in over 50 countries.`,
            c13: ``,
            c14: ``,
            c15: ``,
            c16: ``,
            c17: ``,
            c18: ``,
            c19: ``,
            c20: ``,
            c21: ``,
            c22: ``,
            c23: ``,
            c24: ``,
            c25: ``,
            c26: ``,
            c27: ``,
            c28: ``,
            c29: ``,
            c30: ``,
        },
        cn11: {
            title: '以绿色环保项目为主 CTX推出实体资产代币交易平台',
            date: 'MAY 20, 2021',
            nyuan: 'News Source:',
            yuan: '联合早报',
            url: 'https://www.zaobao.com/finance/singapore/story20210520-1148097',
            img1: require('@/assets/img/new-20-logo.png'),
            c1: `市场对绿色投资产品的兴趣日益浓厚，Cyberdyne Tech Exchange（简称CTX）推出相关产品代币交易平台。`,
            c2: `CTX推出新的实体资产代币（asset-backed token）交易平台，这些资产以绿色环保项目为主，例如太阳能或风能发电厂，以及电动车辆基础设施。发行机构和投资者必须披露公司的碳足迹。`,
            c3: `其他资产还包括证券、房地产、艺术品、比特币（Bitcoin）和以太币（Ethereum）。`,
            c4: `平台预计7月开始运作`,
            c5: `这个平台预计7月开始运作。目前有一家中国的太阳能公司和欧洲的一家艺术品商计划在平台上发行代币。平台也有结算和代客户保管代币的服务。`,
            c6: `CTX日前获得新加坡金融管理局颁发的资本市场执照。`,
            c7: `公司执行主席兼合伙创办人白波说：“我们能相信，证券代币会是新的证券产品，而且是推动下一波数码经济的动力。对投资者而言，他们能拥有门槛较高投资产品的一部分，这也是一种成本效益高、可追踪且流动性大的新集资来源。”`,
            c8: ``,
            c9: ``,
            c10: ``,
            c11: ``,
            c12: ``,
            c13: ``,
            c14: ``,
            c15: ``,
            c16: ``,
            c17: ``,
            c18: ``,
            c19: ``,
            c20: ``,
            c21: ``,
            c22: ``,
            c23: ``,
            c24: ``,
            c25: ``,
            c26: ``,
            c27: ``,
            c28: ``,
            c29: ``,
            c30: ``,
        },
        // cn12: {
        //     title: 'CTX to Debut Cross-Border Trading of Tokens Backed by China’s Carbon Credits',
        //     date: '23 July 2021',
        //     nyuan: 'News Source:',
        //     yuan: 'AsiaBizToday',
        //     url: 'https://www.asiabiztoday.com/2021/07/23/ctx-debut-cross-border-trading-of-tokens-china-carbon-credits/',
        //     img1: require('@/assets/img/new-20-logo.png'),
        //     c1: `SINGAPORE, July 23, 2021`,
        //     c2: ` – Cyberdyne Tech Exchange (CTX) said today that its digital exchange will soon debut cross-border trading of its proprietary Carbon Neutrality Tokens (CNTs) to be backed by the carbon credits of China, the world’s largest carbon market. CTX has signed Memoranda of Understanding (MOU) with three Chinese entities to issue and facilitate the issuance of CNTs backed by carbon credits, green infrastructure and real estate projects and insurance products, packaged as Collective Investment Schemes under Singapore’s regulatory regime.`,
        //     c3: `The three Chinese entities are CECEP Green Carbon Investment and Development Co, a subsidiary of China Energy Conservation and Environmental Protection Group (CECEP), China Jinmao Holdings’ subsidiary, Jinmao Capital, and China Taiping Insurance Singapore. CTX, backed by the US$2 billion Asia Green Fund, said its CNTs will pave the way for carbon credits to be transferred across international borders. `,
        //     c4: `Dr Bai Bo, Co-founder and Executive Chairman of CTX`,
        //     c5: `Dr Bai Bo, Co-founder and Executive Chairman of CTX, said: “We are excited with the responses we have been getting from prospective issuers since we unveiled CTX two months ago. They saw the innovation behind our CNT and how it can involve the international community in helping pollutive industries reduce their emissions in a sustainable manner. “We were able to engender trust at a time when the crypto market was going through uncertainties because CTX is regulated by the Monetary Authority of Singapore and built on the robust trading and market surveillance technologies of Nasdaq.”`,
        //     c6: `With the carbon information tracked in the tokens, issuers and investors can have visibility of the carbon footprint (or lack thereof) of their production activities and investment portfolios.`,
        //     c7: `This will help them to align their fundraising and investing activities with their commitment to promote sustainable business practices.`,
        //     c8: `Dr Bai disclosed that CTX is also in talks with institutions in Europe and North America to issue tokens on its exchange. “Chinese-backed tokens will initially be dominant because of the size of its carbon credits market but our ambition is to develop CTX into a global marketplace for green investing.” `,
        //     c9: `CTX was recently licensed by the Monetary Authority of Singapore as a Recognised Market Operator. It also holds a Capital Market Services License but is exempted from the Payment Services Act. `,
        //     c10: `CTX, through its wholly-owned subsidiary Cyberdyne Tech Services, will kick-off trading next month with bitcoin, which it expects will be a popular medium for settlement on its exchange. A direct exchange between bitcoin and fiat currencies is allowed on CTX, with each bitcoin carrying a carbon emission value. `,
        //     c11: `Dr Bai, a Chinese American with a PhD in Physics and Financial Technology Option from MIT, co-founded CTX with Singaporean banker Gabriel Wong and Chinese tech entrepreneur Lily Hong. He is also chairman and founder of Asia Green Fund, one of Asia’s first impact private equity funds.`,
        //     c12: ``,
        //     c13: ``,
        //     c14: ``,
        //     c15: ``,
        //     c16: ``,
        //     c17: ``,
        //     c18: ``,
        //     c19: ``,
        //     c20: ``,
        //     c21: ``,
        //     c22: ``,
        //     c23: ``,
        //     c24: ``,
        //     c25: ``,
        //     c26: ``,
        //     c27: ``,
        //     c28: ``,
        //     c29: ``,
        //     c30: ``,
        // },
        // cn13: {
        //     title: 'Singapore-Based Cyberdyne Exchange to Debut China Carbon Credit-Backed Tokens',
        //     date: 'Caixin Global - By Kelsey Cheng Jul 23, 2021 09:03 PM ',
        //     nyuan: 'News Source:',
        //     yuan: 'Caixin Global',
        //     url: 'https://www.caixinglobal.com/2021-07-23/singapore-based-cyberdyne-exchange-to-debut-china-carbon-credit-backed-tokens-101744675.html',
        //     img1: require('@/assets/img/cpnews37_ban.png'),
        //     c1: `Photo: Cyberdyne`,
        //     c2: `Digital green exchange Cyberdyne Tech Exchange will next month debut Chinese carbon credit-backed digital tokens, its co-founder and executive chairman told Caixin. `,
        //     c3: `The Singapore-based exchange’s carbon neutrality tokens (CNTs) are a type of non- fungible token stored on a blockchain, with each representing 1 ton of carbon credits. These credits are tradable certificates that allow holders to emit 1 ton of carbon dioxide or other greenhouse gases. `,
        //     c4: `Such blockchain-backed tokens, which contain information — including data on emission volume, carbon offsetting and carbon capture — can be traded on Cyberdyne’s platform by global investors. `,
        //     c5: `“This can bridge the gap between international capital and the voluntary emission reduction market in China and ultimately attract international capital to support the massive green infrastructure build-outs in China,” Cyberdyne Executive Chairman Bai Bo said in an interview on Friday. Bai is also the founder of the Asia Green Fund, a green impact private equity fund that is also the largest institutional shareholder of Cyberdyne. `,
        //     c6: `Cyberdyne has signed memoranda of understanding with three Chinese entities — CECEP Green Carbon Investment and Development Co. Ltd., a subsidiary of state-owned China Energy Conservation and Environmental Protection Group, China Jinmao Holdings’ subsidiary Jinmao Capital, and China Taiping Insurance Singapore — to issue CNTs backed by carbon credits, green infrastructure and real estate projects and insurance products, the exchange said in a press release. `,
        //     c7: `Bai expects total CNT trading volume will reach at least $100 million within a year, with initial trading dominated by Chinese-backed tokens due to the size of the country’s carbon credit market. `,
        //     c8: `China’s voluntary carbon market is growing steadily. Its national mandatory carbon market, launched last week, is the world’s largest, as total annual carbon emissions of just the first batch of companies involved amount to more than 4 billion tons, according to official estimates. `,
        //     c9: `“There will be a period of market acceptance before we see more robust growth. But eventually we hope companies will realize that this is actually a really interesting way to attract capital,” Bai said. `,
        //     c10: `Read more `,
        //     c11: `Caixin Explains: How China’s New Carbon Market Will Work `,
        //     c12: `The exchange focuses on the listing and trading of asset-backed tokens, which allow users to hold ownership rights over an asset via the digital token, such as real estate and art and collectibles. `,
        //     c13: `Cyberdyne also claims to be the first digital exchange to mandate carbon emission disclosures for both issuers and investors. `,
        //     c14: `“The carbon disclosure requirement will allow all institutions that are truly environmentally conscious to have a more measureable way to support and keep track of green projects and ESG impact,” Bai said. `,
        //     c15: `The exchange, which received its`,
        //     c16: ` capital markets service license `,
        //     c17: `from the Monetary Authority of Singapore in May and was approved last week as a recognized market operator, is only open to institutional and accredited investors.`,
        //     c18: ``,
        //     c19: ``,
        //     c20: ``,
        //     c21: ``,
        //     c22: ``,
        //     c23: ``,
        //     c24: ``,
        //     c25: ``,
        //     c26: ``,
        //     c27: ``,
        //     c28: ``,
        //     c29: ``,
        //     c30: ``,
        // },
        // cn14: {
        //     title: 'China’s Carbon Credit-Backed Digital Tokens to Launch August',
        //     date: ' By OLUSEGUN OGUNDEJI july 25, 2021, 00:45  ',
        //     nyuan: 'News Source:',
        //     yuan: '8 BTC',
        //     url: 'https://news.8btc.com/chinas-carbon-credit-backed-digital-tokens-to-launch-august',
        //     img1: ``,
        //     c1: `China is set to get carbon neutrality tokens (CNTs) as a type of non-fungible token (NFT) stored on a blockchain, Singapore-based Cyberdyne Tech Exchange (CTX) has disclosed to Caixin Global. `,
        //     c2: `According to the exchange whose platform seeks to enable trading of green assets like solar or wind farms and electric-vehicle infrastructure in tokenized form, each CNT will represent 1 ton of carbon credits. They come as tradable certificates that allow holders to emit 1 ton of carbon dioxide or other greenhouse gases, the report says.`,
        //     c3: `Tokenized assets are those sliced into fractions of ownership using the blockchain technology to make it accessible to a wider range of investors. Aside from reducing barriers to investment, tokenization boosts an asset’s trading liquidity and price discovery. `,
        //     c4: `China’s Paris Agreement goal to cut down 60% of the carbon emission per GDP by 2030 based on that of 2005. Though China is the world’s largest emitter of greenhouse gases, it only started its first national emissions-trading market on July 16 based on a cap-and-trade model. The model allows emitters to be allocated a certain number of emissions allowances up to a cap, and then either trade or buy allowances if they remain below or exceed this. `,
        //     c5: `CTX’s launch of CNTs brings a blockchain and crypto approach to carbon tokenization at a time when crypto mining activities have been getting a lot of attention of late going by the carbon emission reduction efforts globally and particularly in China. `,
        //     c6: `Recent coal mine accidents in Xinjiang, Shanxi and Guizhou provinces which saw some mining farms shut down due to a power cut, fuelled even more crackdown on crypto miners and some of them have relocated to other parts of the world. `,
        //     c7: `The focus on Bitcoin miners has been has been supported by various claims including a study published in the broad open-access journal, Nature Communications, which puts the estimate of CO2 emissions from China attributed to the Bitcoin blockchain between January 2016 and June 2018 at up to 13 million metric tons (based on a Bitcoin blockchain carbon emission model). `,
        //     c8: `The authors of the study set an April 2024 timeline for the profit of Bitcoin miners in China to likely drop to zero. They project the annual energy consumption of the Bitcoin blockchain in China would peak at 296.59 Twh in 2024 to generate 130.50 million metric tons of carbon emission correspondingly unless policy interventions were made.`,
        //     c9: `After CTX received its Monetary Authority of Singapore (MAS) Capital Market licence in May, its Executive Chairman and co-founder, Bo Bai, claims the exchange will focus on being “regulated, digital and green” and is the first exchange to require carbon emission disclosure for all assets for both issuers and investors. With services that include the primary issuance, secondary trading, settlement and clearing, and the custody of asset-backed tokens, the exchange says it aims to become an international hub for green financing and the first regulated exchange that enables carbon disclosures for both the issuers and investors. `,
        //     c10: `It notes that the CNT blockchain-backed token which will contain information — including data on emission volume, carbon offsetting and carbon capture — will be traded by global investors on its green digital exchange regulated by MAS. CTX earlier this month signed an agreement with China Taiping Insurance to encourage the investment, trading and insurance of green assets for issuers and investors (both accredited and institutional).`,

        // },
        // cn15: {
        //     title: 'CTX to Debut Chinese Carbon Credit Backed Digital Tokens',
        //     date: ' July 26, 2021  ',
        //     nyuan: 'News Source:',
        //     yuan: 'cryptoknowmics',
        //     url: 'https://www.cryptoknowmics.com/news/ctx-to-debut-chinese-carbon-credit-backed-digital-tokens/',
        //     img1: ``,
        //     c1: `Singapore-based Cyberdyne Tech Exchange(CTX) is preparing to debut cross-border trading of its carbon neutrality tokens (CNTs) backed by Chinese carbon credits. In a press release issued on July 25, the company said that it has signed a memorandum of understanding (MOU) with three Chinese entities who will help the company issue carbon credit-backed CNTs and launch other projects under an investment scheme regulated by Singapore. `,
        //     c2: `CTX to Launch CNT Tokens Backed by Chinese Carbon Credit`,
        //     c3: `The company’s proprietary offering is a type of non-fungible token on the blockchain that represents one ton of carbon credits. Owners of these tokens can use them as tradeable certificates to receive approval for emitting one ton of carbon dioxide and other greenhouse gases. If a company has spare credits, it can sell them to other businesses or pay for other clean energy-based projects to offset its own emissions.`,
        //     c4: `According to the exchange, its CNT tokens will enable the transfer of carbon credits across the border. This has been impossible until now due to the long-drawn disagreements between signatories of the Paris Agreement. The disputes are specifically centered on Article 6, with many countries expressing reservations about the double-counting of internationally traded carbon offsets. `,
        //     c5: `“We are excited with the responses we have been getting from prospective issuers since we unveiled CTX two months ago,” Dr. Bai Bo, the co-founder and Executive Chairman of CTX said. `,
        //     c6: `“We were able to engender trust at a time when the crypto market was going through uncertainties because CTX is regulated by the Monetary Authority of Singapore and built on the robust trading and market surveillance technologies of Nasdaq,” he added. `,
        //     c7: `CTX Looking to expand in Europe and North America`,
        //     c8: `To assure transparency, CTX leverages a digital asset called VER (voluntary emission reduction), which has the information of a carbon neutrality token embedded in it. These assets are then available for trade on the company’s exchange. As a result, both investors and issuers can track the carbon footprint of their production activities through the tokens and plan their fundraising to meet their sustainability objectives. `,
        //     c9: `At present, the exchange is in talks with institutions from North America and Europe, where it hopes to expand sometime in the future. Addressing the prospects of going global, Dr. Bai said, “Chinese-backed tokens will initially be dominant because of the size of its carbon credits market but our ambition is to develop CTX into a global marketplace for green investing.” `,
        //     c10: `Founded in 2018 and backed by the $2 billion Asia Green fund, CTX is a digital green exchange recognized by the Monetary Authority of Singapore(MAS). The company provides institutional investors with complete infrastructure and custody of asset-backed digital tokens. It will soon launch Bitcoin trading for its users, with a direct exchange between fiat money and the currency. In line with its focus on green energy, each Bitcoin traded on its exchange will carry a carbon emission value. `,

        // },
    },

    // 菜單一
    opname: {
        title: '产品',
        title1: 'BTC/ETH',
        title2: '资产支持通证(ABT)',
        title3: '非同质化通证(NFT)',
        title4: '碳中和通证(CNT)',
        title5: '股票支持通证(EBT)',
        mename1: '概览',
        mename2: '艺术品支持通证(ABT-A)',
        mename3: '钻石支持通证(ABT-D)',
        mename4: '基础设施支持通证(ABT-I)',
        mename5: '房地产支持通证(ABT-R)',
        mename6: '概览',
        mename7: '概览',
        mename8: 'CNT 资产列表',
        mename9: '概览',
        mename10: '结算 – CNT',
        mename11: '托管服务 – CNT',
        m1: {
            c1: `概览`,
            c2: `比特币是全球市值第一、最受投资者追捧的数字加密资产。比特币市值已突破1万亿美元大关，占据加密货币总市值的一半以上。到2021年，比特币的市场价格已超过6万美元，成为众多全球投资者心目中的数字黄金。`,
            c3: `比特币（Bitcoin）的概念最初由中本聪在2008年11月1日提出，并于2009年1月3日正式诞生。根据中本聪的思路设计发布的开源软件以及建构其上的P2P网络。比特币是一种P2P形式的虚拟的加密数字货币。点对点的传输意味着一个去中心化的支付系统。`,
            c4: `与所有的货币不同，比特币不依靠特定货币机构发行，它依据特定算法，通过大量的计算产生，比特币经济使用整个P2P网络中众多节点构成的分布式数据库来确认并记录所有的交易行为，并使用密码学的设计来确保货币流通各个环节安全性。P2P的去中心化特性与算法本身可以确保无法通过大量制造比特币来人为操控币值。基于密码学的设计可以使比特币只能被真实的拥有者转移或支付。这同样确保了货币所有权与流通交易的匿名性。比特币其总数量非常有限，极具稀缺性。`,
            c5: `比特币采用通缩机制，每过21万个区块，或大约每四年，就会触发给予矿工的验证奖励就会减半，这使得进入流通的新比特币速度降低了一半。比特币采用通缩的货币政策，每四年减半，直到所有比特币被释放并进入流通。`,
            c6: `综上所述，比特币以其通缩性、可追溯性、分布性、匿名性等特点，被用作价值储存和转移支付的工具。`,
            c7: `以太坊目前是仅次于比特币的，具有全球第二大市场价值的加密货币。以太坊是一个具有智能合约功能的开源公共区块链平台，它提供了一个去中心化的以太坊虚拟机，通过其专有加密货币——以太——来处理点对点合约。`,
            c8: `以太坊的概念最初是由程序员Vitalik Buterin在受到比特币的启发后提出的，被称为“下一代加密货币和去中心化应用平台”，于2014年通过ICO (初始代币提供)开发。以太坊可以支持许多高级功能，包括智能协议、发行货币、建立去中心化的自治组织。以太坊已成为全球最大的基于区块链的智能合约开发和应用平台，以及全球最大的基于区块链的DeFi（去中心化金融）应用平台。`,
            c9: ``,
            c10: ``,
            c11: ``,
            c12: ``,
            c13: ``,
        },
        m2: {
            c1: `艺术品支持通证(ABT-A)`,
            c2: `艺术品能唤起人类的原始情感，是我们知识和文化身份的基石，它也是一种保值增值的资产类别。`,
            c3: `在MVGX，我们为投资者提供投资蓝筹艺术品的机会，从早期大师到战后和当代艺术，投资者可以在一个受监管、透明和安全的环境中投资、交易和托管其艺术品通证。`,
            c4: require('@/assets/img/abta.png'),
        },
        m3: {
            c1: `钻石支持通证(ABT-D)`,
            c2: `抛光钻石（裸钻）– `,
            c3: ` 极端自然和人类艺术的产物。它是美丽和欲望的象征，也是一种可投资资产。精明的收藏家一直通过购买钻石，提高投资回报或使他们的投资组合多样化。`,
            c4: `在MVGX，我们为投资者提供投资精选投资级钻石的机会，受益于价格透明、流动性强、符合反洗钱、反恐制裁要求的受监管交易所。`,
            c5: require('@/assets/img/abtd.png'),
            c6: ``,
            c7: ``,
            c8: ``,
            c9: ``,
            c10: ``,
        },
        m4: {
            c1: `基础设施支持通证(ABT-I)`,
            c2: `基础设施是一个成熟的另类资产类别，具有长期投资眼光和/或ESG考虑因素的投资者将纳入基础设施投资，以分散其投资组合。`,
            c3: `在MVGX，投资者可以投资于精心策划的ESG相关基础设施资产通证。无论是绿色金融还是与可持续发展相关的项目，我们都为投资者提供了可触及的投资门槛，让他们在参与社会公益的同时实现投资组合多元化。`,
            c4: require('@/assets/img/abtis.png'),
            c5: ``,
            c6: ``,
            c7: ``,
            c8: ``,
            c9: ``,
            c10: ``,
        },
        m5: {
            c1: `房地产支持通证(ABT-R)`,
            c2: `房地产是每一代投资者都钟爱的投资品类，它提供了稳定的通胀对冲和投资回报。然而，除了超高净值人士和机构基金，几乎没有人能直接接触到能提供阿尔法回报率的房地产项目。`,
            c3: `在MVGX，投资者可投资经精心策划的房地产项目通证，能以更亲民的价格进行地产投资，实现资本增值、股息收入或其他定制化的投资目标。`,
            c4: require('@/assets/img/abtr.png'),
            c5: ``,
            c6: ``,
            c7: ``,
            c8: ``,
            c9: ``,
            c10: ``,
        },
        m6: {
            c1: `股票支持通证(EBT)`,
            c2: `一直以来，热门IPO项目或科技独角兽公司私募的都备受超高净值人士和机构基金青睐。这些公司之所以成为诱人的投资对象，是因为它们能在公开上市时产生良好的阿尔法。`,
            c3: `在MVGX，我们为投资者提供购买和交易精心策划的处于上市准备阶段公司股权通证的机会。投资者可以在一个受监管、透明和审慎的平台投资、交易和托管他们的通证。 `,
            c4: require('@/assets/img/abts.png'),
            c5: ``,
            c6: ``,
            c7: ``,
            c8: ``,
            c9: ``,
            c10: ``,
        },
        m7: {
            c1: `概览`,
            c2: `非同质化通证(NFT)是存储在数字分类账(称为区块链)上的数据单位，它是数字资产唯一性的证明，因此不可互换。NFT可用于代表照片、视频、音频和其他类型的原生数字文件。然而，访问原始文件的任何副本，并不限于非功能性文件的买家。虽然任何人都可以获得这些数字项目的副本，但区块链上的NFT被跟踪，以向所有者提供独立于版权的所有权证明。`,
            c3: `非同质化通证的特征`,
            c4: `稀缺性`,
            c5: `NFT的价值来自于它的稀缺性。虽然NFT开发人员可以创建任何数量的非同质化通证，但他们通常会限制通证数量以增强其稀有性。`,
            c6: `不可分割`,
            c7: `大多数非同质化通证都不可分割为更小的单位。你可以够买一件数字艺术品的全部通证或完全不买。`,
            c8: `唯一性`,
            c9: `这也许是其最重要的特征。NFT有一个永久的信息标签，记录其唯一性，该信息被视为一种真实性证书。`,
            c10: `NFT的三大优势`,
            c11: `它们是可交易的`,
            c12: `与交易所交易的可互换通证不同，NTF可以在特殊市场上买卖。然而，它们的价值取决于其唯一性。`,
            c13: `它们是真实的`,
            c14: `区块链技术为非同质化通证提供了技术可能性，因此，他让人信赖其真实性，因为它几乎不可能通过去中心化、不可改变的分布式账本来伪造。`,
            c15: `他们能保留所有权`,
            c16: `NFT使用去中心化的平台生成，数据一旦被投资，任何所有者都不能对其进行更改。NFT在游戏、数字资产、身份证明和收藏品中具有广泛的应用需求和场景。`,
            c17: require('@/assets/img/ntf.png'),
            c18: ``,
        },
        m8: {
            c1: `CNT 资产列表`,
            c2: `资产 ID`,
            c3: `资产名称`,
            c4: `描述`,
            c5: `更多信息`,
            c6: `日期`,
            c7: `报告名称`,
            c8: "返回",
            c9: "资产 ID:",
            c10: "资产名称:",
            c11: "描述:",
            c12: "证书:",
            c13: "合约地址:",
            c14: "收款地址:",
            c15: "交易地址:",
            c16: "CNT 发行数量:",
            c17: "收款地址:",
            c18: "交易地址:",
        },
        m9: {
            c1: `碳中和通证(CNT)`,
            c2: `Carbon Neutrality Token (CNT), a proprietary asset-backed token developed by MVGX, enables cross-border trading of high quality voluntary emission reductions without violating the Nationally Determined Contributions (“NDC”) issues. `,
            c3: `MVGX’s proprietary systems, blockchain technologies and operational procedures provide safeguards to ensure carbon integrity, avoid double counting, and enhance transparency, through the following characteristics:`,
            c4: `CNTs issued via MVGX are legally recognized as a unit of a restricted Collective Investment Scheme for non-capital markets product, under Singapore’s Securities and Futures Act (SFA) (Cap 289); `,
            c5: `One CNT is a Digital Depository Receipt (“DDR”) of one tonne of verified carbon emission reduction. DDR is a digital version very similar to American Depository Receipts (“ADR”) in traditional finance; `,
            c6: `CNT is a type of asset-backed token (“ABT”), which is essentially the digital version of asset-backed securities (“ABS”) in traditional markets. CNT’s fundamental value is directly linked to the value of its underlying asset, such as China’s Voluntary Emission Reduction credits (“VERs”), China Certified Emission Reductions (“CCERs”);`,
            c7: `The underlying VERs need to be certified by a few of the most reputable certification firms such as DNV, Bureau Veritas, China Quality Certification Center and the agency under Ministry of Economy and Environment. The Listing Rule of MVGX provides a white list of acceptable quality of VERs from various jurisdiction. For example, for P. R. China, Type 1 and compliance-eligible China Certified Emission Reduction credit is the one accepted to be issued as CNT on MVGX; `,
            c8: `The underlying VERs need to be registered in national, regional, or international registries to avoid any double counting of emissions reduction. The Listing Rule of MVGX provides a white list of acceptable carbon registries. For example, in P. R. China, it should be National Voluntary Emissions Reduction Trading Registry mange by National Center for Climate Change Strategy and International Cooperation (NCSC);`,
            c9: `The underlying VERs need to be irrevocably and permanently frozen in their home registries so that the VERs will not be used for any commercial applications in the non-digital world. The Listing Rule of MVGX provides a white list of acceptable carbon registries. For example, in P. R. China, it should be National Voluntary Emissions Reduction trading Registry mange by National Center for Climate Change Strategy and International Cooperation (NCSC);`,
            c10: `All purchasing and freezing certificates related to the underlying VERs need to be put under MVGX’s custody;`,
            c11: `MVGX’s proprietary digital ledger system tracks carbon footprint of every assets on its platform, allowing both issuers and investors to achieve carbon footprint disclosures. Trading CNTs creates possibilities for investors to pursue carbon neutrality of its portfolio holdings of various assets on MVGX. `,
            c12: `Background Information: `,
            c13: `CNT is a proprietary methodology to separate sovereign ownership issues (e.g., Nationally Determined Contributions, or NDC) from financial characteristics of VERs:`,
            c14: `Article 6 of the Paris Agreement aims at promoting integrated, holistic and balanced approaches that assists governments in implementing their NDCs through voluntary international cooperation. This cooperation mechanism, if properly designed, should make it easier to achieve carbon emissions reduction targets and raise ambitions. In particular, Article 6 could also establish a policy foundation for a global emissions trading system, which could help lead to a global price on carbon;`,
            c15: `In the subsequent years of negotiations, parties failed to reach an agreement on how to set the rules of the market mechanism;`,
            c16: `CNT is a private sector solution in lieu of global consensus on the implementation of Article 6;`,
            c17: `CNT is a market-based solution powered by technologies and supply-demand forces;`,
            c18: `CNT is a proprietary patent-pending system that allows cross-border international trading of VERs;`,
            c19: `CNT is a highly scalable process for international VERs trading across multiple jurisdictions, generating profits for both issuers and investors while attracting capital to fund green assets;`,
            c20: `CNT is a conduit for international financing for green infrastructure projects in developing countries. All CNTs derived from VERs channel capital to the real-world economy.`,
            c21: ``,
        },
        m10: {
            c0: `结算 – CNT`,
            c1: `Settlement is instanteous and updated to our proprietary ledger.`
        },
        m11: {
            c0: `托管服务 – CNT`,
            c1: `All clients’ CNT holdings are kept in cold wallets, segregated by clients’ individual account.As part of business continuity, client’s holding data are backed up by our proprietary ledger which ensures that it is always up-to-date and with adequate redundancy.`
        }
    },

    //菜单二
    osname: {
        title: '服务',
        title1: '服务',
        title2: '交易服务',
        title3: '结算服务',
        title4: '托管服务',
        mename1: '概览',
        mename2: '技术架构',
        mename3: 'BTC/ETH交易',
        mename4: '资产支持的通证交易',
        mename5: '技术架构',
        mename6: '结算 —— BTC/ETH',
        mename7: '结算——资产支持通证',
        mename8: '托管服务 —— BTC/ETH',
        mename9: '托管服务-资产支持通证',
        m1: {
            c1: `概览`,
            c2: `MVGX为通证经济提供了一个高安全性的全服务平台。`,
            c3: `全服务平台`,
            c4: require('@/assets/img/ourservice01-cn.png'),
            c5: `MVGX为通证经济提供发行、交易、结算、托管、互联互通、市场数据和ESG服务等全服务平台。仅对机构投资者及经认定的合格投资者开放。`,
            c6: `银行等级安全标准`,
            c7: `MVGX采用银行等级安全标准，全方位保障交易所安全`,
            c8: require('@/assets/img/ourservice02.png'),
        },
        m2: {
            c1: `技术架构`,
            c2: `MVGX采用纳斯达克的交易引擎、全球监控引擎及风控引擎，结合MVGX自主研发的专有数字资产评估和管理平台，共同打造高效透明的数字资产市场`,
            c3: `MVGX专有数字资产管理平台`,
            c4: `MVGX以纳斯达克技术体系为基础，MVGX 为数字经济交易打造专属的资产评估及管理支撑平台，支持数字经济发展`,
            c5: `结算模块`,
            c6: `模块包括清算、风险、抵押品管理和结算应用。`,
            c7: `复合结算模块`,
            c8: `高速结算引擎`,
            c9: `更高容量、更深交易、更复杂条件、全生命周期管理`,
            c10: `多资产类别的复杂性管理`,
            c11: `抵押品管理模块`,
            c12: `完善的中央交易对手结算所抵押品管理功能`,
            c13: `办理存款、估值和风险评估。`,
            c14: `场外交易管理模块`,
            c15: `负责复杂和非复杂场外交易（OTC）合同的登记、匹配、确认、更替前检查和持仓。`,
            c16: `交收模块`,
            c17: `管理和汇总中央对手方清算所处理的所有证券和现金结算指令。`,
            c18: `现金功能的基础`,
        },
        m3: {
            c1: `BTC/ETH交易`,
            c2: `交易流程:`,
            c3: `我们提供BTC、ETH与美元、欧元和新加坡元等法定货币的直接交易。该服务通过我们的全资子公司新加坡赛博坦技术服务公司（CTS）提供。`,
            c4: `所有订单采用全额缴付，暂时不提供保证金交易。因此，任何时候，客户的未完成订单都不能超过他们的账户余额，所有未完成订单都会减少客户头寸，直到这些订单被完成或取消。`,
            c5: `交易日:`,
            c6: `7*24小时，包括周末与公共假期。`,
            c7: `订单类型:`,
            c8: `市价订单，限价订单，立即执行否则取消（IOC）、全部成交否则取消（FOC）、止损订单、冰山订单`,
            c9: require('@/assets/img/ordertypes.png'),
            c10: `订单属性 :`,
            c11: `市价订单:`,
            c12: `市价订单是按订单簿上当时最优价买入或者卖出一定数量资产的交易指令。`,
            c13: `限价订单:`,
            c14: `限价订单是指以指定价格买入或卖出一定数量资产的交易指令。`,
            c15: `限价订单：立即执行否则取消（IOC）`,
            c16: `当市场价格达到或者超过其指定价格，订单将立即执行。任何无法立即成交的部分都将被取消，且不会停留在后续的订单簿上。`,
            c17: `限价订单：全部成交否则取消（FOC）`,
            c18: `当订单以指定价格停留在连续订单簿上，一旦市场价达到或优于指定价格时，将该订单立即全部成交，否则直接取消该订单。`,
            c19: `止损订单:`,
            c20: `当且仅当订单簿上的最后交易价格达到或者超过设定的止损价格时，才买入或者卖出指定数量数字资产的订单指令。`,
            c21: `冰山订单:`,
            c22: `是指按照提前设定的订单显示机制，以指定价格买入或卖出指定数量资产的订单指令。`,
            c23: `报价规则 :`,
            c24: `MVGX根据价格-时间优先规则匹配订单簿上的订单。价格-时间优先规则意为每次在订单簿发布的订单，都与订单簿上价格最优、时间最早的订单进行匹配。`,
            c25: ``,
        },
        m4: {
            c1: `资产支持的通证交易`,
            c2: `交易流程:`,
            c3: `MVGX是服务资产支持通证的交易所，我们提供资产支撑通证与美元、欧元和新加坡元等法币货币的直接交易。`,
            c4: `所有订单采用全额缴付，暂时不提供保证金交易。因此，任何时候，客户的未完成订单都不能超过他们的账户余额，所有未完成订单都会减少客户头寸，直到这些订单被完成或取消。`,
            c5: `交易日:`,
            c6: `7*24小时，包括周末与公共假期。`,
            c7: `订单类型:`,
            c8: `市价订单，限价订单，立即执行否则取消（IOC）、全部成交否则取消（FOC）、止损订单、冰山订单`,
            c9: `订单属性:`,
            c10: `市价订单:`,
            c11: `市价订单是按订单簿上当时最优价买入或者卖出一定数量资产的交易指令。`,
            c12: `限价订单:`,
            c13: `限价订单是指以指定价格买入或卖出一定数量资产的交易指令。`,
            c14: `限价订单：立即执行否则取消（IOC）:`,
            c15: `当市场价格达到或者超过其指定价格，订单将立即执行。任何无法立即成交的部分都将被取消，且不会停留在后续的订单簿上。`,
            c16: `限价订单：全部成交否则取消（FOC）:`,
            c17: `当订单以指定价格停留在连续订单簿上，一旦市场价达到或优于指定价格时，将该订单立即全部成交，否则直接取消该订单。`,
            c18: `止损订单:`,
            c19: `当且仅当订单簿上的最后交易价格达到或者超过设定的止损价格时，才买入或者卖出指定数量数字资产的订单指令。`,
            c20: `冰山订单:`,
            c21: `是指按照提前设定的订单显示机制，以指定价格买入或卖出指定数量资产的订单指令。`,
            c22: `报价规则 :`,
            c23: `MVGX 根据价格-时间优先规则匹配订单簿上的订单。价格-时间优先规则意为每次在订单簿发布的订单，都与订单簿上价格最优、时间最早的订单进行匹配。`,
        },
        m5: {
            c1: `技术架构`,
            c2: require('@/assets/img/ourservice08.png'),
            c3: `系统目标 :`,
            c4: `管理从交易执行到通过中央交易对手服务方完全结算的全交易生命周期`,
            c5: `保障与一项交易有关的所有权利和义务都得到履行`,
            c6: `覆盖交易对手违约风险`,
            c7: `根据合同规定提供结算服务`,
            c8: `生成交易和清算费用`,
            c9: `提供银行与交付实体的交互界面`,
            c10: `为参与者和其他利益相关者提供相关信息`,
        },
        m6: {
            c1: `结算 —— BTC/ETH`,
            c2: `所有订单:`,
            c3: `Before 5 PM`,
            c4: `工作日下午5点(新加坡时间)前执行的订单，执行之后2小时内完成清算和结算。`,
            c5: `After 5 PM`,
            c6: `工作日下午5点(新加坡时间)之后执行的订单，将在下一个工作日进行清算和结算。`,
            c7: `Weekends & public holidays`,
            c8: `周末和公共假期的结算将根据实际情况而定，尽力而为。`,
            c9: require('@/assets/img/bitbits.png'),
        },
        m7: {
            c1: `结算——资产支持通证`,
            c2: `实时结算，并更新到我们的专有分类账簿`,
            c3: require('@/assets/img/accessed.png'),
        },
        m8: {
            c1: `托管服务 —— BTC/ETH`,
            c2: `Independent cold wallet storage`,
            c3: `所有客户的比特币和ETH都保存在客户各自账户的冷钱包中。`,
            c4: `Multi-signature`,
            c5: `任何从冷钱包中提币的需求，都需要多个管理人进行多重私钥签名确认，以防止勾结和内部威胁。`,
            c6: `Remote Vault`,
            c7: `作为业务连续性的一部分，管理人私钥存储在安全的远程保险库中，确保在任何时候可进行私钥恢复`,
            c8: require('@/assets/img/custody-btc.png'),
        },
        m9: {
            c1: `托管服务-资产支持通证`,
            c2: `Independent cold wallet storage`,
            c3: `客户的所有资产支持通证都保存在客户各自账户的冷钱包中。`,
            c4: `Data Backup`,
            c5: `作为业务连续性的一部分，客户资产持有数据由我们的专有分类账簿进行备份，以确保数据始终是最新的，并有足够的冗余。`,
            c6: require('@/assets/img/custody-abt.png'),
        },
    },

    //菜单三
    jomname: {
        title: '市场',
        title1: '发行人 - 在MVGX上市',
        title2: '投资者 - 在MVGX进行交易',
        mename1: '在MVGX上市的好处',
        mename2: 'MVGX上市程序',
        mename3: 'MVGX上市要求',
        mename4: '投资者 - 如何在MVGX进行交易',
        mename5: '在MVGX交易的好处',
        mename6: 'KYC 和注册流程',
        m1: {
            c1: `在MVGX上市的好处`,
            c2: `MVGX是一家数字金融资产交易所。发行人可通过我们创新的上市规则，个性化定制自己的融资选择，这是全球任何其他交易所都无法提供的。`,
            c3: `发行者可以获得更广泛的投资者基础，这就意味着，发行人以更低的融资成本获得更大的市场流动性。`,
            c4: require('@/assets/img/The_Benefits_of_Listing_cn.png'),
        },
        m2: {
            c1: `MVGX上市程序`,
            c2: `我们鼓励潜在发行人与我们联系，以了解和评估在MVGX上市的可行性。`,
            c3: `一般而言，发行者必须根据MVGX的规定拟备并提交发售备忘录，当发行备忘录审核通过后，发行者需配合MVGX举行线上路演。`,
            c4: `路演期间，潜在投资者将向MVGX提交订单，通过MVGX的专用簿记系统在路演结束时确定发行价。`,
            c5: `在商定的上市日期，开始在 MVGX 平台进行交易。`,
        },
        m3: {
            c1: `MVGX上市要求`,
            c2: `MVGX规定了不同资产类别的定性和定量上市要求。`,
            c3: `我们鼓励潜在发行者通过 `,
            c4: `contact@mvgx.com`,
            c5: ` 联系我们，了解我们的上市标准。`,
        },
        m4: {
            c1: `投资者 - 如何在MVGX进行交易`,
            c2: `MVGX仅对投资机构和经认定的合格投资者开放。投资者可通过网页、API或FIX协议访问我们的交易平台。`,
            c3: `作为接受新加坡金融管理局MAS监管的金融资产交易所，MVGX严格遵守MAS和FATF所执行的KYC和AML/CFT等法规要求。MVGX将在开户和交易过程中，对所有客户执行尽职调查。`,
        },
        m5: {
            c1: `在MVGX交易的好处`,
            c2: `全球投资者可以在MVGX选择他们在其他金融交易所无法获得的一系列投资级另类资产，此类资产符合投资标准和ESG合规要求，投资者能够分散其投资组合并获得优秀的阿尔法收益。`,
            c3: `作为一家总部位于新加坡的金融资产交易所，MVGX位于全时段全球性交易流动性中心。在MVGX平台上交易的投资者将受益于汇聚于新加坡的全球投资者和亚洲时区优势，这意味着投资者将获得更大的流动性和更有效的资本配置。`,
            c4: `投资者还受益于我们一流的纳斯达克交易架构，它确保投资者可以 7*24 小时在价格透明、稳健、高扩展性环境中进行交易。`,
            c5: require('@/assets/img/nsdk.png'),
        },
        m6: {
            c1: `KYC 和注册流程`,
            c2: `所有希望在MVGX开户的发行人和投资人都必须按照MAS的要求进行KYC审核。`,
            c3: `投资者可以通过我们的KYC模块进行在线申请，所需资料包括资料个人基本信息、财富来源、最终受益人等`,
            c4: `如果开户资料完整且符合标准，交易账户可于提交申请当日起48小时内开立。如果您在开户过程中有任何问题，我们的交易操作代表将协助您逐步完成。`,
        },
    },

    //菜单四
    rcname: {
        title: '监管与合规',
        title1: '监管与合规',
        mename1: '概览',
        m1: {
            c1: `概览`,
            c2: `MAS直接监管MVGX作为市场运营商、交易经纪人和资产托管人义务。`,
            c3: `我们将严格履行监管义务，高度重视管理标准，主张对投资者进行透明披露。`,
            c4: `发行者`,
            c5: `在对寻求进入我们市场的公司或者资产持有者，以及已经在我们市场发行的资产及发行人的监管管理中，MVGX发挥主导作用。`,
            c6: `所有发行人都要接受严格的上市评估，以确保该发行和/或该资产满足我们在基本价值、ESG考量以及交易价值定性和定量评估等方面的要求。发行申请中，发行者必须拟备及提交MVGX规定的发行备忘录。`,
            c7: `在MVGX，所有上市申请将由我们的上市委员会审核，该委员会由我们的首席执行官和具有相关领域专业知识经验的独立专业人士组成。`,
            c8: `成功在MVGX上市的发行人须遵守我们的持续上市准则，尤其是要求及时披露市场信息。`,
            c9: `MVGX将在合理可行范围内，确保MVGX市场是公平、有序和知情的。`,
            c10: `投资者`,
            c11: `MVGX有权采取任何被认为适当的行动以维护市场的完整性。`,
            c12: `交易所有权采取任何适当的措施以维护市场的公正性。包括但不限于暂停交易、修改降低风险的参数、限制客户访问、限制订单类型、取消订单簿中的订单，或任何其他被认为对交易所最有利的行为。`,
            c13: `我们将会执行以下行为准则(“交易所行为准则”)，旨在防止使用本交易所进行破坏性、操纵性或欺骗性行为，包括但不限于破坏性交易和价格操纵。本交易所严格禁止如下行为：`,
            c14: `欺诈行为:`,
            c15: `客户或任何关联方均不得从事或试图从事与任何订单或交易有关的任何欺诈行为，不得从事或试图从事任何诈骗、欺瞒或利用漏洞的计划`,
            c16: `虚假交易:`,
            c17: `客户或任何关联方均不得创建或执行虚假交易，或在了解虚假交易性质的情况下下任何订单。`,
            c18: `市场操纵:`,
            c19: `禁止在交易所进行任何破坏性交易或市场操纵。禁止为制造不必要的波动或价格不能（或将不会）反映市场公允价格而发布的订单。`,
            c20: `预先安排的交易:`,
            c21: `客户及其任何关联方均不得发布预先安排(或与另一个市场参与者商量好在交易所优先下单)的订单，旨在建立一个虚假价格、虚假交易，或其他对交易所产生破坏性、欺诈性、非竞争性或不公平的影响`,
            c22: `洗盘交易:`,
            c23: `客户或任何关联方均不得通过一个或多个账户以相同的价格发出或接受买卖订单，因其目的是避免承担真实的市场头寸，以免受到市场风险的影响(交易通常称为洗单交易)。来自具有共同受益所有权和/或从属关系的不同账户之间的买卖订单，其目的是：(1)抵消市场风险或价格竞争，(2)获得优惠费用和由此产生的利益，也应被视为违反了我们对洗盘交易的禁令。`,
            c24: `抢跑交易:`,
            c25: `客户或任何关联方均不得基于他人即将进行的交易的非公开信息持有头寸。`,
            c26: `虚假陈述:`,
            c27: `如果客户对MVGX及其董事会、其任何委员会、或MVGX的任何董事、管理人员、经理或员工有任何重大事实的虚假陈述，都将被认定为该客户违反用户协议。`,
            c28: `资金转移:`,
            c29: `客户及其任何关联方均不得为实现进行账户之间的资金转移目的而执行预先安排的交易。所有执行的交易必须本着诚信目的而执行真实的交易，严禁为实现账户间资金转移而预先安排的交易。`,
            c30: `关联交易:`,
            c31: `客户及其任何关联方均不得为协助他人从事违反本交易所行为准则或任何适用法律法规的交易而进行非竞争性交易。`,
        }
    },

    //菜单五
    rename: {
        title: '数据报告',
        title1: '报告',
        title2: '中国碳市场周报',
        title3: '市场统计',
        mename1: '碳中和与绿色影响报告 2020',
        mename2: '比特币碳足迹追踪计算方法',
        // mename3: '比特币碳足迹计算器',
        mename4: '',
        mename5: '中国碳市场周报 - 2021年8月16日',
        mename6: '中国碳市场周报 - 2021年8月23日',
        mename7: '中国碳市场周报 - 2021年8月30日',
        mename8: '中国碳市场周报 - 2021年9月06日',
        mename9: '中国碳市场周报 - 2021年9月13日',
        mename10: '中国碳市场周报 - 2021年9月20日',
        mename11: '中国碳市场周报 - 2021年9月27日',
        m1: {
            c1: `碳中和与绿色影响报告 2020`,
            c2: `Asia Green Fund Apr.2021`,
            c3: `Executive Summary`,
            c4: `In 2020, China made pledges to reach peak emissions by 2030 and become carbon neutral by 2060. These ambitious goals will require trillions of dollars of investment each year into green businesses and technologies to transform traditional industries. Private equity firms can play an important role in leading the transformation. As one of the earliest private equity firms focusing on green impact investment in China, Asia Green Fund (AGF) has established a comprehensive green impact investment system through years of industry experience. AGF’s system has well-established policies, processes, and methodologies to influence and empower portfolio companies to champion green development in their respective sectors. This report provides a comprehensive summary of the carbon emissions reduction and other environmental impact contributions, in quantitative terms, of the portfolio companies under AGF’s management in 2020. This is the first ever carbon neutrality and green impact performance report published by a private equity firm in Asia.`,
            c5: `As a market-driven private equity firm, AGF has been pursuing both financial return and environmental impact (green impact) in its investments since its inception. AGF takes a proactive approach to selecting and investing in companies with evidence or potential to make a significant green impact. AGF has incorporated environmental, social, and governance (ESG) evaluation metrics into its investment and post-investment management processes to ensure positive contributions to carbon neutrality and green development in every single investment and its entire investment portfolio.`,
            c6: `In practicing green impact investing, AGF pays particular attention to proactively influencing and empowering its portfolio companies through its role as a shareholder. In addition to helping portfolio companies improve their financial and operational capabilities, AGF also guides them in establishing “green strategies”, introducing financing sources that share green ambitions and facilitating collaborations with industrial and strategic partners. Besides standard financial and operational monitoring and reporting, AGF has developed a quantitative impact assessment model, the Carbon Neutrality and Green Impact Assessment System (CNGIAS), to constantly evaluate the green impact performance of each portfolio company. With the basic financial and operational data inputs, CNGIAS quantifies the environmental impact of each portfolio company, including but not limited to the carbon emissions reduction, air pollutant emissions reduction, wastewater reduction, hazardous wastes reduction, etc.`,
            c7: `By also factoring in the investment size, the model generates two indices to quantify environmental impact by investment. One index, called the AGF Carbon Neutrality Index (AGF CNI), is designed to reflect the carbon emissions reduction for every RMB 100 million Yuan of AGF investment. The other index, the Green Impact Index (GII), is designed to reflect the cost savings in environmental remediation due to reduced air pollution, water pollution, and waste of every RMB 1 Yuan of AGF investment. The two indices are first calculated for each portfolio company and then aggregated at the fund level over the entire fund lifecycle to reflect the total contribution of the fund.`,
            c8: `CNGIAS was developed based on proprietary research by AGF, with support and collaboration from third-party institutions. AGF works closely with portfolio companies, leading internationally renowned independent verification, authorization, and certification organizations, environmental data, and carbon management service providers, to ensure the objectivity, integrity, and accuracy of the assessment.`,
            c9: `Today, AGF is pleased to release the 2020 Annual Carbon Neutrality and Green Impact Report. This report quantifies and presents the environmental contribution of each portfolio company as well as the aggregated contribution at the fund level of all the assets under management. Through the long-term monitoring of these indicators, AGF will continuously guide its portfolio companies on carbon neutral and green development strategies and optimize the fund's overall green impact investment portfolio.`,
            c10: `The 2020 report shows that assets under AGF’s management have achieved 2.64 million tCO2e in carbon emissions reduction, nearly 800 tons in air pollution reduction (excluding CO2), 1.64 million tons in water pollution reduction, and 45,000 tons in hazardous waste reduction in year 2020. The above impact implies that AGF has achieved 173,000 tCO2e reduction for every RMB 100 million Yuan invested and saved RMB 0.36 Yuan in environmental remediation on every RMB 1 Yuan invested.`,
            c11: require('@/assets/img/Carbon Neutrality and Green Impact Report 2020.png'),
            c12: `Read More, please `,
            c13: `download`,
            c14: ` the full report.`,
        },
        m2: {
            c1: `比特币碳足迹追踪计算方法`,
            c2: `Cyberdyne Tech Exchange (CTX)`,
            c3: `April 2021`,
            c4: `Summary`,
            c5: `This report summarizes the methodology of calculating the carbon footprint of one bitcoin and explains the default carbon footprint of each bitcoin to be traded on MVGX. Based on the current prevailing mining process and under the guidance of international standards for carbon emission quantification (e.g., ISO 14046, ISO14047, etc.), the carbon emission of one bitcoin is the product of i) the power of the mining machine used (W), ii) the energy efficiency of the mining data center (PUE), iii) the emission factor of the power for the mining machine (tCO2e/MWh), and iv) the time needed to mine the bitcoin, given the computational power of the mining machine (TH•s-1) and the estimate of the average number of bitcoins that can be mined in a day (24 hours) with one unit of hashing power (1 TH•s-1) at the time of mining (typically expressed as Pay Per Share, BTC•day-1 per TH•s-1). Referenced to data in January 2021 and taking a median approach on mining machine energy efficiency and a conservative approach on the emission factor of the power sources, the default carbon footprint for one bitcoin is set to be -170 tCO2e on MVGX. For miners with bitcoins of varying carbon footprints,once the carbon emission of the bitcoin is certified by a third-party verification and certification organization, the miner can issue the difference between the default carbon footprint and the actual certified carbon footprint as a corresponding number of Carbon Neutrality Tokens (CNT) to reflect its more energy efficient mining process.`,
            c12: `Read More, please `,
            c13: `download`,
            c14: ` the full report.`,
            c15: `个人信息`,
            c16: `姓名`,
            c17: `公司`,
            c18: `邮箱`,
            c19: `取消`,
            c20: `确定`,
            c21: `请输入姓名`,
            c22: `请输入公司名称`,
            c23: `请输入邮箱`,
            c24: `报表已经发送到您的邮箱，请查收`,
        },
        m3: {
            c1: `比特币碳足迹计算器`,
            c2: `Mining machine`,
        },
        m5: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年8月16日`,
            c1: '每周总结',
            c2: '8月9日至8月13日交易周，中国碳排放配额（CEA）市场收报为54.00元/吨，周总成交量为379,868吨，其中大宗交易1为279,856吨。 7 月 16 日全国 CEA 市场启动首日交易后，本周也出现了价格相对较高和成交量较低的趋势。 造成这种低成交量限制市场参与者局面的因素可能有以下几个：充足的排放配额免费发放，距履约还有相当长时间，交易信息不充分，或新纳入主体心存犹豫等。',
            c3: '在政策和监管方面，中国在全国 CEA 市场启动后继续推动实施全国市场化的碳减排战略。政治局和中国人民银行（PBOC）在各自的 2021 年下半年工作规划会议上都将碳减排作为重点工作。计划在2030 年实现碳排放峰值。中国人民银行表示将通过资助高效碳减排、促进碳披露和管理气候风险等领域大力发展“绿色金融体系”。',
            c4: '更多内容，请',
            c5: '下载  ',
            c6: '完整报告。',
        },
        m6: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年8月23日`,
            c1: '每周总结',
            c2: '8月16日至8月20日交易周，中国碳排放配额（CEA）市场收于49.00元/吨，周成交量为1,422,012吨。常规开盘交易总量为 22,012 吨，大宗交易总量为 1,400,000 吨。截至8月20日，全国CEA市场累计CEA交易量为7,940,844吨，包括大宗交易在内的均价为49.55元/吨（7.62美元/吨）。与上周相比，包括大宗交易在内的收盘价（-9.26%）和均价（-12.36%）均出现明显下跌。常规公开报价交易类型的交易量降至最低，但大宗交易的交易量急剧增加。总成交量低和大宗交易在市场上占主导地位是造成这种低成交量限制市场参与者数量的主要原因。',
            c3: '在政策和法规方面，生态环境部部长表示，该部将尽快发布《碳排放交易管理暂行条例》。 《暂行条例》将取代现行的《碳排放交易管理办法（试行）》，为国家碳交易体系的进一步发展提供更坚实的法律基础。',
            c4: '中国央行中国人民银行（PBOC）发布了两项中国金融行业标准，即《金融机构环境信息披露指引》（以下简称《披露指引》）和《环境股权融资工具》（以下简称《融资工具》），均于7月22日起生效。虽然此标准不是强制性规定，但这两个行业标准文件为中国绿色金融体系的发展提供了急需（和预期）的指导方针。',
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
        m7: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年8月30日`,
            c1: '一周概览',
            c2: '过去一周（8月23日至27日），中国碳排放配额（CEA）市场总交易量大幅下降，但总体价格保持稳定。 全部9个区域市场的中国核证减排量（CCER）总量比前一周增长5.5%，其中个别市场的变化存在巨大差异。',
            c3: '沈阳市预计于9月启动其地方碳排放交易体系 (ETS)，它将成为中国第10 个，也可能是最后一个区域性碳排放交易市场。',
            c4: '通过参与中国的排放交易体系，中共中央能源管理部门看到了进一步保护及恢复中国海洋、森林和草原生态系统的机会。',
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
        m8: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年9月06日`,
            c1: '一周概览',
            c2: '过去一周（8月30日至9月3日），中国碳排放配额 (CEA)市场交易量大幅下降，公开市场交易量仅为658吨，其中无大宗交易。东航价格继续小幅下跌，收盘价为44.67元/吨。上海排放交易体系(ETS)将于9月30日提交其覆盖的排放主体2020合规年度的排放配额。',
            c3: '全部9个区域碳/气候交易所的中国核证减排量（CCER）信用总交易量较前一周增长17.5%，其信用额超过260万吨。根据广东交易所发布信息，合规的CCER和不合规的CCER周均价分别为45.22元/吨和12.18元/吨。 8月29日，北京绿色交易所（BGE）公布了4家入围全国CCER注册及交易平台建设合同的名单。',
            c4: '中央碳峰值和碳中和领导小组成立碳排放统计核算工作组，加快建立全国统一规范的碳排放统计核算体系。',
            c41: `在两国地缘政治紧张的局势中，中美在天津举行了“坦诚、深入和务实”的气候会谈。`,
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
        m9: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年9月13日`,
            c1: '一周概览',
            c2: `中国的碳排放配额（CEA）市场交易量在上周之后有所回升。总交易量增加了近十倍，达到 6,312 吨，其中没有大宗交易。收盘价下跌1.5%，至44.00元/吨（6.83美元/吨）。由于交易员坚持碳信用，价格下跌趋势仍在继续，预计一旦金融机构获得参与批准，未来价格将上涨。`,
            c3: `中国核证减排量（CCER）总量下降32.3%，至1,788,559吨，个别市场依然存在波动。与可用信息交换的价格大多较低。其中上海的交易量最大，可能是由于2020 年合规年的截止日期临近 9月30日。`,
            c4: `中国启动绿色电力交易试点，首日有259家企业参与交易，交易量超过79亿千瓦时。覆盖区域比当地中长期电价高出0.027-0.050元/千瓦时。目前尚不清楚这将如何影响CCER。`,
            // c41: `在两国地缘政治紧张的局势中，中美在天津举行了“坦诚、深入和务实”的气候会谈。`,
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
        m10: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年9月20日`,
            c1: '一周概览',
            c2: `中国全国碳排放配额(CEA) 市场活动较前一周持续回暖，但价格进一步下跌。总交易量增长了五倍，达32,090 吨，其中依旧没有大宗交易。每周收盘价下跌1.3% 至43.43 元/吨（6.72 美元/吨）。市场似乎在等待金融交易者准入，CCER项目注册和信贷交易重新开放的明确政策消息。`,
            c3: `中国核证减排量（CCER）总量下降21.5%至1,403,969吨，个别市场依然存在波动。上海市场作为本周唯一有可用信息的交易所，价格呈走低趋势。在九个区域交易市场中，四川交易所的交易量最大，其中还有四个没有任何交易。`,
            c4: `中国在中共中央办公厅和国务院办公厅这两个最高政策规划机构发布的联合政策声明中重申其推动，将CCER信贷纳入全国CEA市场。该声明特别指明林业、可再生能源和甲烷利用作为 CCER 来源的关键领域。`,
            // c41: `在两国地缘政治紧张的局势中，中美在天津举行了“坦诚、深入和务实”的气候会谈。`,
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
        m11: {
            title: '中国碳市场周报',
            surch: 'Cyberdyne Tech Exchange (CTX)',
            c31: `2021年9月27日`,
            c1: '一周概览',
            c2: `由于中秋假期，本交易周交易时间缩短，中国碳排放配额（CEA）市场交易量较前一周大幅下降，但收盘价略高。在CEA市场结束为期三天的交易周，总成交量为11,572吨，较前一周下降63.9%。大宗交易再次缺席。公开市场交易价格本周收盘价上涨 2.14% 至 44.36 元/吨（6.86 美元/吨），而成交量的加权平均价小幅下跌至 43.84 元/吨（6.78 美元/吨）。`,
            c3: `中国核证减排量（CCER）的每周总量增长171.5%至3,812,230吨，其中天津市场增长了8倍。上海、重庆和北京的市场已接近各自提交碳排放配额的截止日期，上海和重庆的市场活动有所增加，而北京市场则完全没有交易产生。`,
            c4: `中国国家主席习近平于9月21日在联合国演讲中承诺将停止在中国境外建设新的燃煤电厂。`,
            c41: `上海环境能源交易所宣布了2020年合规年度的第二次区域CEA 拍卖。上海区域的200万吨碳排放配额将于9月30日以底价48.22元/吨拍卖。`,
            c5: '更多内容，请',
            c6: '下载  ',
            c7: '完整报告。',
        },
    },

    //菜单六
    acname: {
        title: '关于MVGX',
        title1: '关于MVGX',
        title2: '加入我们',
        mename1: '我们是谁',
        mename2: '愿景与使命',
        mename3: '我们的优势',
        mename4: '我们的团队',
        mename5: 'MVGX ESG 义务',
        mename6: '隐私和Cookie 政策',
        mename7: '法律免责声明',
        // mename8: 'Assistant Director, Application Development (Front-End-Mobile)',
        mename9: 'Assistant Director, Infrastructure Services (Cloud Engineer)',
        // mename10: 'Assistant Director, Infrastructure Services (End User Computing)',
        mename11: 'Assistant Director, IT Security',
        // mename12: 'Deputy Director or Director, Infrastructure Services',
        // mename13: 'IT Helpdesk Specialist',
        // mename14: 'Operations Associate',
        mename15: 'Vice President, Institutional Sales',
        mename16: 'Institutional Sales Associate',
        // mename17: 'Legal Associate',
        // mename18: 'Vice President, Finance',
        mename19: 'Customer Service Specialist',
        mename20: 'Customer Service Manager',
        mename21: 'Deputy Director / Director, IT Security',
        // mename22: 'Corporate Communications Manager,Director',
        mename23: 'Executive Assistant',
        mename24: 'Senior HR Executive / HR Executive',
        mename25: 'Talent Acquisition Executive',
        mename26: 'Finance Executive',
        mename27: 'Finance Manager',
        m1: {
            c1: `我们是谁`,
            c2: `MVGX 交易所成立于 2018 年，是一家取得主流金融节点主权国家——新加坡金融管理局（Monetary Authority of Singapore)金融牌照并受其监管的合规数字资产交易所。 MVGX 交易所为全球的合格投资人和资产发行人，提供基于实体资产、金融资产和原生数字资产的证券型通证的发行和交易服务。该类证券型通证以绿色基础设施、艺术品、钻石、房地产、股票证券等投资级实体资产作为价值支撑。MVGX 交易所为客户提供包括一级发行、交易、结算以及托管服务等一站式专业金融服务。`,
            c3: `MVGX的交易平台采用了纳斯达克领先的交易引擎和市场监控引擎技术，该引擎被全球250多家市场参与者采用，包括50多个国家的国家交易所、清算所、中央证券存托机构和监管机构。在MVGX平台上交易的投资者将受益于纳斯达克技术架构，该架构具有对新服务和新产品的高扩展性和适应性，以及确保公平和透明的价格发现机制。`,
        },
        m2: {
            c1: `愿景与使命`,
            c2: `愿景`,
            c3: `为每一份资产提供更好、更环保的金融服务`,
            c4: `使命`,
            c5: `打造受监管的绿色数字交易所`,
            c6: require('@/assets/img/greenassets.png'),
        },
        m3: {
            c1: `我们的优势`,
            c2: `新加坡金融管理局发牌和监管的数字资产交易所`,
            c3: `由新加坡金融管理局发牌和监管`,
            c4: `基于 Nasdaq技术的交易平台`,
            c5: `全面采用纳斯达克的先进技术和经验，包括新一代交易引擎、市场监控引擎和风险控制引擎`,
            c6: `无缝连接主流金融机构`,
            c7: `采用银行等级KYC/AML标准和机构级安全标准，与主流金融机构无缝对接`,
            c8: `为通证经济构建基础设施`,
            c9: `为即将到来的通证经济打造全服务基础设施，利用区块链技术释放高价值低流动性资产的价值`,
            c10: `赋能实体经济`,
            c11: `使实体经济获得新的融资渠道和来源`,
            c12: `助力碳中和`,
            c13: `创新的AGF-MVGX系统实现发行者和投资者的双向碳披露，建设碳中和区块链助力碳中和目标实现`,
        },
        m4: {
            c0: `MVGX领导团队`,
            c1: `白波博士`,
            c2: `执行董事长及联合创始人`,
            c3: `现任Asia Green Fund（“AGF”）创始人和董事长。AGF是一家管理资产规模约20亿美元的私募股权公司，是MVGX第一大机构投资者。2009年至2016年，白博士曾担任美国华平投资集团的合伙人与董事总经理。白博士曾服务于全球能源私募基金First Reserve Corporation和美国高盛集团，并在此开启他的投资银行和私募股权职业生涯。`,
            c4: `白波博士拥有麻省理工学院的物理学博士学位和麻省理工学院斯隆管理学院的金融工程学证书。`,
            c5: `陈美玲`,
            c6: `首席行政官`,
            c7: `陈女士拥有超过20年的全球知名企业管理、咨询和人才发展专业经验。 曾任Lee Hecht Harrison LLC （新加坡） 人才发展主管，负责本地业务，并与全球团队在关键客户合作。曾任光辉国际亚太区和英国石油亚太区高管。`,
            c8: `陈女士拥有新加坡国立大学教育学研究生学位，澳大利亚国立大学理学学士和商学学士学位，并拥有注册会计师资格。`,
            c9: `林国伟`,
            c10: `首席技术官`,
            c11: `林先生在IT业拥有超过20年的丰富经验，包括软件开发、基础设施管理、网络安全及IT风险管理。`,
            c12: `2012年至2021年，他曾担任Great Eastern和Manulife等保险公司的高级IT/网络安全经理。2006年至2012年间，他在新加坡教育部负责IT安全管理。 林先生持有西悉尼大学资讯科技学位，并获微软及国际资讯系统安全认证协会(ISC)认证。`,
            c13: `黄国强`,
            c14: `首席合规官`,
            c15: `黄先生是一位经验丰富的合规及内部审计专业人士，拥有多年的金融业经验和资本市场产品的知识以及对证券和衍生品交易的实践认知。他曾在新交所担任监管合规官以及花旗银行、劳埃德银行（新加坡分行）等大行担任高级职位超过17年，包括在劳埃德银行担任主管风控合规的副行长。他拥有莫纳什大学(Monash University)的银行与金融学位以及由国际合规协会和新加坡银行与金融学院颁发的合规专家专业认证(FICS专家)。`,
        },
        m5: {
            c1: `对可持续发展和碳中和的影响`,
            c2: `MVGX严格推动可持续性发展和ESG投资。`,
            c3: `在MVGX, ESG披露和ESG目标的交易不仅受到鼓励，而且通过利用数字化技术和交易解决方案将其嵌入交易所系统，促进资产ESG属性的标记、跟踪、定价和交易。`,
            c4: require('@/assets/img/about-logo.png'),
        },
        m6: {
            c1: `隐私政策`,
            c2: `简介`,
            c3: `我们是指赛博坦科技交易所有限公司和赛博坦科技服务有限公司（简称"MVGX 集团","我们"或"我们的"）。 我们的隐私政策（简称“隐私政策”）关于我们可能采集、使用、披露或其他处理客户信息和数据的方式，是依据新加坡《2012 年个人数据保护法案》(PDPA)而制定。本政策适用于我们拥有或掌握的个人数据，包括基于我们特定目的收集、使用、披露或处理的个人数据。`,

            c8: `个人数据`,
            c9: `1. 在本文隐私政策中 :`,
            c10: `“客户”  `,
            c11: ` 是指(a)通过任何方式与我们联系以了解我们提供的任何服务，或(b)可能或已经与我们签订合同接受由我们提供任何服务的个人；以及`,
            c12: `“个人数据”`,
            c13: ` 是指该数据无论其是否为真，(a)从该数据；或(b)从该数据和我们已经或有可能获得的其他信息，能够从中进行客户身份识别。`,
            c14: `2. 根据您与我们互动的性质，我们可能从您那里收集一些个人数据样例，包括:`,
            c15: `身份和联系信息数据，包括您的姓名、护照号码或其他身份证件号码、电话号码、邮寄地址、电子邮件地址、您的护照或身份证件的图像或水电费账单;`,
            c16: `财务数据，包括您的财务状态、现状和历史状态，以及您的账单详情（如银行账号、信贷、支付及其他付款信息）;`,
            c17: `交易数据，包括您的账户收支详情;`,
            c18: `技术数据，包括你使用设备和技术的详细信息，包括网络协议地址、您的登录数据、和你用于访问我们网站、产品和/或服务的设备的其他技术信息;`,
            c19: `用户行为数据，包括有关您如何使用我们的网站、产品和/或服务的信息，包括cookie、IP 地址和账户详情；和/或`,
            c20: `区块链数据，包括区块链地址和公钥。`,
            c21: `3. 本隐私政策中使用的其他术语应具有PDPA中赋予它们的含义（如果上下文允许）。`,
            c22: `个人数据的收集、使用和披露`,
            c23: `1. 我们通常会收集此类个人数据，(a)您有意且自愿提供的，在我们向您提供服务、或与之相关的过程中，或通过经您正式授权向我们披露您个人数据的第三方（即您的 "授权代表"），在(i)您（或您的授权代表）已被告知收集数据的目的，以及(ii)您（或您的授权代表）已书面同意为这些目的收集和使用您的个人数据，或(b)PDPA或其他法律允许或要求未经同意收集和使用的个人数据。`,
            c24: `2. 我们在收集任何额外的个人数据之前，以及在将您的个人数据用于未通知您的目的之前（法律允许或授权的情况除外），应征求您的同意。如果您不向我们提供您的个人数据，MVGX可能无法提供您要求我们提供的服务。我们在日常活动中收集个人数据，并只在我们的某项职能或活动需要时才会收集这些个人数据。`,
            c25: `3. 一些关于如何收集个人数据的例子:`,
            c26: `当您访问、使用我们的网站、产品、服务（或其一部分）时；`,
            c27: `在MVGX注册您的详细资料时;`,
            c28: `当您完成我们的产品或服务的账户申请时;`,
            c29: `当您直接通过我们的客户服务柜台或我们的客服人员就我们的产品和服务与我们进行沟通时（无论是本人当面、电子邮件、电话、直邮或其他方式）;`,
            c30: `当您要求我们与您联系时;`,
            c31: `当您被认定为我们的客户后更新您的个人资料时;`,
            c32: `当您在活动、研讨会期间、或使用通信设备与我们互动时；`,
            c33: `参与调查或其他类型的研究时;`,
            c34: `4. 我们可能为以下任何或所有目的收集和使用您的个人数据:`,
            c35: `在我们提供您所要求的服务的过程中或与之有关的情况下履行义务;`,
            c36: `验证您的身份;`,
            c37: `对您的询问、请求、申请、投诉和反馈作出回应、处理和纳入流程;`,
            c38: `管理您与我们之间的关系;`,
            c39: `与您沟通您和我们之间的关系、您对我们感兴趣的相关事宜;`,
            c40: `用于达成您提供信息的任何其他目的;`,
            c41: `管理和处理您要求我们提供的产品、服务和/或设施相关的任何付款事宜;`,
            c42: `回应您的查询或投诉，解决您与我们进行交易时可能出现的任何问题和争议;`,
            c43: `为您提供关于我们的产品、服务和您可能感兴趣的研讨会或活动的信息和/或更新，这些研讨会由我们和/或我们选定的第三方提供和组织;`,
            c44: `有选择地通过短信、电话、电子邮件、传真、邮件、社交媒体和/或任何其他适当的沟通渠道向您发送有关我们的服务和产品的信息;以征得您的同意;`,
            c45: `协助您参与和管理任何活动事件，包括研讨会、活动或营销活动;`,
            c46: `维护和更新内部记录;`,
            c47: `出于内部管理目的;`,
            c48: `向您发送参加我们活动和研讨会的邀请;`,
            c50: `监测、复盘和改进我们的活动和研讨会、产品和/或服务;`,
            c51: `处理您和我们之间的商业交易相关的付款事物;`,
            c52: `单独或整合处理和分析您的个人数据;`,
            c53: `出于内部审计和报告目的，与审计员共享您的个人数据;`,
            c54: `基于您为寻求法律和/或财务建议和/或为了开始法律行动，欲与我们正式签订协议或文件，而共享您的个人数据;`,
            c55: `基于审计、风险管控和安全目的;`,
            c56: `为检测、调查和阻止欺诈、违禁或非法活动;`,
            c57: `用以履行我们的义务，并行使我们作为缔约方的任何协议或文件中所赋予的权利;`,
            c58: `将我们签署的任何协议中所赋予的权利、利益和义务进行转让或过户;`,
            c59: `应任何适用法律或监管要求，根据适用于我们的适用法律、法规、指示、法院指令、附则、准则、通告或守则的要求，进行披露;`,
            c60: `根据适用法律、法规和条例，执行或捍卫我们和您的权利，并遵守我们的义务`,
            c61: `用于运营、维护和更好地管理我们的业务以及您与我们的关系所需的其他目的；届时我们会通知您，以征得您的同意.`,
            c62: `传递给任何无关联的第三方，包括我们的第三方服务提供商和代理，以及新加坡或国外的相关政府和/或监管机构，用于上述目的；以及`,
            c63: `任何其他与上述内容有关或与之相关的附带商业目的。`,
            c64: `(统称为“目的”)`,
            c65: `5. 我们可能会披露您的个人数据于:`,
            c66: `在我们提供您所要求的商品和服务的过程中或与之有关的情况下，需要进行此类披露；或向我们聘请的第三方服务提供商、代理和其他组织（无论是位于新加坡还是新加坡以外）披露，以履行与上述目的有关的任何职能。`,
            c67: `6. T即使在您与我们的关系已被终止或以任何方式改变的情况下，上述条款所列目的在此后的一段合理时间内仍可继续适用（包括在适用的情况下，使我们能够根据与您的合同执行我们的权利）。`,
            c68: `向第三方披露个人数据的具体问题`,
            c69: `1. 我们尊重您提供给我们的个人数据的隐私性。MVGX 集团不会向任何个人、公司或团体共享、出售、出租或发布我们采集的任何个人数据。我们采集的任何信息都只用于MVGX自身业务目的，如本 PDPA政策中所述。`,
            c70: `2. 为了向您提供广泛的产品和服务，第三方服务提供商可通过赛博坦科技交易所有限公司参与并提供服务，包括如下： :`,
            c71: `专业建议和咨询`,
            c72: `第三方服务提供商，包括提供电信通讯、信息技术、市场营销等运营服务，以及与政府监管机构相关的合规服务，以遵守任何法律、规则、准则和法规或权威政府的计划。`,
            c73: `3. 开展业务的第三方仅有权在执行其受聘服务时使用您的个人数据。作为我们与他们协议的一部分，他们必须遵守我们提供的 PDPA 法律和政策，并采取合理措施保障您的个人数据安全。`,
            c74: `在这方面，我们不会在未事先征得您的同意的情况下向第三方披露您的个人数据。但是，请注意，在某些特殊情况下，我们可能会在未事先征得您的同意的情况下向第三方披露您的个人数据，包括但不限于以下情况:`,
            c75: `根据适用法律和/或法规要求或授权披露的情况;`,
            c76: `如果这种披露的目的明显符合您的利益，而又无法及时征得您同意的情况;`,
            c77: `对于威胁您自己或他人的生命、健康或安全的紧急情况，必须披露信息的情况;`,
            c78: `任何调查或程序需要披露的情况;`,
            c79: `出示由该执法机构的负责人或主管或类似级别人员签署的书面授权书，证明为该执法人员履行其职能或职责，而必须向其披露个人数据的情况;`,
            c80: `PDPA 或其他法律允许的，无需经您同意而披露的情况。`,
            c81: `4. 有关例外情况的详细信息，建议您参阅PDPA 的第二、第三和第四个附表，获得该附表请前往 `,
            c82: `https://sso.agc.gov.sg.`,
            c83: `如果我们在征得您的同意后向第三方披露您的个人数据，我们将尽最大努力要求此类第三方保护您的个人数据。`,
            c84: `Cookies`,
            c85: `1. 当您浏览我们的网站时，我们会使用Cookie来存储有关您如何使用这些网站的信息，以提高服务质量。`,
            c86: `2. 要了解我们所使用的Cookie类型及其工作原理，请参阅我们的 `,
            c87: ` Cookie Policy.`,
            c88: ` 撤回您的许可`,
            c89: `1. 您为收集、使用和披露您的个人数据所提供的许可将一直有效，直到您以书面形式撤回。作为客户，您可以撤回许可，并要求我们停止为上述任何或所有目的收集、使用和/或披露您的个人数据，您可以通过书面或电子邮件向我们的数据保护官提交您的要求，联系方式如下。`,
            c90: `2. 在收到您撤回许可的书面请求后，我们可能需要合理的时间（取决于请求的复杂性及其对我们与您的关系的影响）来处理您的请求，并让我们通知您我们同意的后果，包括可能影响您对我们的权利和责任的任何法律后果。一般来说，我们应在收到您的请求后的十（10）天内设法处理并使之生效。`,
            c91: `3. 虽然我们尊重您撤回许可的决定，但请注意，根据您请求的性质和程度，我们可能无法继续向您提供我们的商品或服务（视情况而定）。在这种情况下，我们应在完成对您的请求的处理之前通知您（如上所述）。如果您决定取消撤回许可，请按照本节第1条所述的方式书面通知我们。`,
            c92: `4. 请注意，撤回许可并不影响我们继续收集、使用和披露个人数据的权利，因为适用法律允许或要求在没有许可的情况下进行这种收集、使用和披露。`,
            c93: ` 查阅和修正个人数据`,
            c94: `1. 如果您希望(a)提出查阅要求，以获取我们所持有的关于您的个人数据的副本或关于我们使用或披露您的个人数据的方式的信息，或(b)提出修正要求，以修正或更新我们所持有的您的任何个人数据，您可以通过书面或电子邮件向我们的数据保护官提交您的要求，联系方式如下。`,
            c95: `2. 请注意，访问请求可能会被收取合理的费用。我们将在处理您的请求之前通知您费用。`,
            c96: `3. 我们将在合理范围内尽快对您的请求作出回应。一般来说，我们将在三十(30)个工作日内作出回应。如果我们不能在收到您的请求后三十（30）个工作日内作出回应，我们将在三十（30）个工作日内书面通知您我们能够回应请求的时间。如果我们无法向您提供任何个人数据或进行您所要求的更正，我们一般应告知您我们无法这样做的原因（除非根据PDPA我们没有被要求这样做）。`,
            c97: `个人数据保护`,
            c98: `1. 为保护您的个人数据免遭未经授权的访问、采集、使用、披露、复制、修改、处置或类似风险的影响，我们引入了适当的管控、物理和技术措施，例如最新的防病毒保护、加密和使用隐私过滤器来保护我们的所有个人数据的存储和传输，并在内部以及我们授权的第三方服务提供商和代理商之间仅在需要知道的基础上进行个人数据披露。`,
            c99: `2. 但是，如您所知，任何通过互联网传输或电子存储方法都不可能绝对安全。虽然无法百分之百保证，但我们会尽最大努力保护您的信息安全，并不断审查和加强我们的信息安全保障措施。`,
            c100: `个人数据的准确性`,
            c101: `我们主要依赖您（或您的授权代表）提供个人数据。为了确保您的个人数据是最新的、完整和准确的，如果您的个人数据有任何变动，请通过如下联系方式以书面或电子邮件通知我们的数据保护官，以便我们及时对您的个人数据进行更新。`,
            c102: `个人数据的保留`,
            c103: `1. 我们会尽可能长久地保留您的个人数据，以满足采集个人数据的目的或适用法律的要求或规定。`,
            c104: `2. 只要有理由假定此类保留不再需要用于采集个人数据的目的，并且不再需要用法律或业务目的，我们将停止保留您的个人数据，或解除该数据与您的关联性。`,
            c105: `向新加坡境外转移个人资料`,
            c106: `我们一般不会将您的个人数据转移到新加坡以外的国家。然而，如果我们这样做，我们将征得您的同意后进行转移，并将采取措施，以确保您的个人数据继续得到至少与PDPA规定的保护标准相当的保护。`,
            c107: `数据保护官`,
            c108: `如果您对我们的个人数据保护政策和程序有任何疑问或反馈；或者您想提出任何要求，可以通过以下方式联系我们的数据保护官：`,
            c109: `To: Data Protection Officer`,
            c110: `Email Address:`,
            c111: ` dpo@mvgx.com`,
            c112: `隐私政策的效力和更改`,
            c113: `1. 本隐私政策与适用于我们收集、使用和披露您的个人数据的任何其他政策、通知、合同条款和同意条款一起适用。`,
            c114: `2. 我们可能会不时地修订本通知，而不作任何事先通知。您可以通过参考本通知的最后更新日期来确定是否已经进行了任何此类修订。您继续使用我们的服务即表示您承认并接受此类修改。`,
            c115: `Effective Date: 02/12/2019`,
            c116: `Last Updated: 31/12/2021`,
            c117: `求职者的隐私政策`,
            c118: `简介`,
            c119: `我们是指赛博坦科技交易所有限公司和赛博坦科技服务有限公司（简称“MVGX 集团”，“我们”或“我们的”）。`,
            c120: `本数据保护政策（"政策"）规定了MVGX根据《个人数据保护法》（"PDPA"）收集、使用、披露或以其他方式处理求职者的个人数据的依据。本政策适用于我们所拥有或掌握的个人数据，包括我们为收集、使用、披露或处理个人数据而聘请的机构所拥有的个人数据。`,
            c121: `本政策的应用`,
            c122: ` 本政策适用于所有向我们申请任何此类职位的人（"求职者"）。`,
            c123: `个人数据`,
            c124: `1. 在本政策中， "个人数据"是指关于雇员或求职者的数据，无论真实与否，都可以被识别:(a)从该数据中；或(b)从该数据和我们已经或可能获得的其他信息中。`,
            c125: `2. 我们可能收集的个人数据,包括但不限于您的:`,
            c126: `身份和联系数据，包括您的姓名、护照号码或其他身份证件号码、电话号码、邮寄地址、护照或身份证件的图像;`,
            c127: `简历、教育资质、专业资质和证书以及就业推荐信;`,
            c128: `就业及培训经历；`,
            c129: `薪酬信息及银行账户细节资料；`,
            c130: `您的亲属、配偶和其他家庭成员的详细信息;`,
            c131: `与工作有关的健康问题和残疾问题;`,
            c132: "照片；以及; ",
            c133: "与工作申请相关的任何其他个人数据。",
            c134: "3. 本政策中使用的其他术语应具有PDPA中赋予它们的含义（如果上下文允许）。",
            c135: "个人资料的收集、使用和披露 ",
            c136: `1.我们通常收集以下个人数据：(a)您知情并自愿地提供，在与我们合作的过程中或与您的就业或工作申请有关的情况下，或通过您正式授权的第三方向我们披露您的个人数据（您的 "授权代表"，可能包括您的职业介绍所）。在(i)您（或您的授权代表）已被告知收集数据的目的，以及(ii)您（或您的授权代表）已书面同意为这些目的收集和使用您的个人数据，或(b)PDPA或其他法律允许或要求未经同意收集和使用个人数据。在收集任何额外的个人数据之前，以及在将您的个人数据用于未通知您的目的之前（除非法律允许或授权），我们应征求您的同意。`,
            c137: "2. 我们将为以下目的收集和使用您的个人数据，并在必要时为以下目的向第三方披露您的个人数据：",
            c138: "评估和评价您是否适合在该组织的任何现有或潜在职位上就业；",
            c139: "核实您的身份以及您的个人资料和提供的其他信息的准确性；",
            c140: "履行您与我们的雇佣合同项下或与之相关的义务，包括支付报酬和税款；",
            c141: "我们组织内所有与行政和人力资源有关的事项，包括管理工资单、允许进入我们的场所和计算机系统、处理休假申请、管理您的保险和其他福利、处理您的索赔和费用、调查任何行为或违约行为（或可疑行为或违约行为）以及制定人力资源政策；",
            c142: "管理和终止我们与您的雇佣关系，包括监控您的互联网访问和您对我们内联网电子邮件的使用，以调查可能违反我们内部或外部合规规定的行为，并解决任何与雇佣有关的申诉；",
            c143: "评估和评价您是否适合在我们组织内的任何职位上就业/任用或继续就业/任用；",
            c144: "在您与我们的雇佣关系已经或将要终止的情况下，确保我们组织的业务连续性；",
            c145: "履行我们向客户提供货物或服务的义务或与之相关的义务；",
            c146: "促进任何涉及我们组织任何部分的拟议或确认的合并、收购或商业资产交易，或公司重组过程；以及",
            c147: "促进我们遵守可能适用于我们的任何法律、海关和法规。",
            c148: "3. 即使在您与我们的关系已被终止或以任何方式改变的情况下，上述条款所列目的在此后的一段合理时间内仍可继续适用（包括在适用的情况下，使我们能够根据与您的合同执行我们的权利）。",
            c149: "撤回许可",
            c150: "1. 您为收集、使用和披露您的个人数据所提供的许可将一直有效，直到您以书面形式撤回。作为求职者，您可以撤回许可，并要求我们停止为上述任何或所有目的收集、使用和/或披露您的个人数据，您可以通过书面或电子邮件向我们的数据保护官提交您的请求，联系方式如下。",
            c151: "2. 在收到您撤回许可的书面请求后，我们可能需要合理的时间（取决于请求的复杂性及其对我们与您的关系的影响）来处理您的请求，并让我们通知您我们同意的后果，包括可能影响您对我们的权利和责任的任何法律后果。一般来说，我们应在收到您的请求后的十（10）天内设法处理并使之生效。",
            c152: "3. 虽然我们尊重您撤回许可的决定，但请注意，根据您的请求的性质和程度，我们可能无法处理你的工作申请（视情况而定）。在这种情况下，我们将在完成对您的请求的处理之前通知您（如上所述）。如果您决定取消撤回许可，请按照本节第1条所述的方式书面通知我们。",
            c153: "4. 请注意，撤回许可并不影响我们继续收集、使用和披露个人数据的权利，因为适用法律允许或要求在没有同意的情况下进行这种收集、使用和披露。",
            c154: "查阅和修正个人数据",
            c155: "1. 如果您希望(a)提出查阅要求，以获取我们所持有的关于您的个人数据的副本或关于我们使用或披露您的个人数据的方式的信息，或(b)提出更正要求，以更正或更新我们所持有的您的任何个人数据，您可以通过书面或电子邮件向我们的数据保护官提交您的要求，联系方式如下。",
            c156: "2. 请注意，访问请求可能会被收取合理的费用。我们将在处理您的请求之前通知您费用。",
            c157: "3. 我们将在合理范围内尽快对您的请求作出回应。一般来说，我们将在三十(30)个工作日内作出回应。如果我们不能在收到您的请求后三十（30）个工作日内作出回应，我们将在三十（30）个工作日内书面通知您我们能够回应请求的时间。如果我们无法向您提供任何个人数据或进行您所要求的更正，我们一般应告知您我们无法这样做的原因（除非根据PDPA我们没有被要求这样做）。",
            c158: "4. 请注意，根据所提出的要求，我们只需要向您提供所要求的文件中包含的个人数据，而不是整个文件本身。在这些情况下，如果您的个人数据记录在文件中只占很小的一部分，我们可能只需要向您提供我们机构所记录的个人数据。",
            c159: "个人数据保护",
            c160: "1. 为保护您的个人数据免遭未经授权的访问、采集、使用、披露、复制、修改、处置或类似风险的影响，我们引入了适当的管控、物理和技术措施，例如最新的防病毒保护、加密和使用隐私过滤器来保护我们的所有个人数据的存储和传输，并在内部以及我们授权的第三方服务提供商和代理商之间仅在需要知道的基础上进行个人数据披露。",
            c161: "2. 但是，如您所知，任何通过互联网传输或电子存储方法都不可能绝对安全。虽然无法百分之百保证，但我们会尽最大努力保护您的信息安全，并不断审查和加强我们的信息安全保障措施。",
            c162: "个人数据的准确性",
            c163: "我们主要依赖您（或您的授权代表）提供个人数据。为了确保您的个人数据是最新的、完整和准确的，如果您的个人数据有任何变动，请通过如下联系方式以书面或电子邮件通知我们的数据保护官，以便我们及时对您的个人数据进行更新。  ",
            c164: "个人数据的保留",
            c165: "1. 我们会尽可能长久地保留您的个人数据，以满足采集个人数据的目的或适用法律的要求或规定。",
            c166: "2. 只要有理由假定此类保留不再需要用于采集个人数据的目的，并且不再需要用法律或业务目的，我们将停止保留您的个人数据，或解除该数据与您的关联性。",
            c167: "向新加坡境外转移个人资料",
            c168: "我们一般不会将您的个人数据转移到新加坡以外的国家。然而，如果我们这样做，我们将征得您的同意后进行转移，并将采取措施，以确保您的个人数据继续得到至少与PDPA规定的保护标准相当的保护。",
            c169: "数据保护官",
            c170: "如果您对我们的个人数据保护政策和程序有任何疑问或反馈；或者您想提出任何要求，可以通过以下方式联系我们的数据保护官：",
            c171: "To: Data Protection Officer",
            c172: "Email Address:",
            c173: "dpo@mvgx.com",
            c174: "隐私政策的效力和更改",
            c175: "1. 本隐私政策与适用于我们收集、使用和披露您的个人数据的任何其他政策、通知、合同条款和同意条款一起适用。",
            c176: "2. 我们可能会不时地修订本通知，而不作任何事先通知。您可以通过参考本通知的最后更新日期来确定是否已经进行了任何此类修订。您继续使用我们的服务即表示您承认并接受此类修改。",
            c177: "Effective Date: 02/12/2019",
            c178: "Last Updated: 31/12/2021",
        },
        m7: {
            c1: `Cookie Policy`,
            c2: `Introduction`,
            c3: `1. We are Cyberdyne Tech Exchange Pte. Ltd. and Cyberdyne Tech Services Pte. Ltd. (referred to as the “ MVGX Group ”, “ we ”, “ us ” or “ our ”).`,
            c4: `2. Our cookie policy (“Cookie Policy”) explains how and why we use cookies on our websites.`,
            c5: `3. By continuing to use our website without changing your settings, you consent to our use of cookies as set out in this Cookie Policy. If you do not agree to our use of cookies as set out in this Cookie Policy, you should disable or delete the cookies associated with the websites by changing the setting on the web browser on your device accordingly.`,
            c6: `We may from time to time amend the Cookie Policy. Such changes will be published here and effective upon publication. Please check the Cookie Policy regularly for updated information/version. Your continued access and/or use of our website, our products and/or our services will constitute your agreement to the revised Cookie Policy.`,
            c7: `Cookies`,
            c8: `1. Cookies are small files (typically made up of letters and numbers) placed onto your computer by certain websites that you visit or e-mails that you open. Cookies allow a website to recognize a particular device or browser. There are several types of cookies:`,
            c9: `Session cookies expire at the end of your browser session and allow us to link your actions during that particular browser session. Persistent cookies are stored on your device in between browser sessions, allowing us to remember your preferences or actions across multiple sites. First-party cookies are set by the site you are visiting.`,
            c10: `2. Cookies can be disabled or removed by tools that are available in most commercial browsers. The preferences for each browser you use will need to be selected separately and different browsers offer different functionalities and options.`,
            c11: `How We Use Cookies`,
            c12: `1. When you visit, access or interact with MVGX Group website or portal and use our services, we or our authorized service providers may use cookies for collecting and storing information to help provide you with a better, faster, and safer web experience.`,
            c13: `2. We use cookies to:`,
            c14: `manage the signing up process and general administration when you create an account with us;
            remember your user details for future correspondence when you submit data through a form;
            remember your preferences when viewing our websites;
            to remember when you are logged in to your account, which prevents you from having to log in every single time you visit a new page;
            record and store your acceptance of our terms of services (including our Privacy Policy and the Cookie Policy);
            collect statistical information about users of our websites (for example, time spent on each page and which links our users choose to click); and
            from time to time when we offer surveys and questionnaires to understand our user base more accurately, such surveys and questionnaires may use cookies to remember who has already taken part in a survey to provide you with accurate results after you change pages.`,
            c15: `3. Where third party marketing cookies are used to gather information about your browsing activities, please note that we do not have access to, nor control over these third parties’ use of cookies or other tracking technologies or the content of their advertisements.`,
            c16: `Disabling cookies`,
            c17: `1. You can prevent the setting of cookies by adjusting the settings on your browser.`,
            c18: `2. Please note however that disabling cookies will typically result in disabling certain functionalities and features of this site. For example, we will not be able to know that you have opted out of targeted advertising on our website, recognise that you have agreed to the Privacy Policy and Cookie Policy, or remember your preferences.`,
            c19: `3. The personal data that we collect may include information about the way you use our website, your choice of Internet browser, the type of device you’re accessing our website from and where you are in the world.`,
            c20: ``,
        },
        // m8: {
        //     c1: `ASSISTANT DIRECTOR, APPLICATION DEVELOPMENT (FRONT-END / MOBILE)`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: `We are looking for a driven individual who is passionate about developing quality front-end mobile responsive or mobile applications. Our ideal candidate should have excellent organizational skills and could handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset. Those with experience in either securities trading, derivatives, or cryptocurrencies and blockchain would be an added advantage.`,
        //     c4: `As a Front-End or Mobile App Developer, the candidate is expected to delivery user interfaces targeting internal and institutional users.`,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Plan, design and develop our enterprise web sites, including content management system, UI & UX`,
        //     c7: `Design, implement and manage the frontend of our various web applications.`,
        //     c8: `Plan, design and develop native or hybrid mobile application.`,
        //     c9: `Develop and maintain system using Continuous Integration and Continuous Delivery (CICD) pipeline.`,
        //     c10: `Requirements:`,
        //     c11: `Bachelor’s degree or Tertiary education in Information Technology/Science/Computer Science/Engineering or related technical area of study.`,
        //     c12: `Demonstrable coding experience of ideally 3+ years.`,
        //     c13: `Hands-on experience in HTML, CSS and JavaScript frameworks such as Vue.js, Bootstrap for front-end developer as well as nginx.`,
        //     c14: `Hands-on experience in Android and IOS programming or react native for mobile app developer.`,
        //     c15: `Experience in web socket programming would be an advantage.`,
        //     c16: `Experience in CICD and automated testing tools, e.g. Jenkins, Katalon is an advantage.`,
        //     c17: `Experience in AWS Cloud and container technologies, e.g. EC2, RDS, S3, EKS, ECR, etc is an advantage.`,
        //     c18: `Experience in securities exchange, derivatives trading, cryptocurrencies and blockchain would be an added advantage.`,
        //     c19: `Able to communicate effectively in both English and Mandarin.`,
        //     c20: `Must have good interpersonal communication skills (written and oral).`,
        //     c21: `Highly analytical and able to work independently.`,
        //     c22: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player.`,
        //     c23: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
        //     c24: `A team player that collaborates well with other departments.`,
        //     c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` jingwen.pou@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        m9: {
            c1: `ASSISTANT DIRECTOR, INFRASTRUCTURE SERVICES (CLOUD ENGINEER )`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `We are looking for a highly motivated and technology passionate Cloud Engineer to join the team to design, transform and build our core infrastructure and IT services into a secure, efficient, and cost-effective platform.`,
            c4: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset.`,
            c5: `Roles and Responsibilities:`,
            c6: `Provide full architecting, engineering, and administration of Cloud solution in the infrastructure (IaaS) and Platform (PaaS) space.`,
            c7: `Collaborate across business units and project teams to understand their business requirements, project, and operation must-have, and derive solution to address all requirements considerations.`,
            c8: `Collaborate, build, and operate the DevOps infrastructure with the Application Developer team, including the development, operation and administrative of the continuous integration/continuous delivery (CI/CD) environment.`,
            c9: `Collaborate as an integral unit in the Infrastructure team to support the system operation between cloud and on-premises IT network infrastructure.`,
            c91: `Derive a continuous improvement program to review all internal and external cloud operation, validate industry best practices to automate operational and security tasks and implement enterprise-grade, cloud management and governance tools.`,
            c92: `Administer and operationally support the operations of all products and services deployed on the AWS platform.`,
            c93: `Automate the proactive monitoring and statistic reporting capabilities to support operational response and maintenance.`,
            c94: `Conduct capacity planning to forecast resource acquisition, maintain infrastructure availability and ensure sustainable cost.`,
            c95: `Engage in all project planning, management, and development of cloud related tasks, include supporting all integration requirements with the company on-premises IT network infrastructures.`,
            c10: `Requirements:`,
            c11: `Bachelor’s degree or Tertiary education in Information Technology/Science/Computer Science/Engineering or related technical area of study.`,
            c12: `At least 3 years of practical experience in architecture, design, provision, and administration of workload on public Cloud in AWS, Azure or Google.`,
            c13: `Must have hands-on experience working on AWS cloud services such as multi-account strategy, landing zone setup operation, strategize compute and network services, integrated-tiered security, role-based identity, data and storage management, encryption technology and compliance services.`,
            c14: `Knowledge with practical hands-on experience in deploying and optimizing the use of management and governance tools within AWS Cloud Platform.`,
            c15: `Knowledge with practical hands-on experience in deploying and optimizing the use of Cloud Formation or equivalent automation tools in AWS operation.`,
            c16: `Knowledge and experience of deploying and administration of MySQL and PostgreSQL databases in AWS EC2 and RDS will be an advantage.`,
            c17: `Certification in AWS platform will be an advantage, AWS Certified Solution Architect Associate, AWS Certified SysOps Administrator and others.`,
            c18: `Familiar with Linux OS, Java, Docker, Kubernetes and others is a plus`,
            c19: `Experience in securities exchange, derivatives trading, cryptocurrencies and blockchain would be an added advantage.`,
            c20: `Able to communicate effectively in both English and Mandarin.`,
            c21: `Must have good interpersonal communication skills (written and oral).`,
            c22: `Highly analytical and able to work independently.`,
            c23: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player.`,
            c24: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
            c96: `A team player that collaborates well with other departments.`,
            c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` jingwen.pou@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        // m10: {
        //     c1: `ASSISTANT DIRECTOR, INFRASTRUCTURE SERVICES (END USER COMPUTING)`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: ``,
        //     c4: ``,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Provision Windows notebooks and accounts to user`,
        //     c7: `Onsite and remote support for IT issues`,
        //     c8: `Perform security and windows patching as required.`,
        //     c9: `Operational Support and administration of Cloud and IT infrastructure`,
        //     c91: `Participate in weekly after-office-hour support.`,
        //     c92: `Configuration, maintenance and support of Office Automation software and ticketing system (Jira)`,
        //     c93: `End user training and communication of IT initiative`,
        //     c10: `Requirements:`,
        //     c11: `Bachelor’s degree or Tertiary education in Information Technology/Science/Computer Science/Engineering or related technical area of study`,
        //     c12: `At least 3 years of practical experience in End User and IT operation support`,
        //     c13: `Fundamental understanding of IT concepts regarding hardware and software, network, data storage, data backups, and monitoring`,
        //     c14: `Excellent problem-solving skills, ability to troubleshoot and resolve issues without unnecessary escalation to higher levels of support.`,
        //     c15: `Good understanding of common Windows PC & Mac hardware components and connections, network Network Protocols (TCP/IP/UDP/ICMP etc.), Mobile phone technology (i.e., Android, iOS) and O365 suite of software`,
        //     c16: `Able to communicate effectively in both English and Mandarin (written and oral)`,
        //     c17: `Highly analytical and able to work independently.`,
        //     c18: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player.`,
        //     c19: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
        //     c20: `A team player that collaborates well with other departments.`,
        //     c21: ``,
        //     c22: ``,
        //     c23: ``,
        //     c24: ``,
        //     c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` jingwen.pou@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        m11: {
            c1: `ASSISTANT DIRECTOR, IT SECURITY`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have excellent organizational skills and could handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset.`,
            c4: ``,
            c5: `Roles and Responsibilities:`,
            c6: `Implementation of IT security architecture and platforms in a cloud environment which may include access control solutions, identity and access management platforms, data protection technologies, anti-malware, vulnerability management, security monitoring and compliance tools.`,
            c7: `Support the development and maintenance of enterprise IT security policies, standards, methodologies, and best practices for security management to ensure IT systems are designed with due considerations for security.`,
            c8: `Conduct regular security analysis such as penetration and platform security vulnerability scanning to prevent internal and external security incidents and attacks.`,
            c9: `Perform security review of cloud environment and IT systems to ensure compliance with MAS policies and standards.`,
            c91: `Lead in the responses to cyber incidents and assist in remediation efforts in a 24x7x365 mode of operation.`,
            c92: `Stay current on the latest threats and vulnerabilities to ensure the cyber defences and processes of the organisation are up to date.`,
            c10: `Requirements:`,
            c11: `Bachelor’s degree or Tertiary education in Information Technology/Science/Computer Science/Engineering or related technical area of study.`,
            c12: `3 or more years of working experience in cyber security and risks in cloud ecosystems like AWS.`,
            c13: `Strong technical skills, which may include experience with Linux and Windows operating systems, scripting languages like Python, and cloud ecosystems like AWS.`,
            c14: `Relevant certifications in cloud, networking or cyber security, e.g. AWS, CISSP, CISM, CISA preferred.`,
            c15: `Knowledge of DevOps techniques and Agile practices preferred.`,
            c16: `Experience in securities exchange, derivatives trading, cryptocurrencies and blockchain would be an added advantage.`,
            c17: `Able to communicate effectively in both English and Mandarin.`,
            c18: `Must have good interpersonal communication skills (written and oral).`,
            c19: `Highly analytical and able to work independently.`,
            c20: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player.`,
            c21: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
            c22: `A team player that collaborates well with other departments.`,
            c23: ``,
            c24: ``,
            c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` jingwen.pou@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        // m12: {
        //     c1: `DEPUTY DIRECTOR / DIRECTOR, INFRASTRUTURE SERVICES`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: ``,
        //     c4: ``,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Lead and manage the team to run the operational tasks related to the company's IT Infrastructure environment`,
        //     c7: `Monitor, maintain and develop IT infrastructure service levels and associated service management documentation.`,
        //     c8: `Analyse current infrastructure and provide recommendations to the senior management about improvements and cost savings.`,
        //     c9: `Act as an escalation point for the team on the resolution of priority issues as well as coaching and mentoring when appropriate.`,
        //     c91: `Perform technical duties when required.`,
        //     c92: `Provide full architecting, engineering, and administration of Cloud solution in the infrastructure (IaaS) and Platform (PaaS) space.`,
        //     c93: `Lead across business units and project teams to understand their business requirements, project, and operation must-have, and derive solution to address all requirements considerations.`,
        //     c94: `Lead, build and operate the DevOps infrastructure with the Application Developer team, including the development, operation and administrative of the continuous integration/continuous delivery (CI/CD) environment.`,
        //     c95: `Lead an integral unit in the Infrastructure team to support the system operation between cloud and on-premises IT network infrastructure.`,
        //     c96: `Derive a continuous improvement program to review all internal and external cloud operation, validate industry best practices to automate operational and security tasks and implement enterprise-grade, cloud management and governance tools.`,
        //     c97: `Lead and operationally support the operations of all products and services deployed on the AWS platform.`,
        //     c98: `Automate the proactive monitoring and statistic reporting capabilities to support operational response and maintenance.`,
        //     c99: `Conduct capacity planning to forecast resource acquisition, maintain infrastructure availability and ensure sustainable cost.`,
        //     c100: `Engage in all project planning, management, and development of cloud related tasks, include supporting all integration requirements with the company on-premises IT network infrastructures.`,
        //     c10: `Requirements:`,
        //     c11: `Degree or Diploma in Information Technology/Science/Computer Science/Engineering or related technical area of study.`,
        //     c12: `Relevant certifications in ITIL, Microsoft, Cloud, Network will be highly regarded.`,
        //     c13: `At least 7 years of experience in infrastructure support (network, server, EUC), with prior team lead experience`,
        //     c14: `At least 3 years of practical experience in architecture, design, provision, and administration of workload on public Cloud in AWS, Azure or Google.`,
        //     c15: `Strong understanding of financial services regulations and framework related to IT.`,
        //     c16: `Strong knowledge in Virtualisation technologies (VMWare, HyperV), cloud services (AWS, Microsoft Azure, Office 365)`,
        //     c17: `Knowledge in networking protocols, IT security technologies will be highly regarded.`,
        //     c18: `Must have hands-on experience working on AWS cloud services such as multi-account strategy, landing zone setup operation, strategize compute and network services, integrated-tiered security, role-based identity, data and storage management, encryption technology and compliance services.`,
        //     c19: `Knowledge with practical hands-on experience in deploying and optimizing the use of management and governance tools within AWS Cloud Platform.`,
        //     c20: `Knowledge with practical hands-on experience in deploying and optimizing the use of Cloud Formation or equivalent automation tools in AWS operation.`,
        //     c21: `Knowledge and experience of deploying and administration of MySQL and PostgreSQL databases in AWS EC2 and RDS will be an advantage.`,
        //     c22: `Certification in AWS platform will be an advantage, AWS Certified Solution Architect Associate, AWS Certified SysOps Administrator and others.`,
        //     c23: `Familiar with Linux OS, Java, Docker, Kubernetes, and others is a plus.`,
        //     c24: `Experience in securities exchange, derivatives trading, cryptocurrencies and blockchain would be an added advantage.`,
        //     c101: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
        //     c102: `Able to communicate effectively in both English and Mandarin.`,
        //     c103: `Must have good interpersonal communication skills (written and oral).`,
        //     c104: `Highly analytical and able to work independently.`,
        //     c105: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player.`,
        //     c106: `A team player that collaborates well with other departments.`,
        //     c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` jingwen.pou@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        // m13: {
        //     c1: `IT HELPDESK SPECIALIST`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: `As a Technology Operation Specialist, you will work in the TechOps Operation Centre, collaborating with other business units to monitor and support the day-to-day health activities and service uptime of the organization’s IT systems, by providing IT helpdesk, service desk operation and customer support services.`,
        //     c4: `You will manage end users’ escalations, resolving user issues, and monitoring the performance of business-critical systems to prevent delays, outages and quickly resolve ongoing issues with internal and external parties.`,
        //     c41: `Our ideal candidate should have excellent organizational skills and could handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and have a can-do mind-set.`,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Perform 24-hours real-time monitoring shift schedule on organization’s business application, core systems and networks.`,
        //     c7: `Provide direct user support by handling help desk or service desk escalations, collaborate within team or units to assess the situation, support a solution to the problem, and coordinate with external service providers, where necessary.`,
        //     c8: `Assess helpdesk inquiries, execute ITSM workflow, take ownership as the escalation point of contact to support, resolve end users’ issues and assist in all IT systems project’s directives towards ticket closure.`,
        //     c9: `Assist to create policies and procedures to ensure that the department operates effectively and reliably, including the developing of technical knowledge base and service level agreements (SLAs) for the help desk, service desk and customer support services.`,
        //     c91: `Develop, maintain and update all relevant documentation (SOPs, case tickets, etc.) for continuous improvements of CTX operations.`,
        //     c92: `Manage and analyze data logs, prepare reports and technical documentation to maintain operation efficiency and support areas for improvement.`,
        //     c10: `Requirements:`,
        //     c42: `He/she will adhere to department policy, and dutifully carry out day-to-day user support under the assigned rostered shift system. The team is looking for candidate possessing the following:`,
        //     c11: `Minimum Diploma in any IT related discipline.`,
        //     c12: `Have years of IT experience in computer software and hardware, including operating system and basic network to successfully perform IT helpdesk functions.`,
        //     c13: `Have years of practical operation experience in a NOC/SOC, including good understanding of ITSM workflow, documentation and processes to develop and implement policies and procedures for the department.`,
        //     c14: `Have good technical knowledge, exhibit confidence and practical competency in problem-solving, directly addressing customer and end-user issues in a time sensitive environment.`,
        //     c15: `A strong written and verbal communicator, able to communicate with team members, management personnel, end users throughout the organization, manage partners and vendors for timely deliverables.`,
        //     c16: `Take ownership and responsibility to promote productivity within team members, and effective collaboration with set department priorities.`,
        //     c17: `Familiarity with Windows, Linux, Microsoft Office tools, and basic Cloud services (AWS).`,
        //     c18: `Familiarity with Nagios, Jira, Grafana, AWS CloudWatch, Git lab and Jenkins is an advantage.`,
        //     c19: `Knowledge on ITIL/ISO20001 and ITSM is an advantage.`,
        //     c20: `Good team spirit, meticulous workmanship, independent and self-discipline.`,
        //     c21: ``,
        //     c22: ``,
        //     c23: ``,
        //     c24: ``,
        //     c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` jingwen.pou@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        // m14: {
        //     c1: `OPERATIONS ASSOCIATE`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: `CTX requires a high caliber professional to be responsible for the discharge of all aspects of CTX’s operations, and regulatory compliance thereof. All Ops functions including Client onboarding, STO issuance, Trading & Custody Operations, Market Surveillance & AML monitoring, and Ops Reporting.`,
        //     c4: `Our ideal candidate should have excellent organizational skills and can handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset.`,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Work with the rest of Operations to ensure that the day-to-day CTX operations is working smoothly, to support the business and meet regulatory compliance/reporting requirements.`,
        //     c7: `Maintain operational stability and excellence in all of CTX’s operations including client onboarding, digital asset/securities token issuance, trading and custody, market surveillance & AML monitoring, and Ops reporting.`,
        //     c8: `Identify and communicate operational issues and opportunities through engagement with the Head of Ops, good understanding of trade processes, operational controls, and regulatory requirements.`,
        //     c9: `Maintain operations checklist and exception logs. Resolve or escalate operational breaks on a timely basis.`,
        //     c91: `Be conversant with all operations policies and procedures, and NASDAQ systems/manuals relating to operations.`,
        //     c92: `Ensure daily reports are prepared timely and accurately.`,
        //     c93: `Ensure client onboarding/ongoing review meets AML/KYC policy and procedure.`,
        //     c94: `Ensure the best use of technology in operations, and business continuity/crisis management plans are in place and tested to work successfully.`,
        //     c95: `Ensure all client trading instructions are executed appropriately by the NASDAQ system and Ops team, and any exceptions, client feedback or complaints are dealt with or escalated appropriately.`,
        //     c96: `Ensure proper segregation of client vs house assets and integrity of data between operational and financial systems.`,
        //     c97: `Assist the Head of Ops with other ad-hoc tasks or projects from time to time.`,
        //     c98: `Model and reinforce ethical behavior in self and others in accordance to the Company SOPs, adhere to organizational policies and guidelines, support compliance initiatives, maintain confidences, admit mistakes, conduct business with honesty, show consistency in words and actions, and follow through on commitments.`,
        //     c10: `Requirements:`,
        //     c11: `Bachelor’s Degree or Diploma in any discipline with approximately 5 years of relevant experience.`,
        //     c12: `Bilingual, excellent oral and written communication skills.`,
        //     c13: `A hands-on individual as this is an individual contributor role.`,
        //     c14: `Exposure to trading operations in financial institutions or fintech companies will be useful but not necessary.`,
        //     c15: `Be familiar with regulatory requirements from MAS pertaining to day-to-day operations (e.g., AML/KYC, unusual or suspicious transaction reporting).`,
        //     c16: `Self-motivated and result-oriented with good analytical, problem-solving, presentation and communication skills.`,
        //     c17: `Adaptable, resilient, and detailed-oriented.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` huiwen.teo@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        m15: {
            c1: `VICE PRESIDENT, INSTITUTIONAL SALES`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary
            Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded
            in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including
            primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX
            aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for
            both issuers and investors.`,
            c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal
            traits include ability to navigate through the emerging space, be a team player, able to work effectively and
            collaborate with colleagues across the firm.`,
            c4: ``,
            c5: `Roles and Responsibilities:`,
            c6: `Actively approach and pitch existing and potential clients with emerging digital products that meet their
            investment requirements.
            `,
            c7: `Work closely with clients, to enhance working relationships and ensure the client’s needs are met.`,
            c8: `Work to broaden relationships with institutional investors in Singapore and elsewhere.`,
            c9: `Work closely with other departments on client related matters and assist in any ad-hoc projects as required.`,
            c91: `Serve as the primary day to day contact for all relationship activities, including daily ad hoc enquiries and in-depth search of information regarding portfolios and operational related requests.`,
            c92: `Responding to any enquiries by clients and ensuring the quality and accuracy of both regular and ad
            hoc reports to be delivered to clients.`,
            c93: `Liaise and establish strong relationship with other departments for the on-boarding process of clients
            and ensure client reporting needs are met.`,
            c94: `Provide proactive support and communication to clients with respect to product performance, attributes
            and developments`,
            c95: `Arrange and coordinate client portfolio meetings to review investment guidelines, objectives and
            process.`,
            c96: `Ensure client documentation is updated accordingly and internal monitoring is feasible.`,
            c10: `Requirements:`,
            c11: `A university degree or higher with 5-8 years of relevant experience.`,
            c12: `Proven track record in business development, sales and building a portfolio of clients within the Financial
            Institution industry.`,
            c13: `Bilingual, excellent oral and written communication skills`,
            c14: `MAS representative license
            `,
            c15: `Possess solid experience in buy & sell side environment.`,
            c16: `Ability to build the trust and confidence of clients, ability to strengthen client relationships through
            ongoing dialog and interactions, ability to work well with others to accomplish client objectives.`,
            c17: `Self-starter, resourceful, able to work independently and in a small team environment.`,
            c18: `Demonstrated history of being results-oriented, able to work under pressure, and organized.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` huiwen.teo@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        m16: {
            c1: `INSTITUTIONAL SALES ASSOCIATE`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary
            Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded
            in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including
            primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX
            aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for
            both issuers and investors.
            `,
            c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal
            traits include ability to navigate through the emerging space, be a team player, able to work effectively and
            collaborate with colleagues across the firm.
            `,
            c4: ``,
            c5: `Roles and Responsibilities:`,
            c6: `Actively approach and pitch existing and potential clients with emerging digital products that meet their
            investment requirements.
            `,
            c7: `Work closely with clients, to enhance working relationships and ensure the client’s needs are met.`,
            c8: `Work to broaden relationships with institutional investors in Singapore and elsewhere.`,
            c9: `Work closely with other departments on client related matters and assist in any ad-hoc projects as
            required.`,
            c91: `Serve as the primary day to day contact for all relationship activities, including daily ad hoc enquiries
            and in-depth search of information regarding portfolios and operational related requests.`,
            c92: `Responding to any enquiries by clients and ensuring the quality and accuracy of both regular and ad
            hoc reports to be delivered to clients.`,
            c93: `Liaise and establish strong relationship with other departments for the on-boarding process of clients
            and ensure client reporting needs are met.`,
            c94: `Provide proactive support and communication to clients with respect to product performance, attributes
            and developments.`,
            c95: `Arrange and coordinate client portfolio meetings to review investment guidelines, objectives and
            process.`,
            c96: `Ensure client documentation is updated accordingly and internal monitoring is feasible.`,
            c10: `Requirements:`,
            c11: `A university degree or higher with 3 - 5 years of relevant experience.`,
            c12: `Proven track record in business development and sales within the Financial Institution industry. `,
            c13: `Bilingual, excellent oral and written communication skills. `,
            c14: `MAS representative license`,
            c15: `Possess solid experience in buy & sell side environment.`,
            c16: `Ability to build the trust and confidence of clients, ability to strengthen client relationships through
            ongoing dialog and interactions, ability to work well with others to accomplish client objectives.`,
            c17: `Self-starter, resourceful, able to work independently and in a small team environment.`,
            c18: `Demonstrated history of being results-oriented, able to work under pressure, and organized.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` huiwen.teo@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        // m17: {
        //     c1: `LEGAL ASSOCIATE`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: `We are looking for a professional individual who is capable to ensure the company complies with statutory and corporate governance practices and guidelines as observed in the financial industry.`,
        //     c4: ``,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Responsible for updating and overseeing on all legal matters, commercial contracts, and agreements.`,
        //     c7: `Negotiation/drafting/reviewing and advising on all legal agreements.`,
        //     c8: `Work with external legal counsel.`,
        //     c9: `Keep updated of developments in the Financial Services Regulatory space`,
        //     c91: `Any other ad-hoc duties as may be assigned.`,
        //     c10: `Requirements:`,
        //     c11: `Bachelor’s degree in Law with at least 5 years of working experience.`,
        //     c12: `Bilingual in English and Chinese.`,
        //     c13: `Familiar with Singapore Securities and Futures Act, and other relevant regulatory rules and regulations.`,
        //     c14: `Experience in interacting with regulators would be advantages.`,
        //     c15: `Outstanding people skills and able to work well across the organization, good interpersonal and communication skills with a positive attitude and take ownership in the roles and projects.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` huiwen.teo@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        // m18: {
        //     c1: `VICE PRESIDENT, FINANCE`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based CTX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
        //     c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal traits include ability to navigate through the emerging space, be a team player, able to work effectively and collaborate with colleagues across the firm.`,
        //     c4: ``,
        //     c5: `Roles and Responsibilities:`,
        //     c6: `Lead and supervise the finance team and oversee all aspects related to finance and accounting to ensure smooth business operations.`,
        //     c7: `Manage financial planning, policies, processing, forecasting and budgets.`,
        //     c8: `Regular review and implementation of internal controls and changes to accounting systems and processes to ensure front to back processing is accurate and complete.`,
        //     c9: `Review monthly financial and regulatory reports, profit and cash flow projections, and financial analysis.`,
        //     c91: `Support various audits, inspections and tax submissions as per regulatory requirements.`,
        //     c92: `Coordination with the senior management with regards to the development of annual revenue and cost budgets`,
        //     c93: `Preparation and review of relevant MAS reports for licensed entities.`,
        //     c10: `Requirements:`,
        //     c11: `Degree in Finance, Accountancy or related disciplines`,
        //     c12: `8 years of working experience with at least 5 years of leadership experience in Finance, preferably at a financial institution.`,
        //     c13: `Display sound knowledge of relevant regulations, laws and accounting standards and taxation rules.`,
        //     c14: `Familiarity with relevant MAS rules and regulations, notices and guidelines for licensed entities.`,
        //     c15: `Able to communicate effectively with various stakeholders including team members and senior management.`,
        //     c16: `Professional and possess strong organizational skills with high attention to detail.`,
        //     c25: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
        //     c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
        //     c27: `Corporate Office Department`,
        //     c28: `Cyberdyne Tech Exchange Pte Ltd`,
        //     c29: ` huiwen.teo@ctx.sg`,
        //     c30: `We regret that only shortlisted candidates will be notified.`,
        // },
        m19: {
            c1: `CUSTOMER SERVICE SPECIALIST`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary
            Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies.
            Founded in 2018, it provides qualified asset owners and institutional investors with a full-service
            infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed
            tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to
            incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have excellent organizational skills and can handle sensitive information
            confidentially. Desired personal traits include strong people skills, be collaborative and a can-do
            mindset.`,
            c4: ``,
            c5: `Roles and Responsibilities:`,
            c6: `Deliver personalized service over the telephone to customers in call centre on in an effective
            and efficient manner.`,
            c7: `Ability to understand customers’ needs and provide appropriate solutions and attention.`,
            c8: `Consistently deliver excellent quality service to our customers to achieve total customer
            satisfaction.`,
            c9: `To adhere to professional standards of behaviour & conduct in dealing with customers.`,
            c91: `Solicit customers’ feedback and identify problem trends for improvement actions.`,
            c92: `Follow up promptly with customers to resolve issues.`,
            c10: `Requirements:`,
            c11: `A Level or diploma in any discipline.`,
            c12: `Fresh graduates are welcome to apply.`,
            c13: `Experience in customer support or similar client service role will be advantages.`,
            c14: `Familiarity with the financial industry in a call centre environment is a plus.
            `,
            c15: `Has passion for customer service`,
            c16: `Able to work in a fast-paced and demanding environment.`,
            c17: `Excellent bilingual communication and problem-solving skills.`,
            c18: `Comfortable to work rotating shift hours including weekends and public holidays, if required.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` huiwen.teo@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        m20: {
            c1: `CUSTOMER SERVICE MANAGER`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have excellent organizational skills and can handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset.`,
            c4: ``,
            c5: `Roles and Responsibilities:`,
            c6: `Deliver personalized service over the telephone to customers in call centre on in an effective and efficient manner.`,
            c7: `Ability to understand customers’ needs and provide appropriate solutions and attention.`,
            c8: `Consistently deliver excellent quality service to our customers to achieve total customer satisfaction.`,
            c9: `To adhere to professional standards of behaviour & conduct in dealing with customers.`,
            c91: `Solicit customers’ feedback and identify problem trends for improvement actions.`,
            c92: `Follow up promptly with customers to resolve issues.`,
            c10: `Requirements:`,
            c11: `Bachelor’s Degree or Diploma in any discipline with approximately 5 years of relevant experience.`,
            c12: `Experience as a Customer Support Manager or similar client service role.`,
            c13: `Familiarity with the financial industry in a call centre environment is a plus.`,
            c14: `Has passion for customer service.`,
            c15: `Hands-on and able to work in a fast-paced and demanding environment.`,
            c16: `Excellent bilingual communication and problem-solving skills.`,
            c17: `Comfortable to work rotating shift hours including weekends and public holidays, if required.`,
            c26: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to:`,
            c27: `Corporate Office Department`,
            c28: `Cyberdyne Tech Exchange Pte Ltd`,
            c29: ` huiwen.teo@mvgx.com`,
            c30: `We regret that only shortlisted candidates will be notified.`,
        },
        m21: {
            c1: `DEPUTY DIRECTOR / DIRECTOR, IT SECURITY`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have excellent organizational skills and could handle sensitive information confidentially. Desired personal traits include strong people skills, be collaborative and a can-do mindset.`,
            c4: `Roles and Responsibilities: `,
            c5: `Lead and managed the team in implementation of IT security architecture and platforms in a cloud environment which may include access control solutions, identity and access management platforms, data protection technologies, anti-malware, vulnerability management, security monitoring and compliance tools. `,
            c6: `Lead the development and maintenance of enterprise IT security policies, standards, methodologies and best practices for security management to ensure IT systems are designed with due considerations for security. `,
            c7: `Lead and manage corporate IT compliance and IT risk assessments.`,
            c8: `Conduct regular security analysis such as penetration and platform security vulnerability scanning to prevent internal and external security incidents and attacks. `,
            c9: `Perform security review of cloud environment and IT systems to ensure compliance with MAS policies and standards. `,
            c10: `Lead in responses to law or regulatory bodies like MAS or PDPC with regards to cyber security controls.`,
            c11: `Lead in the responses to cyber incidents and assist in remediation efforts in a 24x7x365 mode of operation. `,
            c12: `Stay current on the latest threats and vulnerabilities to ensure the cyber defences and processes of the organisation are up to date. `,
            c13: `Requirements: `,
            c14: `Degree or Diploma in Information Technology/Science/Computer Science/Engineering or related technical area of study. `,
            c15: `Minimum 7 years of working experience in cyber security and risks in cloud ecosystems like AWS.`,
            c16: `Minimum 3 years of practical experience in architecture, design, provision and administration of IT security devices and appliances.`,
            c17: `Strong technical skills, which may include experience with Linux and Windows operating systems, scripting languages like Python, and cloud ecosystems like AWS.`,
            c18: `Knowledge in networking protocols, IT security technologies will be highly regarded`,
            c19: `Strong understanding of financial services regulations and framework related to IT`,
            c20: `Relevant certifications in cloud, networking or cyber security, e.g. AWS, CISSP, CISM, CISA preferred.`,
            c21: `Knowledge of DevOps techniques and Agile practices preferred.`,
            c22: `Experience in securities exchange, derivatives trading, cryptocurrencies and blockchain would be an added advantage.`,
            c23: `Excellent bilingual communication.`,
            c24: `Must have good interpersonal communication skills (written and oral).`,
            c25: `Highly analytical and able to work independently.`,
            c26: `A fast learner, passionate about technology, processes a positive attitude, diligent and good team player. `,
            c27: `Good strategic thinking, quantitative analysis, collaboration, problem solving, judgment, decision-making skills.`,
            c28: `A team player that collaborates well with other departments.`,
            c29: `If you are looking to be part of an exciting team within the financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.   `,
            c30: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to :`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  jingwen.pou@mvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        // m22: {
        //     c1: `CORPORATE COMMUNICATIONS MANAGER/DIRECTOR`,
        //     c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary
        //     Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies.
        //     Founded in 2018, it provides qualified asset owners and institutional investors with a full-service
        //     infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed
        //     tokens. Singapore-based CTX aims to be a global hub for green financing and will be the first exchange
        //     to incorporate carbon disclosures for both issuers and investors. `,
        //     c3: `Our ideal candidate should possess the ability to manage sensitive information and actively oversee
        //     and contribute to the planning, development, and implementation phases of all marketing
        //     communications matters and public relations activities in accordance with the company’s direction and
        //     policies. The candidate shall play an important role to build and raise the company’s profile, brand, and
        //     affinity with our customers.`,
        //     c4: `Roles and Responsibilities: `,
        //     c5: `Responsible for all marketing and communications activities including but not limited to digital
        //     and social media marketing, corporate branding, product launches, creative campaigns,
        //     media relations, and publicity events.
        //     `,
        //     c6: `Provide communications counsel to senior management`,
        //     c7: `Partner both internal and external stakeholders to develop and implement strategic media
        //     engagement plans`,
        //     c8: `Oversee outreach channels, including corporate website, eDMs, and social media platforms,
        //     to grow visibility and cultivate positive awareness of CTX’s brand. `,
        //     c9: `Manage the annual budget for all marketing communications matters and public relations
        //     activities. `,
        //     c10: `Ensure articulation of CTX’s desired image and position to both internal and external
        //     stakeholders.`,
        //     c11: `Collaborate with external partners, such as creative and media agencies, to ensure timely
        //     delivery of effective results and positive performances.`,
        //     c12: `Stay abreast of the latest digital technology and financial services trends.`,
        //     c13: `Requirements: `,
        //     c14: `Degree in Communications, Marketing, or a relevant degree with a minimum of 5 years of
        //     relevant working experience `,
        //     c15: `Proven track record in public relations firm and/or media company, financial institutions,
        //     and/or international economic organization is a plus. `,
        //     c16: `Possesses strong relationships with media sector`,
        //     c17: `Bilingual with an excellent command of oral and written communications skills.`,
        //     c18: `Possesses good strategic, analytical, organisational, and interpersonal skills.`,
        //     c19: `Demonstrates experience and expertise in writing, editing, proof-reading marketing and
        //     communications materials`,
        //     c20: `Creative, meticulous, and resourceful, with an innate passion to drive innovation and brand
        //     growth.`,
        //     c21: `Proven abilities in creative digital marketing strategy, with experience planning and/or speaking
        //     at local events.`,
        //     c22: `Results-oriented, diligent and a collaborative team member who is able to concurrently
        //     manage several projects with multiple stakeholders within tight timelines.`,
        //     c29: `If you are looking to be part of an exciting team within the financial technology industry, we would like
        //     to hear from you. Remuneration will commensurate with experience and qualifications.
        //     `,
        //     c30: `Interested candidates are requested to write in with your detailed resume including current and expected remuneration, and contact numbers to :`,
        //     c31: `Corporate Office Department`,
        //     c32: `Cyberdyne Tech Exchange Pte Ltd  `,
        //     c33: `  huiwen.teo@ctx.sg`,
        //     c34: `We regret that only shortlisted candidates will be notified.`,
        // },
        m23: {
            c1: `EXECUTIVE ASSISTANT`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded  in  2018,  it  provides  qualified  asset  owners  and  institutional  investors  with  a  full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be aglobal hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `We are looking for a professional individual who is passionate about creating a nourishing workplace, to  provide  support to  the  CEO and  office  administration  areas.  You  will  perform  a  variety  of office administrative tasks and will act as the first point of contact for related queries from CEO and external parties.`,
            c4: `Roles and Responsibilities: `,
            c5: `Reportdirectly to the CEO and provides executive support in a one-on-one working relationship.`,
            c6: `Managing an active calendar of appointments; completing reports, composing and preparing correspondence; arranging complex and detailed travel plans, itineraries and agendas, etc.`,
            c7: `Perform common office administrative tasks.`,
            c8: `Any other ad-hoc duties as may be assigned.`,
            c13: `Requirements: `,
            c14: `Bachelor’s degree in Administration/Business  Management  or  any  related  discipline  with  at least 5 years of relevant working experience.`,
            c15: `Strong experience as an Executive Assistant and Office Manager with organizations within the law, public accountancy, major accounting, consultancy firms, banking & finance, legal and/or recruitment sector would be advantageous.`,
            c16: `Proficient with Microsoft Office Applications (Word, Excel, and PowerPoint).`,
            c17: `Skilled in preparation of PowerPoint presentation slides would be advantages.`,
            c18: `Excellent bilingual communication,organizational and time management skills.`,
            c19: `Outstanding people skills and able to work well across the organization, good interpersonal and communication skills with a positive attitude and take ownership in the roles and projects.`,
            c29: `If you are looking to be part of an engaging team in the new financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c30: `Interested candidates are requested to send in your detailed resume including contact numbers to:`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  huiwen.teo@mvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        m24: {
            c1: `SENIOR HR EXECUTIVE / HR EXECUTIVE`,
            c2: `Cyberdyne Tech Exchange (CTX) is a digital green exchange licensed and regulated by the Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance  technologies. Founded  in  2018,  it  provides  qualified  asset  owners  and  institutional  investors  with  a  full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `We are looking for a professional individual who is passionate about creating a nourishing workplace, to provide support in all human resources and office administration areas. You will perform a variety of human resources, personnel and office administrative tasks and will act as the first point of contact for related queries from employees and external parties.`,
            c4: `Roles and Responsibilities: `,
            c5: `Be responsible for talent management, performance review, compensation & benefits, day to day human resource operationsand learning &development.`,
            c6: `Support end to end recruitment cycle from sourcing to arranging for interviews.`,
            c7: `Provide support in day-to-day HR Operations such as on-boarding / off-boarding of employees, maintaining of personnel records, application for government grants, claims and work passes.`,
            c8: `Coordinate external training program with various organisations.`,
            c81: `Maintain HR documents and forms like employment contracts, employee handbooks, and HR policies and procedures.`,
            c82: `Knowledgeable in Singapore employment act.`,
            c83: `Perform common office administrative tasks.`,
            c84: `Liaise with external partners such as universities, government organizations and vendors.`,
            c85: `Maintains a positive and friendly company image by acting as the first line of contact for related queries from employees and to external parties.`,
            c86: `Any other ad-hoc duties as may be assigned.`,
            c13: `Requirements: `,
            c14: `Bachelor’s degree in any  relevant discipline  with minimum 3  years of  relevant  working experience.`,
            c15: `Prior relevant experience within banking & financial institutions and/or fintech sectors would be advantageous.`,
            c16: `Proficient with Microsoft Office Applications (Word, Excel, and PowerPoint).`,
            c17: `Excellent organizational and time management skills.`,
            c18: `Strong  analytical,  interpersonal  and  communication  skills  with  a  positive  attitude  and  take ownership in the roles and projects.`,
            c29: `If you are looking to be part of an engaging team in the new financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c30: `Interested candidates are requested to send in your detailed resume including contact numbers to:`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  jingwen.pou@mvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        m25: {
            c1: `TALENT ACQUISITION EXECUTIVE`,
            c2: `Cyberdyne  Tech  Exchange  (CTX)  is  a  digital  green  exchange  licensed  and  regulated  by  the  Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be a global hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal traits include ability to navigate through the emerging space, be a team player, able to work effectively and collaborate with colleagues across the firm.`,
            c4: `Roles and Responsibilities: `,
            c5: `Primarily  in  charge  of  talent  acquisition,  while  actively  partner with business  units  for  their  talent requirements.`,
            c6: `Manage all aspects of recruitment, including reviewing job descriptions, posting job advertisement, sourcing, screening, scheduling interviews, conducting interviews to offering and on-boarding of new hires.`,
            c7: `Enhance the hiring experience and onboarding journey from candidate to employee.`,
            c8: `Partner closely with the operations functions to understand their requirements and recruitment needs.`,
            c81: `Be abreast with latest recruitment channels and strategies in an effort to improve the hiring success rate for the positions you are responsible for, embedding best practices within the team and expanding the sourcing channels in use.`,
            c82: `Ensure compliance to employment act and other legal requirement.`,
            c13: `Requirements: `,
            c14: `Degree/Diploma in any discipline or equivalent with min 3 years relevant experience.`,
            c15: `Proven track record,sound sourcing approach with ability to dive deep into searches for hard-to-fill positions.`,
            c16: `Must be able to multi-task and bring tasks through to completion with minimal supervision.`,
            c17: `Good interpersonal and stakeholder management skills.`,
            c18: `Excellent computing skills using Microsoft office.`,
            c181: `Good understanding of labour regulations.`,
            c182: `Have a strong affinity for critical thinking, with continuous improvement mindset, hands-on execution, problem-solving, and result orientation.`,
            c183: `Able to communicate effectively with various stakeholders including team members and senior management.`,
            c184: `Professional and possess strong organizational skills with high attention to detail.`,
            c29: `If you are looking to be part of an engaging team in the new financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c30: `Interested candidates are requested to send in your detailed resume including contact numbers to:`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  jingwen.pou@cmvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        m26: {
            c1: `FINANCE EXECUTIVE`,
            c2: `Cyberdyne  Tech  Exchange  (CTX)  is  a  digital  green  exchange  licensed  and  regulated  by  the  Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be aglobal hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal traits include ability to navigate through the emerging space, be a team player, able to work effectively and collaborate with colleagues across the firm.`,
            c4: `Roles and Responsibilities: `,
            c5: `Support the full spectrum of financial and accounting needs.`,
            c6: `Maintain an accurate record of financial transactions, including account reconciliation.`,
            c7: `Update and maintain the general ledger, including preparation of journal entries.`,
            c8: `Handle the Accounts Payable & Accounts Receivable functions.`,
            c81: `Prepare Cash flow projection and forecast reports and supports the budgeting process. Monitor any variances from the projected budget.`,
            c82: `Ensure timely and accurate month-end closing activities, ie. bank reconciliation etc.`,
            c83: `Other ad-hoc tasksasassigned by your supervisor.`,
            c13: `Requirements: `,
            c14: `Diploma in LCCI accounting or from a Polytechnic, or equivalent.`,
            c15: `At least 3 years of experience in Finance, preferably at a financial institution or accounting & audit firm.`,
            c16: `Strong accounting knowledge and data entry skills.`,
            c17: `Proficiency in MS Excel.`,
            c18: `Able to produce work with high accuracy.`,
            c181: `Professional and possess strong organizational skills, and able to communicate well.`,
            c182: `Able to work independently with minimal supervision, as well as being a team player.`,
            c183: `Able to displayhigh attention to detail.`,
            c29: `If you are looking to be part of an engaging team in the new financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c30: `Interested candidates are requested to send in your detailed resume including contact numbers to:`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  lynn.tan@mvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        m27: {
            c1: `FINANCE MANAGER`,
            c2: `Cyberdyne  Tech  Exchange  (CTX)  is  a  digital  green  exchange  licensed  and  regulated  by  the  Monetary Authority of Singapore and powered by Nasdaq’s advanced trading and surveillance technologies. Founded in 2018, it provides qualified asset owners and institutional investors with a full-service infrastructure including primary issuance, secondary trading, settlement, and custody of asset-backed tokens. Singapore-based MVGX aims to be aglobal hub for green financing and will the first exchange to incorporate carbon disclosures for both issuers and investors.`,
            c3: `Our ideal candidate should have the ability to handle sensitive information confidentially. Desired personal traits include ability to navigate through the emerging space, be a team player, able to work effectively and collaborate with colleagues across the firm.`,
            c4: `Roles and Responsibilities: `,
            c5: `Manage full accounting operations to ensure smooth business operations.`,
            c6: `Prepare monthly  financial  and  regulatory  reports,  profit  and  cash  flow  projections,  and  financial analysis.`,
            c7: `Manage financial planning, policies, processing, forecasting and budgets.`,
            c8: `Preparation and review of relevant MAS reports for licensed entities.`,
            c81: `Review & implementation of internal controls, and manage the in-house internal control system.`,
            c82: `Manage changes to accounting systems and processesto ensure front to back processing is accurate and complete.`,
            c83: `Support various audits, inspections and tax submissionsas per regulatory requirements.`,
            c13: `Requirements: `,
            c14: `Degree in Accountancy or related disciplines.`,
            c15: `5 - 8  years  of  working  experience  with  at  least 3 years  of  experiencein  Finance,  preferably  at  a financial institution or accounting & audit firm.`,
            c16: `Strong knowledge of accounting standards,principles and procedures.`,
            c17: `Experience   with   full   set   entity   accounting   and   preparation   of   financial   statement,   including consolidation.`,
            c18: `Experience with MAS reporting.`,
            c181: `Experience with full audit procedure.`,
            c182: `Experience  with  project management,  system  implementation(preferably NetSuite)and  UAT process.`,
            c183: `Display sound knowledge of relevant regulations, laws and taxation rules.`,
            c184: `Able  to  communicate  effectively  with  various  stakeholders  including  team  members  and  senior management.`,
            c185: `Professional and possess strong organizational skills with high attention to detail.`,
            c186: `Independent, pro-active with effective problem-solving skills.`,
            c29: `If you are looking to be part of an engaging team in the new financial technology industry, we would like to hear from you. Remuneration will be commensurate with experience and qualifications.`,
            c30: `Interested candidates are requested to send in your detailed resume including contact numbers to:`,
            c31: `Corporate Office Department`,
            c32: `Cyberdyne Tech Exchange Pte Ltd  `,
            c33: `  eva.ang@mvgx.com`,
            c34: `We regret that only shortlisted candidates will be notified.`,
        },
        m28: {
            c1: `免责声明`,
            c2: `本免责声明适用于所有Cyberdyne Tech Services Pte. Ltd.（CTS）的用户和/或任何访问 CTS 网站的人。`,
            c3: `风险提示：`,
            c4: `应新加坡金融管理局（MAS）要求，作为数码支付代币（DPT）服务提供商，我们有义务向用户进行此风险提示。`,
            c5: `在您向CTS支付任何资金或数码支付代币之前，您应注意如下内容：`,
            c6: `（a）       CTS已获得新加坡金融管理（MAS）豁免，持牌提供数码支付代币服务。请注意，如果CTS遭遇商业失败，您可能无法收回支付给CTS的资金或数码支付代币。`,
            c7: `（b）       如果您不熟悉数码支付代币，您不应该进行此交易；如果您不熟悉数码支付代币服务商提供的技术，您不适合进行数码支付代币交易。`,
            c8: `（c）       您应明确知晓数码支付代币的价值存在巨大波动。只有当您做好能够承担损失所有您支付的数码支付代币时，您才应该购买数码支付代币。`,
            c9: `区域限制：`,
            c10: `CTS 提供的任何数码支付代币服务及CTS网站内容均受到限制，不能直接或间接被任何中国实体及中国居民（如下文所定义）或任何其他受限制的司法管辖区的用户（如果相关服务违反了此司法管辖区的法律法规）访问、传播或提供。“中国实体”是指在中华人民共和国注册成立的任何公司或实体，“中国居民”是指所有居住在中华人民共和国的中国公民和/或将用于为其在CTS的账户注资或在CTS交易提供资金的资产位于中华人民共和国境内的个人。`,
            c11: `您有责任确保自己严格遵守相关法律和法规的要求。您必须同意不误导CTS，也不故意从事任何可能构成违反您所在司法管辖区相关法律法规的活动。`,
            c12: `当您接受CTS提供的任何数码支付代币服务和/或访问CTS网站时，即表明您已仔细阅读并充分理解本声明，且同意接受本声明条款的约束，包括以下内容：`,
            c13: `（a）      您理解并同意遵守本声明所列条款的限制；`,
            c14: `（b）      您确认，您不是中国实体、中国居民或居住在受限制的司法管辖区的用户，并且不代表任何此类实体或个人行事；和`,
            c15: `（c）        您理解并同意，如果CTS认为提供给您的访问、权限和服务违反了任何受限制司法管辖区的相关法律法规时，CTS有权自行决定暂停和/或取消您的交易访问、权限和其他数码支付代币服务。`,
            c16: `本免责声明受新加坡法律管辖，并根据新加坡法律进行解释。`,
        },
    },

    nftmarket: {
        title: 'NFT市场',
        title1: '我的NFT资产',
        c1: '作品介绍',
        c2: '作品详情',
        c3: '合约地址',
        c4: '通证ID',
        c5: '区块链地址',
        c6: '编辑',
        c7: '出售',
        c8: '取消',
        c9: '持有者:',
        c10: '类别:',
        c11: '出售将在',
        c12: '天内结束',
        c13: '最小出价 - 未达到保留价格',
        c131: '最高出价 - 未达到保留价格',
        c132: '最高出价 - 达到保留价格',
        c14: '立即购买',
        c15: '出价',
        c155: '出价必须高于最低价格',
        c16: '选择付款账户',
        c17: '请选择',
        c18: '报价',
        c19: '价格',
        c20: '有效期',
        c21: '所属用户',
        c22: '取消',
        c23: '接受',
        c24: '创建报价',
        c25: '创建报价',
        c199: '美元价格',
    },

    marketsform: {
        c1: '类别:',
        c2: '在售:',
        c3: '排序方式:',
    },

    commodity: {
        title: "暂时没有商品呦～",
        nftassets: 'NFT 市场',
        c1: '描述',
        c2: '详细说明',
        c3: '联系地址',
        c4: 'Token ID',
        c5: '区块链',
        c6: '拥有',
        c7: '类别：',
        c8: '编辑',
        c9: '销售',
        c10: '认购',
        c11: '底价',
        c12: '市场经济',
        c13: '取消',
        c14: '继续',
        c16: '销售以',
        c16: '天',
        c17: '现行价格',
        c18: '现在购买',
        c19: '出价',
        c20: '提议',
        c21: '取消',
        c22: '报价',
        c23: '出价',
        c24: '报价',
        c25: '总计',
        c26: '审核中',
        c27: '审核已通过',
        c28: '审核未通过',
        c29: '提交 Contract 出错',
        c30: 'Contract 已提交',
        c31: 'Contract 提交成功',
        c32: '出售中',
    }
}